function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var Dropzone = _interopDefault(require('react-dropzone'));

var accessibleStyles = _interopDefault(require('@patternfly/patternfly/utilities/Accessibility/accessibility.css'));

var reactStyles = require('@patternfly/react-styles');

var reactTokens = require('@patternfly/react-tokens');

var reactRouter = require('react-router');

var reactVirtualized = require('react-virtualized');

var Mustache = require('mustache');

var Velocity = require('velocityjs');

require('codemirror/mode/velocity/velocity.js');

var CodeMirror = require('codemirror');

var freemarkerParser = require('freemarker-parser');

var reactCodemirror2 = require('react-codemirror2');

require('codemirror/addon/display/placeholder.js');

require('codemirror/addon/lint/lint.js');

var reactRouterDom = require('react-router-dom');

var classnames = _interopDefault(require('classnames'));

var ContentLoader = _interopDefault(require('react-content-loader'));

var patternflyReact = require('patternfly-react');

var reactCore = require('@patternfly/react-core');

var reactIcons = require('@patternfly/react-icons');

var React = require('react');
/**
 * Returns a valid DOM id from the given string
 * @param value
 */


function toValidHtmlId(value) {
  return value ? value.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase() : value || '';
}

var AboutModal =
/*@__PURE__*/
function (superclass) {
  function AboutModal(props) {
    superclass.call(this, props);
  }

  if (superclass) AboutModal.__proto__ = superclass;
  AboutModal.prototype = Object.create(superclass && superclass.prototype);
  AboutModal.prototype.constructor = AboutModal;

  AboutModal.prototype.render = function render() {
    var ref = this.props;
    var bgImg = ref.bgImg;
    var brandImg = ref.brandImg;
    var children = ref.children;
    var isModalOpen = ref.isModalOpen;
    var handleModalToggle = ref.handleModalToggle;
    var productName = ref.productName;
    var trademark = ref.trademark;
    return React.createElement(React.Fragment, null, React.createElement(reactCore.AboutModal, {
      isOpen: isModalOpen,
      onClose: handleModalToggle,
      trademark: trademark,
      brandImageSrc: brandImg,
      brandImageAlt: "Brand Image",
      productName: productName,
      backgroundImageSrc: bgImg
    }, children));
  };

  return AboutModal;
}(React.Component);

function AboutModalContent(ref) {
  var className = ref.className;
  var productName = ref.productName;
  var version = ref.version;
  var buildId = ref.buildId;
  var commitId = ref.commitId;
  var i18nBuildIdLabel = ref.i18nBuildIdLabel;
  var i18nCommitIdLabel = ref.i18nCommitIdLabel;
  return React.createElement(reactCore.TextContent, {
    className: classnames('', className)
  }, React.createElement(reactCore.TextList, {
    component: "dl"
  }, React.createElement(reactCore.TextListItem, {
    component: "dt",
    "data-testid": 'about-modal-content-product-name-list-item'
  }, productName, ":"), React.createElement(reactCore.TextListItem, {
    component: "dd",
    "data-testid": 'about-modal-content-version-list-item'
  }, version), React.createElement(reactCore.TextListItem, {
    component: "dt"
  }, i18nBuildIdLabel), React.createElement(reactCore.TextListItem, {
    component: "dd",
    "data-testid": 'about-modal-content-build-id-list-item'
  }, buildId), React.createElement(reactCore.TextListItem, {
    component: "dt"
  }, i18nCommitIdLabel), React.createElement(reactCore.TextListItem, {
    component: "dd",
    "data-testid": 'about-modal-content-commit-id-list-item'
  }, commitId)));
}

var AggregatedMetricCard =
/*@__PURE__*/
function (superclass) {
  function AggregatedMetricCard() {
    superclass.apply(this, arguments);
  }

  if (superclass) AggregatedMetricCard.__proto__ = superclass;
  AggregatedMetricCard.prototype = Object.create(superclass && superclass.prototype);
  AggregatedMetricCard.prototype.constructor = AggregatedMetricCard;

  AggregatedMetricCard.prototype.formatNumber = function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  };

  AggregatedMetricCard.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      accented: true,
      aggregated: true,
      matchHeight: true
    }, React.createElement(patternflyReact.Card.Title, null, React.createElement(patternflyReact.AggregateStatusCount, null, React.createElement("span", {
      "data-testid": 'aggregated-metric-card-total-count'
    }, this.formatNumber(this.props.total)), React.createElement("span", {
      "data-testid": 'aggregated-metric-card-title'
    }, ' ', this.props.title))), React.createElement(patternflyReact.Card.Body, null, React.createElement(patternflyReact.AggregateStatusNotifications, null, React.createElement(patternflyReact.AggregateStatusNotification, null, React.createElement(patternflyReact.Icon, {
      type: "pf",
      name: "ok"
    }), React.createElement("span", {
      "data-testid": 'aggregated-metric-card-ok-count'
    }, this.formatNumber(this.props.ok)), ' '), React.createElement(patternflyReact.AggregateStatusNotification, null, React.createElement(patternflyReact.Icon, {
      type: "pf",
      name: "error-circle-o"
    }), React.createElement("span", {
      "data-testid": 'aggregated-metric-card-error-count'
    }, this.formatNumber(this.props.error))))));
  };

  return AggregatedMetricCard;
}(React.PureComponent);

(function (ConfirmationIconType) {
  ConfirmationIconType["DANGER"] = "error-circle-o";
  ConfirmationIconType["WARNING"] = "warning-triangle-o";
  ConfirmationIconType["INFO"] = "info";
  ConfirmationIconType["OK"] = "ok";
  ConfirmationIconType["NONE"] = "NONE";
})(exports.ConfirmationIconType || (exports.ConfirmationIconType = {}));

(function (ConfirmationButtonStyle) {
  ConfirmationButtonStyle["NORMAL"] = "primary";
  ConfirmationButtonStyle["SUCCESS"] = "success";
  ConfirmationButtonStyle["DANGER"] = "danger";
  ConfirmationButtonStyle["WARNING"] = "warning";
  ConfirmationButtonStyle["INFO"] = "info";
  ConfirmationButtonStyle["LINK"] = "link";
})(exports.ConfirmationButtonStyle || (exports.ConfirmationButtonStyle = {}));
/**
 * A modal dialog to display when an object is being deleted.
 */


var ConfirmationDialog =
/*@__PURE__*/
function (superclass) {
  function ConfirmationDialog() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConfirmationDialog.__proto__ = superclass;
  ConfirmationDialog.prototype = Object.create(superclass && superclass.prototype);
  ConfirmationDialog.prototype.constructor = ConfirmationDialog;

  ConfirmationDialog.prototype.render = function render() {
    return React.createElement(patternflyReact.MessageDialog, {
      accessibleName: "deleteConfirmationDialog",
      accessibleDescription: "deleteConfirmationDialogContent",
      icon: this.props.icon !== exports.ConfirmationIconType.NONE && React.createElement(patternflyReact.Icon, {
        type: "pf",
        name: this.props.icon
      }),
      onHide: this.props.onCancel,
      primaryAction: this.props.onConfirm,
      primaryActionButtonContent: this.props.i18nConfirmButtonText,
      primaryActionButtonBsStyle: this.props.buttonStyle,
      primaryContent: React.createElement("p", {
        className: "lead"
      }, this.props.i18nConfirmationMessage),
      secondaryAction: this.props.onCancel,
      secondaryActionButtonContent: this.props.i18nCancelButtonText,
      secondaryContent: this.props.i18nDetailsMessage ? React.createElement("p", null, this.props.i18nDetailsMessage) : undefined,
      show: this.props.showDialog,
      title: this.props.i18nTitle
    });
  };

  return ConfirmationDialog;
}(React.Component);

var CopyToClipboard =
/*@__PURE__*/
function (superclass) {
  function CopyToClipboard(props) {
    superclass.call(this, props);
  }

  if (superclass) CopyToClipboard.__proto__ = superclass;
  CopyToClipboard.prototype = Object.create(superclass && superclass.prototype);
  CopyToClipboard.prototype.constructor = CopyToClipboard;

  CopyToClipboard.prototype.render = function render() {
    return React.createElement(reactCore.ClipboardCopy, null, this.props.children);
  };

  return CopyToClipboard;
}(React.Component);

var Dialog =
/*@__PURE__*/
function (superclass) {
  function Dialog() {
    superclass.apply(this, arguments);
  }

  if (superclass) Dialog.__proto__ = superclass;
  Dialog.prototype = Object.create(superclass && superclass.prototype);
  Dialog.prototype.constructor = Dialog;

  Dialog.prototype.render = function render() {
    return React.createElement(patternflyReact.MessageDialog, {
      title: this.props.title,
      primaryContent: this.props.body,
      footer: this.props.footer,
      show: true,
      onHide: this.props.onHide
    });
  };

  return Dialog;
}(React.Component);

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var Container = function Container(ref) {
  var children = ref.children;
  var className = ref.className;
  var rest = objectWithoutProperties(ref, ["children", "className"]);
  var props = rest;
  return React.createElement("div", Object.assign({
    className: classnames('container-fluid', className)
  }, props), children);
};

var WithDropzone =
/*@__PURE__*/
function (superclass) {
  function WithDropzone() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithDropzone.__proto__ = superclass;
  WithDropzone.prototype = Object.create(superclass && superclass.prototype);
  WithDropzone.prototype.constructor = WithDropzone;

  WithDropzone.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(Dropzone, {
      accept: this.props.fileExtensions,
      disabled: this.props.disableDropzone,
      multiple: this.props.allowMultiple,
      maxSize: this.props.maxSize,
      minSize: this.props.minSize,
      preventDropOnDocument: true,
      onDropAccepted: this.props.onDropAccepted,
      onDropRejected: this.props.onDropRejected
    }, function (ref) {
      var getRootProps = ref.getRootProps;
      var getInputProps = ref.getInputProps;
      return this$1.props.children({
        getRootProps: getRootProps,
        getInputProps: getInputProps
      });
    });
  };

  return WithDropzone;
}(React.Component);
/**
 * A component that can be used to upload files. Files can be uploaded by clicking in the drop zone or by
 * drag and dropping files into the drop zone.
 */


var DndFileChooser =
/*@__PURE__*/
function (superclass) {
  function DndFileChooser(props) {
    superclass.call(this, props); // set up initial state

    this.state = {
      files: [],
      notifications: []
    };
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.handleRejectedFiles = this.handleRejectedFiles.bind(this);
  }

  if (superclass) DndFileChooser.__proto__ = superclass;
  DndFileChooser.prototype = Object.create(superclass && superclass.prototype);
  DndFileChooser.prototype.constructor = DndFileChooser;
  /**
   * Obtains an element that lists the names of the files that have been uploaded.
   */

  DndFileChooser.prototype.getSelectedFileMessage = function getSelectedFileMessage() {
    // one file uploaded
    if (this.state.files.length === 1) {
      return React.createElement(React.Fragment, null, this.state.files[0].name);
    } // multiple files uploaded


    if (this.state.files.length > 1) {
      return React.createElement("ul", null, this.state.files.map(function (file, index) {
        return React.createElement("li", {
          "data-testid": "dnd-file-chooser-" + toValidHtmlId(file.name) + "-list-item",
          key: index
        }, file.name);
      }));
    } // no files uploaded


    return React.createElement(Container, null, this.props.i18nNoFileSelectedMessage);
  };
  /**
   * Obtains an element that indicates the if the upload was successful.
   */


  DndFileChooser.prototype.getUploadMessage = function getUploadMessage() {
    if (this.props.i18nUploadSuccessMessage) {
      return React.createElement(reactCore.Text, {
        component: reactCore.TextVariants.p,
        className: "dnd-file-chooser__uploadMessage"
      }, React.createElement(patternflyReact.Icon, {
        type: "pf",
        name: "ok"
      }), "\xA0", this.props.i18nUploadSuccessMessage);
    }

    if (this.props.i18nUploadFailedMessage) {
      return React.createElement(reactCore.Text, {
        component: reactCore.TextVariants.p,
        className: "dnd-file-chooser__uploadMessage"
      }, React.createElement(patternflyReact.Icon, {
        type: "pf",
        name: "error-circle-o"
      }), "\xA0", this.props.i18nUploadFailedMessage);
    }

    if (this.props.i18nUploadSuccessMessages && this.props.i18nUploadFailedMessages) {
      return React.createElement("ul", null, this.props.i18nUploadSuccessMessages.map(function (message, idx) {
        return React.createElement("li", {
          "data-testid": "dnd-file-chooser-" + toValidHtmlId(message) + "-success-message",
          key: 'success' + idx,
          className: "dnd-file-chooser__uploadMessage"
        }, React.createElement(patternflyReact.Icon, {
          type: "pf",
          name: "ok"
        }), "\xA0", message);
      }), this.props.i18nUploadFailedMessages.map(function (message, idx) {
        return React.createElement("li", {
          "data-testid": "dnd-file-chooser-" + toValidHtmlId(message) + "-failed-message-" + idx,
          key: 'fail' + idx,
          className: "dnd-file-chooser__uploadMessage"
        }, React.createElement(patternflyReact.Icon, {
          type: "pf",
          name: "error-circle-o"
        }), "\xA0", message);
      }));
    } // no message


    return React.createElement(Container, null);
  };
  /**
   * Callback for when one or more files were uploaded successfully.
   * @param acceptedFiles the files that have been uploaded
   */


  DndFileChooser.prototype.handleAcceptedFiles = function handleAcceptedFiles(acceptedFiles) {
    this.setState(Object.assign({}, this.state, {
      files: acceptedFiles
    }));
    this.props.onUploadAccepted(acceptedFiles); // notify callback
  };
  /**
   * Callback for when one or more files were rejected.
   * @param rejectedFiles the files that were rejected
   */


  DndFileChooser.prototype.handleRejectedFiles = function handleRejectedFiles(rejectedFiles) {
    var this$1 = this;
    var notifications = rejectedFiles.map(function (file) {
      return {
        key: file.name,
        message: this$1.props.onUploadRejected(file.name),
        persistent: false,
        type: 'error'
      };
    }); // If single file dropped then all files will be cleared. If multiple allowed, and multiple dropped,
    // and some are accepted and some are rejected, the accepted files will still be uploaded because the
    // handleAcceptedFiles is called after this method.

    this.setState(Object.assign({}, this.state, {
      files: [],
      notifications: this.state.notifications.concat(notifications)
    }));
  };

  DndFileChooser.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(WithDropzone, {
      fileExtensions: this.props.fileExtensions,
      disableDropzone: this.props.disableDropzone,
      allowMultiple: this.props.allowMultiple,
      onDropAccepted: this.handleAcceptedFiles,
      onDropRejected: this.handleRejectedFiles
    }, function (ref) {
      var getRootProps = ref.getRootProps;
      var getInputProps = ref.getInputProps;
      return React.createElement(reactCore.TextContent, Object.assign({
        disabled: this$1.props.disableDropzone,
        className: "dnd-file-chooser"
      }, getRootProps({
        refKey: 'dnd-file-chooser'
      })), React.createElement(reactCore.Text, {
        component: reactCore.TextVariants.p,
        className: "dnd-file-chooser__instructions",
        dangerouslySetInnerHTML: {
          __html: this$1.props.i18nInstructions
        }
      }), React.createElement("input", Object.assign({}, getInputProps())), React.createElement(reactCore.TextList, {
        component: reactCore.TextListVariants.dl,
        className: "dnd-file-chooser__selectedFileList"
      }, React.createElement(reactCore.TextListItem, {
        component: reactCore.TextListItemVariants.dt,
        className: "dnd-file-chooser__selectedFileLabel"
      }, this$1.props.i18nSelectedFileLabel), React.createElement(reactCore.TextListItem, {
        component: reactCore.TextListItemVariants.dd,
        className: "dnd-file-chooser__selectedFile"
      }, this$1.getSelectedFileMessage())), this$1.getUploadMessage(), React.createElement(reactCore.Text, {
        component: reactCore.TextVariants.small,
        className: "dnd-file-chooser__helpText"
      }, this$1.props.i18nHelpMessage));
    });
  };

  return DndFileChooser;
}(React.Component); // setup default prop values


DndFileChooser.defaultProps = {
  allowMultiple: false
};

var DefaultHeaderFormat = function DefaultHeaderFormat(value) {
  return React.createElement(patternflyReact.Table.Heading, null, value);
};

var DefaultCellFormat = function DefaultCellFormat(value) {
  return React.createElement(patternflyReact.Table.Cell, null, value);
};

var GenericTable = function GenericTable(ref) {
  var striped = ref.striped;
  if (striped === void 0) striped = true;
  var bordered = ref.bordered;
  if (bordered === void 0) bordered = true;
  var hover = ref.hover;
  if (hover === void 0) hover = true;
  var columns = ref.columns;
  var rows = ref.rows;
  var rowKey = ref.rowKey;
  return React.createElement(patternflyReact.Table.PfProvider, {
    striped: striped,
    bordered: bordered,
    hover: hover,
    columns: columns
  }, React.createElement(patternflyReact.Table.Header, null), React.createElement(patternflyReact.Table.Body, {
    rows: rows,
    rowKey: rowKey
  }));
};

var HelpDropdown =
/*@__PURE__*/
function (superclass) {
  function HelpDropdown(props) {
    var this$1 = this;
    superclass.call(this, props);
    this.state = {
      isOpen: false
    };

    this.onToggle = function (isOpen) {
      this$1.setState({
        isOpen: isOpen
      });
    };

    this.onSelect = function () {
      this$1.setState({
        isOpen: !this$1.state.isOpen
      });
    };
  }

  if (superclass) HelpDropdown.__proto__ = superclass;
  HelpDropdown.prototype = Object.create(superclass && superclass.prototype);
  HelpDropdown.prototype.constructor = HelpDropdown;

  HelpDropdown.prototype.render = function render() {
    var ref = this.state;
    var isOpen = ref.isOpen;
    var ref$1 = this.props;
    var additionalDropdownItems = ref$1.additionalDropdownItems;
    if (additionalDropdownItems === void 0) additionalDropdownItems = [];
    var dropdownDirection = ref$1.dropdownDirection;
    var dropdownPosition = ref$1.dropdownPosition;
    var launchSampleIntegrationTutorials = ref$1.launchSampleIntegrationTutorials;
    var launchUserGuide = ref$1.launchUserGuide;
    var launchConnectorsGuide = ref$1.launchConnectorsGuide;
    var launchSupportPage = ref$1.launchSupportPage;
    var launchContactUs = ref$1.launchContactUs;
    var launchAboutModal = ref$1.launchAboutModal;
    var isTabletView = ref$1.isTabletView;
    var dropdownItems = [React.createElement(reactCore.DropdownItem, {
      "data-testid": 'help-dropdown-integration-tutorials-dropdown-item',
      key: "sampleIntegrationTutorials",
      component: "a",
      onClick: launchSampleIntegrationTutorials
    }, "Sample Integration Tutorials"), React.createElement(reactCore.DropdownItem, {
      "data-testid": 'help-dropdown-user-guide-dropdown-item',
      key: "userGuide",
      component: "a",
      onClick: launchUserGuide
    }, "User Guide"), React.createElement(reactCore.DropdownItem, {
      "data-testid": 'help-dropdown-connectors-guide-dropdown-item',
      key: "connectorsGuide",
      component: "a",
      onClick: launchConnectorsGuide
    }, "Connectors Guide"), React.createElement(reactCore.DropdownItem, {
      "data-testid": 'help-dropdown-support-dropdown-item',
      key: "support",
      component: "a",
      onClick: launchSupportPage
    }, "Support"), React.createElement(reactCore.DropdownItem, {
      "data-testid": 'help-dropdown-contact-us-dropdown-item',
      key: "contactUs",
      component: "a",
      onClick: launchContactUs
    }, "Contact Us"), React.createElement(reactCore.DropdownItem, {
      "data-testid": 'help-dropdown-about-dropdown-item',
      key: "action",
      component: "a",
      onClick: function onClick(ev) {
        ev.preventDefault();
        launchAboutModal();
      }
    }, "About")];
    var dropdownId = 'helpDropdownButton';
    return React.createElement(React.Fragment, null, React.createElement(reactCore.Dropdown, {
      direction: dropdownDirection || reactCore.DropdownDirection.down,
      position: dropdownPosition || reactCore.DropdownPosition.right,
      onSelect: this.onSelect,
      toggle: isTabletView ? React.createElement(reactCore.KebabToggle, {
        id: dropdownId,
        "data-testid": dropdownId,
        className: classnames('', this.props.className),
        onToggle: this.onToggle
      }) : React.createElement(reactCore.DropdownToggle, {
        id: dropdownId,
        "data-testid": dropdownId,
        className: classnames('', this.props.className),
        onToggle: this.onToggle,
        iconComponent: null
      }, React.createElement(reactIcons.HelpIcon, null)),
      isOpen: isOpen,
      isPlain: true,
      dropdownItems: dropdownItems.concat(additionalDropdownItems)
    }));
  };

  return HelpDropdown;
}(React.Component);
/**
 * Component that returns an HTTP method
 * with the properly formatted color.
 * Accepts a string for the HTTP method in question.
 */


var HttpMethodColors =
/*@__PURE__*/
function (superclass) {
  function HttpMethodColors() {
    superclass.apply(this, arguments);
  }

  if (superclass) HttpMethodColors.__proto__ = superclass;
  HttpMethodColors.prototype = Object.create(superclass && superclass.prototype);
  HttpMethodColors.prototype.constructor = HttpMethodColors;

  HttpMethodColors.prototype.render = function render() {
    var httpMethodClass = classnames({
      'http-method--delete': this.props.method === 'DELETE',
      'http-method--get': this.props.method === 'GET',
      'http-method--post': this.props.method === 'POST',
      'http-method--put': this.props.method === 'PUT'
    });
    return React.createElement("span", {
      className: httpMethodClass
    }, this.props.method);
  };

  return HttpMethodColors;
}(React.Component);

var AppLayoutContextDefaultValue = {};
var AppLayoutContext = React.createContext(AppLayoutContextDefaultValue);

var AppBreadcrumb = function AppBreadcrumb(ref) {
  var children = ref.children;
  var appLayoutContext = React.useContext(AppLayoutContext);
  React.useEffect(function setupElement() {
    appLayoutContext.showBreadcrumb(children);
    return function removeElement() {
      appLayoutContext.showBreadcrumb(null);
    };
  });
  return null;
};
/**
 * A component to show the logged in user menu.
 */


var AppTopMenu =
/*@__PURE__*/
function (superclass) {
  function AppTopMenu() {
    var this$1 = this;
    superclass.apply(this, arguments);
    this.state = {
      isOpen: false
    };

    this.onToggle = function (isOpen) {
      this$1.setState({
        isOpen: isOpen
      });
    };

    this.onSelect = function (event) {
      this$1.setState({
        isOpen: !this$1.state.isOpen
      });
    };
  }

  if (superclass) AppTopMenu.__proto__ = superclass;
  AppTopMenu.prototype = Object.create(superclass && superclass.prototype);
  AppTopMenu.prototype.constructor = AppTopMenu;

  AppTopMenu.prototype.render = function render() {
    var ref = this.props;
    var children = ref.children;
    var username = ref.username;
    return React.createElement(reactCore.Dropdown, {
      id: "appTopMenu",
      "data-testid": "appTopMenu",
      isPlain: true,
      onSelect: this.onSelect,
      toggle: React.createElement(reactCore.DropdownToggle, {
        "data-testid": 'app-top-menu-user-dropdown',
        iconComponent: null,
        onToggle: this.onToggle
      }, username),
      isOpen: this.state.isOpen,
      dropdownItems: React.Children.toArray(children)
    });
  };

  return AppTopMenu;
}(React.Component);

var AppLayout = function AppLayout(ref) {
  var avatar = ref.avatar;
  var pictograph = ref.pictograph;
  var verticalNav = ref.verticalNav;
  var logoOnClick = ref.logoOnClick;
  var showNavigation = ref.showNavigation;
  var logoutItem = ref.logoutItem;
  var onNavigationCollapse = ref.onNavigationCollapse;
  var onNavigationExpand = ref.onNavigationExpand;
  var onShowAboutModal = ref.onShowAboutModal;
  var onSelectSupport = ref.onSelectSupport;
  var onSelectConnectorsGuide = ref.onSelectConnectorsGuide;
  var onSelectContactUs = ref.onSelectContactUs;
  var onSelectSampleIntegrationTutorials = ref.onSelectSampleIntegrationTutorials;
  var onSelectUserGuide = ref.onSelectUserGuide;
  var username = ref.username;
  var children = ref.children;
  var onNavToggle = showNavigation ? onNavigationCollapse : onNavigationExpand;
  var ref$1 = React.useState(null);
  var breadcrumb = ref$1[0];
  var setHasBreadcrumb = ref$1[1];

  var showBreadcrumb = function showBreadcrumb(b) {
    return setHasBreadcrumb(b);
  };

  var PageSkipToContent = React.createElement(reactCore.SkipToContent, {
    href: "#main-content-page-layout-default-nav"
  }, "Skip to Content");
  var ref$2 = React.useState(false);
  var isMobileView = ref$2[0];
  var setIsMobileView = ref$2[1];
  var ref$3 = React.useState(false);
  var isNavOpenMobile = ref$3[0];
  var setIsNavOpenMobile = ref$3[1];

  var onNavToggleMobile = function onNavToggleMobile() {
    setIsNavOpenMobile(!isNavOpenMobile);
  };

  var ref$4 = React.useState(1024);
  var curViewportWidth = ref$4[0];
  var setCurViewportWidth = ref$4[1];

  var onPageResize = function onPageResize(props) {
    setIsMobileView(props.mobileView);
    setCurViewportWidth(props.windowSize);
  };

  var ref$5 = React.useState(false);
  var isTabletView = ref$5[0];
  var setIsTabletView = ref$5[1];
  var LARGE_VIEWPORT_BREAKPOINT = parseInt(reactTokens.global_breakpoint_lg.value.substring(0, reactTokens.global_breakpoint_lg.value.indexOf('px')), 10);
  React.useEffect(function () {
    setIsTabletView(curViewportWidth <= LARGE_VIEWPORT_BREAKPOINT);
  }, [curViewportWidth]);
  return React.createElement(AppLayoutContext.Provider, {
    value: {
      showBreadcrumb: showBreadcrumb
    }
  }, React.createElement(reactCore.Page, {
    skipToContent: PageSkipToContent,
    onPageResize: onPageResize,
    header: React.createElement(reactCore.PageHeader, {
      logo: pictograph,
      logoProps: {
        onClick: logoOnClick
      },
      toolbar: React.createElement(reactCore.Toolbar, null, React.createElement(reactCore.ToolbarGroup, {
        className: reactStyles.css(accessibleStyles.screenReader, accessibleStyles.visibleOnLg)
      }, React.createElement(reactCore.ToolbarItem, null, React.createElement(HelpDropdown, {
        isTabletView: isTabletView,
        className: "syn-help-dropdown",
        isOpen: false,
        launchSupportPage: onSelectSupport,
        launchAboutModal: onShowAboutModal,
        launchSampleIntegrationTutorials: onSelectSampleIntegrationTutorials,
        launchConnectorsGuide: onSelectConnectorsGuide,
        launchUserGuide: onSelectUserGuide,
        launchContactUs: onSelectContactUs,
        additionalDropdownItems: [React.createElement(reactCore.DropdownSeparator, {
          key: "separator",
          className: "pf-u-display-none-on-lg"
        }), React.createElement(reactCore.DropdownItem, {
          key: "mobile-" + logoutItem.key,
          onClick: logoutItem.onClick
        }, React.createElement("button", {
          type: "button",
          role: "menuitem",
          id: "mobile-" + logoutItem.id,
          "data-testid": "mobile-" + logoutItem.id,
          className: logoutItem.className + " pf-u-display-none-on-lg"
        }, logoutItem.children))]
      })), React.createElement(reactCore.ToolbarItem, {
        className: "pf-u-display-none pf-u-display-block-on-lg"
      }, React.createElement(AppTopMenu, {
        username: username
      }, React.createElement(reactCore.DropdownItem, {
        key: logoutItem.key,
        onClick: logoutItem.onClick
      }, React.createElement("button", {
        type: "button",
        role: "menuitem",
        id: logoutItem.id,
        "data-testid": logoutItem.id,
        className: logoutItem.className
      }, logoutItem.children)))))),
      avatar: avatar && React.createElement(reactCore.Avatar, {
        src: avatar,
        alt: "User Avatar"
      }),
      showNavToggle: true,
      onNavToggle: isMobileView ? onNavToggleMobile : onNavToggle,
      isNavOpen: isMobileView ? isNavOpenMobile : showNavigation
    }),
    sidebar: React.createElement(reactCore.PageSidebar, {
      nav: React.createElement(reactCore.Nav, null, React.createElement(reactCore.NavList, null, verticalNav)),
      isNavOpen: isMobileView ? isNavOpenMobile : showNavigation
    }),
    breadcrumb: breadcrumb
  }, children));
};

function objectWithoutProperties$1(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var ButtonLink = React.forwardRef(function (ref$1, ref) {
  var onClick = ref$1.onClick;
  var href = ref$1.href;
  var className = ref$1.className;
  var disabled = ref$1.disabled;
  var as = ref$1.as;
  if (as === void 0) as = 'default';
  var size = ref$1.size;
  var children = ref$1.children;
  var rest = objectWithoutProperties$1(ref$1, ["onClick", "href", "className", "disabled", "as", "size", "children"]);
  var props = rest;

  var onClickInterceptor = function onClickInterceptor(ev) {
    if (onClick) {
      ev.preventDefault();
      ev.stopPropagation();
      onClick(ev);
    }
  };

  className = classnames('btn', "btn-" + as, className, {
    'btn-lg': size === 'lg',
    'btn-sm': size === 'sm',
    'btn-xs': size === 'xs'
  });
  return href && !disabled ? React.createElement(reactRouterDom.Link, Object.assign({
    to: href,
    onClick: onClickInterceptor,
    className: className,
    ref: ref
  }, props), children) : React.createElement("button", Object.assign({
    onClick: onClickInterceptor,
    className: className,
    disabled: disabled || !onClick && !href,
    ref: ref
  }, props), children);
}); // tslint:disable react-unused-props-and-state

/**
 * A component to show breadcrumbs. All its children will be wrapped in a tag
 * that will automatically handle the active/inactive state by setting the
 * appropriate class to the wrapper.
 *
 * It's suggested to use only anchors or spans as children node.
 */

var Breadcrumb = function Breadcrumb(ref) {
  var items = ref.items;
  var actions = ref.actions;
  var children = ref.children;
  items = items || React.Children.toArray(children).map(function (c, idx) {
    return React.createElement(reactCore.BreadcrumbItem, {
      key: idx,
      isActive: idx === count - 1
    }, c);
  });
  var count = items.length;
  return React.createElement(AppBreadcrumb, null, React.createElement(reactCore.Level, {
    gutter: 'md'
  }, React.createElement(reactCore.LevelItem, null, React.createElement(reactCore.Breadcrumb, null, items)), actions && React.createElement(reactCore.LevelItem, null, actions)));
};

var Loader =
/*@__PURE__*/
function (superclass) {
  function Loader() {
    superclass.apply(this, arguments);
  }

  if (superclass) Loader.__proto__ = superclass;
  Loader.prototype = Object.create(superclass && superclass.prototype);
  Loader.prototype.constructor = Loader;

  Loader.prototype.render = function render() {
    return React.createElement("div", {
      className: classnames('Loader', {
        'is-block': !this.props.inline,
        'is-inline': this.props.inline
      })
    }, React.createElement(patternflyReact.Spinner, {
      loading: this.props.loading,
      size: this.props.size,
      inline: this.props.inline,
      inverse: this.props.inverse
    }));
  };

  return Loader;
}(React.PureComponent);

Loader.defaultProps = {
  inline: false,
  inverse: false,
  loading: true,
  size: 'lg'
};

var PageLoader =
/*@__PURE__*/
function (superclass) {
  function PageLoader() {
    superclass.apply(this, arguments);
  }

  if (superclass) PageLoader.__proto__ = superclass;
  PageLoader.prototype = Object.create(superclass && superclass.prototype);
  PageLoader.prototype.constructor = PageLoader;

  PageLoader.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(Loader, {
      size: 'lg'
    }));
  };

  return PageLoader;
}(React.PureComponent);

function objectWithoutProperties$2(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

function joinClassnames() {
  var classnames$$1 = [],
      len = arguments.length;

  while (len--) {
    classnames$$1[len] = arguments[len];
  }

  return classnames$$1.filter(function (i) {
    return i;
  }).join(' ');
}

var PfNavLink = function PfNavLink(ref) {
  var activeClassName = ref.activeClassName;
  if (activeClassName === void 0) activeClassName = 'active';
  var activeStyle = ref.activeStyle;
  var classNameProp = ref.className;
  var exact = ref.exact;
  var isActiveProp = ref.isActive;
  var location = ref.location;
  var strict = ref.strict;
  var styleProp = ref.style;
  var to = ref.to;
  var label = ref.label;
  var children = ref.children;
  var rest$1 = objectWithoutProperties$2(ref, ["activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "label", "children", "activeKey", "activeHref"]);
  var rest = rest$1;
  var path = typeof to === 'object' ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');

  var NavLinkChildren = function NavLinkChildren(ref) {
    var childLocation = ref.location;
    var match = ref.match;
    var isActive = !!(isActiveProp ? isActiveProp(match, childLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object.assign({}, styleProp, activeStyle) : styleProp;
    return React.createElement("li", {
      className: className
    }, React.createElement(reactRouterDom.Link, Object.assign({
      style: style,
      to: to,
      children: label
    }, rest)), children);
  };

  return React.createElement(reactRouter.Route, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: NavLinkChildren
  });
};

function objectWithoutProperties$3(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

function PfVerticalNavItem(ref) {
  var exact = ref.exact;
  var isActiveProp = ref.isActive;
  var location = ref.location;
  var strict = ref.strict;
  var to = ref.to;
  var label = ref.label;
  var children = ref.children;
  var rest$1 = objectWithoutProperties$3(ref, ["className", "exact", "isActive", "location", "strict", "to", "label", "children"]);
  var rest = rest$1;
  var path = typeof to === 'object' ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');

  var NavLinkViewTemplate = function NavLinkViewTemplate(ref) {
    var obj;
    var childLocation = ref.location;
    var match = ref.match;
    var isActive = !!(isActiveProp ? isActiveProp(match, childLocation) : match);
    return children ? React.createElement(reactCore.NavExpandable, {
      title: label,
      isActive: isActive,
      isExpanded: isActive
    }, children) : React.createElement("li", {
      className: 'pf-c-nav__item'
    }, React.createElement(reactRouterDom.Link, Object.assign({
      to: to,
      className: classnames('pf-c-nav__link', (obj = {}, obj['pf-m-current'] = isActive, obj)),
      "aria-current": isActive ? 'page' : undefined,
      children: React.createElement(React.Fragment, null, label)
    }, rest)));
  };

  return React.createElement(reactRouter.Route, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: NavLinkViewTemplate
  });
}

PfVerticalNavItem.displayName = 'VerticalNav.Item';

function objectWithoutProperties$4(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var TabBar = function TabBar(ref) {
  var children = ref.children;
  var rest = objectWithoutProperties$4(ref, ["children"]);
  var props = rest;
  return React.createElement(patternflyReact.Nav, Object.assign({
    bsClass: "nav nav-tabs nav-tabs-pf"
  }, props), children);
};

function objectWithoutProperties$5(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var TabBarItem = function TabBarItem(ref) {
  var label = ref.label;
  var to = ref.to;
  var rest = objectWithoutProperties$5(ref, ["label", "to"]);
  var props = rest;
  return React.createElement(PfNavLink, Object.assign({
    label: label,
    to: to
  }, props));
}; // tslint:disable react-unused-props-and-state


var WizardStep = function WizardStep(ref) {
  var isActive = ref.isActive;
  var isDisabled = ref.isDisabled;
  var isAlt = ref.isAlt;
  if (isAlt === void 0) isAlt = false;
  var onClick = ref.onClick;
  var step = ref.step;
  var title = ref.title;
  var subSteps = ref.subSteps;
  if (subSteps === void 0) subSteps = [];
  var activeSubstep = ref.activeSubstep;
  if (activeSubstep === void 0) activeSubstep = 0;
  return React.createElement("li", {
    className: (isAlt ? 'wizard-pf-step-alt' : 'wizard-pf-step') + " " + (isActive ? 'active' : '') + " " + (isDisabled ? 'disabled' : ''),
    onClick: onClick
  }, React.createElement("a", null, React.createElement("span", {
    className: "wizard-pf-step" + (isAlt ? '-alt' : '') + "-number"
  }, step), React.createElement("span", {
    className: "wizard-pf-step" + (isAlt ? '-alt' : '') + "-title"
  }, title), !isAlt && subSteps.map(function (s, idx) {
    return React.createElement("span", {
      className: "wizard-pf-step-title-substep " + (idx === activeSubstep ? 'active' : ''),
      key: idx
    }, s);
  })), isAlt && isActive && React.createElement("ul", null, subSteps.map(function (s, idx) {
    return React.createElement("li", {
      className: "wizard-pf-step-alt-substep " + (idx === activeSubstep ? 'active' : 'disabled'),
      key: idx
    }, React.createElement("a", null, s));
  })));
};

var WizardSteps =
/*@__PURE__*/
function (superclass) {
  function WizardSteps() {
    superclass.apply(this, arguments);
  }

  if (superclass) WizardSteps.__proto__ = superclass;
  WizardSteps.prototype = Object.create(superclass && superclass.prototype);
  WizardSteps.prototype.constructor = WizardSteps;

  WizardSteps.prototype.render = function render() {
    return React.createElement("div", {
      className: 'wizard-pf-steps'
    }, React.createElement("ul", {
      className: "wizard-pf-steps-indicator wizard-pf-steps-alt-indicator " + (this.props.active ? 'active' : ''),
      style: {
        borderTop: '0 none'
      }
    }, this.props.mainSteps), React.createElement("ul", {
      className: "wizard-pf-steps-alt " + (this.props.active ? '' : 'hidden')
    }, this.props.altSteps));
  };

  return WizardSteps;
}(React.Component); // tslint:disable react-unused-props-and-state
// remove the above line after this goes GA https://github.com/Microsoft/tslint-microsoft-contrib/pull/824


function objectWithoutProperties$6(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var ReadWidget = function ReadWidget(ref) {
  var className = ref.className;
  var allowEditing = ref.allowEditing;
  var value = ref.value;
  var onEdit = ref.onEdit;
  return React.createElement("span", {
    className: classnames('inline-text-readwidget', className),
    onClick: allowEditing ? onEdit : undefined
  }, value, allowEditing ? React.createElement(patternflyReact.Icon, {
    className: "inline-text-editIcon",
    name: "edit",
    onClick: onEdit,
    type: "pf"
  }) : null);
};

var EditWidget = function EditWidget(ref) {
  var valid = ref.valid;
  var value = ref.value;
  var placeholder = ref.placeholder;
  var errorMsg = ref.errorMsg;
  var saving = ref.saving;
  var asTextarea = ref.asTextarea;
  var onChange = ref.onChange;
  var onConfirm = ref.onConfirm;
  var onCancel = ref.onCancel;
  return React.createElement("div", {
    className: 'inline-text-editwidget'
  }, asTextarea ? React.createElement(React.Fragment, null, React.createElement(patternflyReact.FormGroup, {
    controlId: "textarea",
    validationState: valid ? 'success' : 'error'
  }, React.createElement(patternflyReact.FormControl, {
    componentClass: "textarea",
    disabled: saving,
    onChange: onChange,
    placeholder: placeholder,
    value: value
  }), saving ? React.createElement("span", {
    className: "btn"
  }, React.createElement(Loader, {
    inline: true,
    loading: saving,
    size: 'sm'
  })) : React.createElement(patternflyReact.InlineEdit.ConfirmButton, {
    disabled: saving || !valid,
    onClick: onConfirm
  }), React.createElement(patternflyReact.InlineEdit.CancelButton, {
    disabled: saving,
    onClick: onCancel
  })), errorMsg && React.createElement(patternflyReact.HelpBlock, null, errorMsg)) : React.createElement(React.Fragment, null, React.createElement(patternflyReact.FormGroup, {
    validationState: valid ? 'success' : 'error'
  }, React.createElement(patternflyReact.InputGroup, null, React.createElement(patternflyReact.FormControl, {
    disabled: saving,
    onChange: onChange,
    placeholder: placeholder,
    type: "text",
    value: value
  }), React.createElement(patternflyReact.InputGroup.Button, null, saving ? React.createElement("span", {
    className: "btn"
  }, React.createElement(Loader, {
    inline: true,
    loading: saving,
    size: 'sm'
  })) : React.createElement(patternflyReact.InlineEdit.ConfirmButton, {
    disabled: saving || !valid,
    onClick: onConfirm
  })), React.createElement(patternflyReact.InputGroup.Button, null, React.createElement(patternflyReact.InlineEdit.CancelButton, {
    disabled: saving,
    onClick: onCancel
  }))), errorMsg && React.createElement(patternflyReact.HelpBlock, null, errorMsg))));
};

var InlineTextEdit = function InlineTextEdit(ref) {
  var className = ref.className;
  var value = ref.value;
  var allowEditing = ref.allowEditing;
  var i18nPlaceholder = ref.i18nPlaceholder;
  var isTextArea = ref.isTextArea;
  var onChange = ref.onChange;
  var onValidate = ref.onValidate;
  var rest = objectWithoutProperties$6(ref, ["className", "value", "allowEditing", "i18nPlaceholder", "isTextArea", "onChange", "onValidate"]);
  var attrs = rest;
  var ref$1 = React.useState(value);
  var currentValue = ref$1[0];
  var setCurrentValue = ref$1[1];
  var ref$2 = React.useState(false);
  var editing = ref$2[0];
  var setEditing = ref$2[1];
  var ref$3 = React.useState(false);
  var saving = ref$3[0];
  var setSaving = ref$3[1];
  var ref$4 = React.useState({
    errorMsg: '',
    valid: true
  });
  var ref$4_0 = ref$4[0];
  var valid = ref$4_0.valid;
  var errorMsg = ref$4_0.errorMsg;
  var setValidity = ref$4[1];

  var validate = function validate(valueToValidate) {
    try {
      var _temp = function () {
        if (onValidate) {
          return Promise.resolve(onValidate(valueToValidate)).then(function (result) {
            if (result === true) {
              setValidity({
                errorMsg: '',
                valid: true
              });
            } else {
              setValidity({
                errorMsg: result,
                valid: false
              });
            }
          });
        } else {
          setValidity({
            errorMsg: '',
            valid: true
          });
        }
      }();

      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleConfirm = function handleConfirm() {
    try {
      var _temp2 = function () {
        if (valid) {
          setSaving(true);
          return Promise.resolve(onChange(currentValue)).then(function (success) {
            if (success) {
              setEditing(false);
            }

            setSaving(false);
          });
        }
      }();

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleChange = function handleChange(e) {
    setCurrentValue(e.target.value);
    validate(e.target.value);
  };

  var onEdit = function onEdit() {
    setEditing(true);
    validate(currentValue);
  };

  var onCancel = function onCancel() {
    setEditing(false);
    setCurrentValue(value);
  };

  var renderValue = function renderValue(v) {
    return React.createElement(ReadWidget, {
      className: className,
      value: v || i18nPlaceholder || 'Value...',
      allowEditing: allowEditing,
      onEdit: onEdit
    });
  };

  var renderEdit = function renderEdit(v) {
    return React.createElement(EditWidget, Object.assign({}, attrs, {
      valid: valid,
      saving: saving,
      value: v,
      errorMsg: errorMsg,
      asTextarea: isTextArea,
      onChange: handleChange,
      onConfirm: handleConfirm,
      onCancel: onCancel
    }));
  };

  var isEditing = function isEditing() {
    return editing;
  };

  return React.createElement(patternflyReact.InlineEdit, {
    className: className,
    value: currentValue,
    isEditing: isEditing,
    renderValue: renderValue,
    renderEdit: renderEdit
  });
};

var ListViewToolbar =
/*@__PURE__*/
function (superclass) {
  function ListViewToolbar() {
    var this$1 = this;
    superclass.apply(this, arguments);

    this.renderInput = function () {
      var ref = this$1.props;
      var currentFilterType = ref.currentFilterType;
      var currentValue = ref.currentValue;

      if (!currentFilterType) {
        return null;
      }

      if (currentFilterType.filterType === 'select') {
        return React.createElement(patternflyReact.Filter.ValueSelector, {
          filterValues: currentFilterType.filterValues,
          currentValue: currentValue,
          onFilterValueSelected: this$1.props.onFilterValueSelected
        });
      } else {
        return React.createElement(patternflyReact.FormControl, {
          type: currentFilterType.filterType,
          value: currentValue,
          placeholder: currentFilterType.placeholder,
          onChange: this$1.props.onUpdateCurrentValue,
          onKeyPress: this$1.props.onValueKeyPress
        });
      }
    };
  }

  if (superclass) ListViewToolbar.__proto__ = superclass;
  ListViewToolbar.prototype = Object.create(superclass && superclass.prototype);
  ListViewToolbar.prototype.constructor = ListViewToolbar;

  ListViewToolbar.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(patternflyReact.Toolbar, {
      className: "list-view-toolbar"
    }, React.createElement(patternflyReact.Filter, null, React.createElement(patternflyReact.Filter.TypeSelector, {
      filterTypes: this.props.filterTypes,
      currentFilterType: this.props.currentFilterType.title,
      onFilterTypeSelected: this.props.onSelectFilterType
    }), this.renderInput()), React.createElement(patternflyReact.Sort, null, React.createElement(patternflyReact.Sort.TypeSelector, {
      sortTypes: this.props.sortTypes,
      currentSortType: this.props.currentSortType,
      onSortTypeSelected: this.props.onUpdateCurrentSortType
    }), React.createElement(patternflyReact.Sort.DirectionSelector, {
      isNumeric: false,
      isAscending: this.props.isSortAscending,
      onClick: this.props.onToggleCurrentSortDirection
    })), React.createElement(patternflyReact.Toolbar.RightContent, null, this.props.children), React.createElement(patternflyReact.Toolbar.Results, null, this.props.activeFilters && this.props.activeFilters.length > 0 && React.createElement(React.Fragment, null, React.createElement("h5", null, this.props.i18nResultsCount), React.createElement(patternflyReact.Filter.ActiveLabel, null, "Active Filters:"), React.createElement(patternflyReact.Filter.List, null, this.props.activeFilters.map(function (item, index) {
      return React.createElement(patternflyReact.Filter.Item, {
        key: index,
        onRemove: this$1.props.onRemoveFilter,
        filterData: item
      }, item.title, "=", item.value);
    })), React.createElement("a", {
      "data-testid": 'list-view-toolbar-clear-filters',
      onClick: this.props.onClearFilters
    }, "Clear All Filters"))));
  };

  return ListViewToolbar;
}(React.Component);

var LogViewer =
/*@__PURE__*/
function (superclass) {
  function LogViewer(props) {
    var this$1 = this;
    superclass.call(this, props);
    this.state = {
      count: 0,
      followScroll: true,
      previousCount: 0
    };

    this.renderRow = function (ref) {
      var index = ref.index;
      var style = ref.style;
      var parent = ref.parent;
      return React.createElement(reactVirtualized.CellMeasurer, {
        cache: this$1.cellMeasurerCache,
        columnIndex: 0,
        key: index,
        rowIndex: index,
        parent: parent
      }, React.createElement("div", {
        className: 'LogViewerRow',
        style: style
      }, React.createElement("span", {
        className: "LogViewerRow_number"
      }, index + 1), React.createElement("span", {
        className: "LogViewerRow_content"
      }, this$1.props.data[index])));
    };

    this.toggleFollow = function () {
      this$1.setState({
        followScroll: !this$1.state.followScroll
      });
    };

    this.cellMeasurerCache = new reactVirtualized.CellMeasurerCache({
      fixedWidth: true,
      minHeight: 20
    });
  }

  if (superclass) LogViewer.__proto__ = superclass;
  LogViewer.prototype = Object.create(superclass && superclass.prototype);
  LogViewer.prototype.constructor = LogViewer;

  LogViewer.getDerivedStateFromProps = function getDerivedStateFromProps(ref, state) {
    var data = ref.data;
    return Object.assign({}, state, {
      count: data.length,
      previousCount: state.followScroll ? state.count : state.previousCount
    });
  };

  LogViewer.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(React.Fragment, null, React.createElement(patternflyReact.Row, {
      className: 'LogViewer'
    }, React.createElement(patternflyReact.Col, {
      sm: 12
    }, React.createElement(reactVirtualized.AutoSizer, {
      disableHeight: !!this.props.height,
      disableWidth: !!this.props.width
    }, function (ref) {
      var width = ref.width;
      var height = ref.height;
      return React.createElement(reactVirtualized.List, {
        deferredMeasurementCache: this$1.cellMeasurerCache,
        height: this$1.props.height || height,
        rowCount: this$1.props.data.length,
        rowHeight: this$1.cellMeasurerCache.rowHeight,
        rowRenderer: this$1.renderRow,
        scrollToLine: this$1.state.count,
        scrollToIndex: this$1.state.followScroll ? this$1.state.count - 1 : -1,
        width: this$1.props.width || width
      });
    }))), React.createElement(patternflyReact.Row, null, React.createElement(patternflyReact.Col, {
      sm: 12
    }, React.createElement(patternflyReact.Switch, {
      id: 'toggle-follow',
      labelText: 'Follow logs',
      onChange: this.toggleFollow,
      value: this.state.followScroll
    }))));
  };

  return LogViewer;
}(React.Component);

LogViewer.defaultProps = {
  height: 300
};

var Notifications =
/*@__PURE__*/
function (superclass) {
  function Notifications() {
    superclass.apply(this, arguments);
  }

  if (superclass) Notifications.__proto__ = superclass;
  Notifications.prototype = Object.create(superclass && superclass.prototype);
  Notifications.prototype.constructor = Notifications;

  Notifications.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(patternflyReact.ToastNotificationList, {
      className: "app__notificationList"
    }, this.props.notifications.map(function (notification) {
      return React.createElement(patternflyReact.TimedToastNotification, {
        key: notification.key,
        type: notification.type,
        persistent: notification.persistent,
        onDismiss: this$1.props.removeNotificationAction.bind(this$1, notification),
        timerdelay: this$1.props.notificationTimerDelay
      }, typeof notification.message === 'string' ? React.createElement(Container, {
        dangerouslySetInnerHTML: {
          __html: notification.message
        }
      }) : React.createElement(Container, null, notification.message));
    }));
  };

  return Notifications;
}(React.Component);

var OpenApiReviewActions =
/*@__PURE__*/
function (superclass) {
  function OpenApiReviewActions() {
    superclass.apply(this, arguments);
  }

  if (superclass) OpenApiReviewActions.__proto__ = superclass;
  OpenApiReviewActions.prototype = Object.create(superclass && superclass.prototype);
  OpenApiReviewActions.prototype.constructor = OpenApiReviewActions;

  OpenApiReviewActions.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      className: 'open-api-review-actions'
    }, React.createElement(patternflyReact.Card.Body, null, this.props.i18nValidationFallbackMessage ? React.createElement("h5", {
      className: 'review-actions__validationFallbackMessage'
    }, this.props.i18nValidationFallbackMessage) : React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
      headingLevel: 'h5',
      size: 'md',
      className: 'review-actions__heading'
    }, this.props.i18nApiDefinitionHeading), React.createElement(Container, {
      className: 'review-actions__name-description'
    }, React.createElement(reactCore.TextList, {
      component: reactCore.TextListVariants.dl
    }, React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nNameLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.apiProviderName), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nDescriptionLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.apiProviderDescription))), React.createElement(reactCore.Title, {
      headingLevel: 'h5',
      size: 'md',
      className: 'review-actions__heading'
    }, this.props.i18nImportedHeading), React.createElement(Container, null, React.createElement(reactCore.Text, {
      component: reactCore.TextVariants.p,
      dangerouslySetInnerHTML: {
        __html: this.props.i18nOperationsHtmlMessage
      }
    })), this.props.i18nOperationTagHtmlMessages && React.createElement(reactCore.TextList, {
      className: 'review-actions__tagMessageList'
    }, this.props.i18nOperationTagHtmlMessages.map(function (msg, index) {
      return React.createElement(reactCore.TextListItem, {
        key: index,
        dangerouslySetInnerHTML: {
          __html: msg
        }
      });
    })), this.props.i18nErrorsHeading && this.props.errorMessages && React.createElement(reactCore.Title, {
      headingLevel: 'h5',
      size: 'md',
      className: 'review-actions__heading'
    }, this.props.i18nErrorsHeading, React.createElement(patternflyReact.Label, {
      bsStyle: 'danger',
      className: 'heading__label'
    }, this.props.errorMessages.length)), React.createElement(Container, {
      className: 'review-actions__errors'
    }, this.props.errorMessages ? this.props.errorMessages.map(function (errorMsg, index) {
      return React.createElement(reactCore.Text, {
        component: reactCore.TextVariants.p,
        key: index
      }, index + 1, ". ", errorMsg);
    }) : null), this.props.i18nWarningsHeading && this.props.warningMessages && React.createElement(reactCore.Title, {
      headingLevel: 'h5',
      size: 'md',
      className: 'review-actions__heading'
    }, this.props.i18nWarningsHeading, React.createElement(patternflyReact.Label, {
      bsStyle: 'warning',
      className: 'heading__label'
    }, this.props.warningMessages.length)), React.createElement(Container, {
      className: 'review-actions__warnings'
    }, this.props.warningMessages ? this.props.warningMessages.map(function (warningMsg, index) {
      return React.createElement(reactCore.Text, {
        key: index,
        component: reactCore.TextVariants.p
      }, index + 1, ". ", warningMsg);
    }) : null))));
  };

  return OpenApiReviewActions;
}(React.Component); // tslint:disable:no-console


var OpenApiSelectMethod =
/*@__PURE__*/
function (superclass) {
  function OpenApiSelectMethod(props) {
    superclass.call(this, props);
    this.state = {
      disableDropzone: false,
      method: 'file',
      specification: '',
      valid: false
    };
    this.buildUploadMessage = this.buildUploadMessage.bind(this);
    this.onAddUrlSpecification = this.onAddUrlSpecification.bind(this);
    this.onSelectMethod = this.onSelectMethod.bind(this);
    this.onUploadAccepted = this.onUploadAccepted.bind(this);
    this.onUploadRejected = this.onUploadRejected.bind(this);
  }

  if (superclass) OpenApiSelectMethod.__proto__ = superclass;
  OpenApiSelectMethod.prototype = Object.create(superclass && superclass.prototype);
  OpenApiSelectMethod.prototype.constructor = OpenApiSelectMethod;
  /**
   * Helper function used to build the D&D upload success/fail
   * messages, which are subsequently set in the UI state
   * @param fileName - The name of the file that was uploaded
   * @param succeeded - Boolean value that specifies whether or not the
   * upload was successful.
   */

  OpenApiSelectMethod.prototype.buildUploadMessage = function buildUploadMessage(fileName, succeeded) {
    if (succeeded && fileName) {
      this.setState({
        uploadSuccessMessage: this.props.i18nUploadSuccessMessage + "'" + fileName + "'"
      });
    } else {
      this.setState({
        uploadFailedMessage: "'" + fileName + "'" + this.props.i18nUploadFailedMessage
      });
    }
  };

  OpenApiSelectMethod.prototype.checkValidUrl = function checkValidUrl(url) {
    var regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    return regexp.test(url);
  };
  /**
   * User has added a specification via a string URL, which will be
   * checked if is a valid HTTP/HTTPS string.
   * @param e
   */


  OpenApiSelectMethod.prototype.onAddUrlSpecification = function onAddUrlSpecification(e) {
    this.setState({
      specification: e.currentTarget.value
    });

    if (this.state.method === 'url' && this.checkValidUrl(e.currentTarget.value)) {
      this.setState({
        valid: true
      });
    } else {
      this.setState({
        valid: false
      });
    }
  };
  /**
   * The action fired when the user selects the method
   * to provide an OpenAPI specification.
   * @param newMethod
   */


  OpenApiSelectMethod.prototype.onSelectMethod = function onSelectMethod(newMethod) {
    this.setState({
      method: newMethod,
      specification: '',
      uploadFailedMessage: '',
      uploadSuccessMessage: '',
      valid: newMethod === 'scratch'
    });
  };
  /**
   * Callback for when one or more file uploads have been accepted.
   */


  OpenApiSelectMethod.prototype.onUploadAccepted = function onUploadAccepted(files) {
    var this$1 = this;
    var reader = new FileReader();
    reader.readAsText(files[0]);
    this.buildUploadMessage(files[0].name, true);

    reader.onload = function () {
      this$1.setState({
        specification: reader.result,
        valid: true
      });
    };
  };
  /**
   * Obtains the localized text (may include HTML tags) that appears when the file upload was rejected. This
   * will occur when a DnD of a file with the wrong extension is dropped. This message is presented
   * as a timed toast notification.
   * @param fileName - Name of file that failed to be uploaded
   */


  OpenApiSelectMethod.prototype.onUploadRejected = function onUploadRejected(fileName) {
    this.buildUploadMessage(fileName, false);
    this.setState({
      specification: '',
      valid: false
    });
    return '<span>File <strong>' + fileName + '</strong> could not be uploaded</span>';
  };

  OpenApiSelectMethod.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(patternflyReact.Card, {
      className: 'open-api-review-actions'
    }, React.createElement(patternflyReact.Card.Body, null, React.createElement(patternflyReact.Grid, {
      fluid: true,
      className: 'open-api-select-method'
    }, React.createElement(patternflyReact.Row, null, React.createElement(patternflyReact.Col, null, React.createElement(patternflyReact.FormGroup, {
      controlId: 'method',
      disabled: false
    }, React.createElement("div", null, React.createElement(patternflyReact.Radio, {
      id: 'method-file',
      name: 'method',
      onClick: function onClick() {
        return this$1.onSelectMethod('file');
      },
      checked: this.state.method === 'file',
      readOnly: true
    }, React.createElement("div", null, this.props.i18nMethodFromFile), this.state.method === 'file' && React.createElement("div", {
      className: "open-api-select-method__dnd-container"
    }, React.createElement(DndFileChooser, {
      allowMultiple: false,
      disableDropzone: this.props.disableDropzone,
      fileExtensions: this.props.fileExtensions,
      i18nHelpMessage: this.props.i18nHelpMessage,
      i18nInstructions: this.props.i18nInstructions,
      i18nNoFileSelectedMessage: this.props.i18nNoFileSelectedMessage,
      i18nSelectedFileLabel: this.props.i18nSelectedFileLabel,
      i18nUploadFailedMessage: this.state.uploadFailedMessage,
      i18nUploadSuccessMessage: this.state.uploadSuccessMessage,
      onUploadAccepted: this.onUploadAccepted,
      onUploadRejected: this.onUploadRejected
    }))), React.createElement(patternflyReact.Radio, {
      id: 'method-url',
      name: 'method',
      onClick: function onClick() {
        return this$1.onSelectMethod('url');
      },
      readOnly: true
    }, React.createElement("div", null, this.props.i18nMethodFromUrl), this.state.method === 'url' && React.createElement("div", null, React.createElement(patternflyReact.FormControl, {
      type: 'text',
      disabled: false,
      value: this.state.specification,
      onChange: this.onAddUrlSpecification
    }), React.createElement("br", null), React.createElement("span", {
      className: 'url-note'
    }, this.props.i18nUrlNote))), this.props.allowFromScratch && React.createElement(patternflyReact.Radio, {
      id: 'method-scratch',
      name: 'method',
      onClick: function onClick() {
        return this$1.onSelectMethod('scratch');
      },
      readOnly: true
    }, React.createElement("div", null, this.props.i18nMethodFromScratch))))), React.createElement(ButtonLink, {
      disabled: !this.state.valid,
      as: 'primary',
      onClick: function onClick() {
        return this$1.props.onNext(this$1.state.method, this$1.state.specification);
      }
    }, this.props.i18nBtnNext)))));
  };

  return OpenApiSelectMethod;
}(React.Component);

OpenApiSelectMethod.defaultProps = {
  allowFromScratch: true
};

var PfDropdownItem =
/*@__PURE__*/
function (superclass) {
  function PfDropdownItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) PfDropdownItem.__proto__ = superclass;
  PfDropdownItem.prototype = Object.create(superclass && superclass.prototype);
  PfDropdownItem.prototype.constructor = PfDropdownItem;

  PfDropdownItem.prototype.render = function render() {
    return React.createElement(reactCore.DropdownItem, {
      isDisabled: this.props.disabled,
      onClick: this.props.onClick
    }, this.props.children);
  };

  return PfDropdownItem;
}(React.Component);

var ProgressWithLink =
/*@__PURE__*/
function (superclass) {
  function ProgressWithLink() {
    superclass.apply(this, arguments);
  }

  if (superclass) ProgressWithLink.__proto__ = superclass;
  ProgressWithLink.prototype = Object.create(superclass && superclass.prototype);
  ProgressWithLink.prototype.constructor = ProgressWithLink;

  ProgressWithLink.prototype.render = function render() {
    return React.createElement("div", {
      className: "progress-link"
    }, React.createElement("div", {
      className: "progress-link__row"
    }, React.createElement("div", {
      className: "progress-link__status",
      "data-testid": 'progress-with-link-value'
    }, this.props.value, " ( ", this.props.currentStep, " /", ' ', this.props.totalSteps, " )"), this.props.logUrl && React.createElement("span", {
      className: "progress-link__link"
    }, React.createElement("a", {
      "data-testid": 'progress-with-link-log-url',
      target: "_blank",
      href: this.props.logUrl
    }, this.props.i18nLogUrlText, ' ', React.createElement(patternflyReact.Icon, {
      className: "progress-link__link-icon",
      name: 'external-link'
    })))), React.createElement(patternflyReact.ProgressBar, {
      now: this.props.currentStep,
      max: this.props.totalSteps,
      style: {
        height: 6
      }
    }));
  };

  return ProgressWithLink;
}(React.PureComponent);

function objectWithoutProperties$7(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var SimplePageHeader = function SimplePageHeader(ref) {
  var i18nTitle = ref.i18nTitle;
  var i18nDescription = ref.i18nDescription;
  var variant = ref.variant;
  if (variant === void 0) variant = 'light';
  var titleSize = ref.titleSize;
  if (titleSize === void 0) titleSize = '2xl';
  var titleHeadingLevel = ref.titleHeadingLevel;
  if (titleHeadingLevel === void 0) titleHeadingLevel = reactCore.TitleLevel.h1;
  var className = ref.className;
  var rest$1 = objectWithoutProperties$7(ref, ["i18nTitle", "i18nDescription", "variant", "titleSize", "titleHeadingLevel", "className"]);
  var rest = rest$1;
  return React.createElement(reactCore.PageSection, Object.assign({
    variant: variant,
    className: classnames('', className)
  }, rest), React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
    size: titleSize,
    headingLevel: reactCore.TitleLevel[titleHeadingLevel]
  }, i18nTitle), i18nDescription && React.createElement(reactCore.Text, {
    dangerouslySetInnerHTML: {
      __html: i18nDescription
    }
  })));
};

var AbstractLanguageLint = function AbstractLanguageLint(theName) {
  this.theName = theName;
  this.errors = [];
  this.define();
};

AbstractLanguageLint.prototype.name = function name() {
  return this.theName;
};

AbstractLanguageLint.prototype.validator = function validator(text, options) {
  this.errors = [];

  if (text.length === 0) {
    var msg = 'linter-no-content';
    this.errors.push({
      from: CodeMirror.Pos(0, 0),
      message: msg,
      severity: 'warning',
      to: CodeMirror.Pos(0, 0)
    });
    return this.errors;
  }

  this.validate(text, this.errors);
  return this.errors;
};

AbstractLanguageLint.prototype.define = function define() {
  var this$1 = this;
  CodeMirror.registerHelper('lint', this.name(), function (text, options) {
    return this$1.validator(text, options);
  });
};

var TemplateSymbol = function TemplateSymbol(id, type) {
  this.id = id;
  this.type = type;
};

TemplateSymbol.prototype.getId = function getId() {
  return this.id;
};

TemplateSymbol.prototype.getType = function getType() {
  return this.type;
};

var MustacheModeLint =
/*@__PURE__*/
function (AbstractLanguageLint$$1) {
  function MustacheModeLint() {
    AbstractLanguageLint$$1.call(this, 'mustache');
  }

  if (AbstractLanguageLint$$1) MustacheModeLint.__proto__ = AbstractLanguageLint$$1;
  MustacheModeLint.prototype = Object.create(AbstractLanguageLint$$1 && AbstractLanguageLint$$1.prototype);
  MustacheModeLint.prototype.constructor = MustacheModeLint;

  MustacheModeLint.prototype.parse = function parse(content) {
    var symbols = [];
    var tokens = Mustache.parse(content);
    Mustache.clearCache();

    for (var i = 0, list = tokens; i < list.length; i += 1) {
      var token = list[i];

      if (token[0] === 'text' || token[0] === '!') {
        continue;
      }

      if (token[0] === 'name') {
        symbols.push(new TemplateSymbol(token[1], 'string'));
      }
    }

    return symbols;
  };

  MustacheModeLint.prototype.define = function define() {
    var this$1 = this;
    CodeMirror.defineMode(this.name(), function (config, parserConfig) {
      return {
        token: function token(stream) {
          var ch;

          if (stream.match('{{')) {
            // tslint:disable-next-line
            while ((ch = stream.next()) != null) {
              if (ch === '}' && stream.next() === '}') {
                stream.eat('}');
                return this$1.name();
              }
            }
          }

          while (stream.next() != null && !stream.match('{{', false)) {// Read it but don't do anything
          }

          return null;
        }
      };
    });
    AbstractLanguageLint$$1.prototype.define.call(this);
  };

  MustacheModeLint.prototype.validate = function validate(text, errors) {
    var symRegex = /^[A-Za-z_]+$/g;
    var format = '{{xyz}}';
    var line = 0;
    var startCol = 0;
    var endCol = 0;
    var openSymbol = 0;
    var closeSymbol = 0;
    var haveSymbol = false;
    var theSymbol = '';
    var reset = false;

    for (var i = 0; i < text.length; i++) {
      // Increase the column count
      endCol++;
      startCol = endCol - 1;

      if (reset) {
        // Successfully parsed a symbol so reset for next
        openSymbol = 0;
        closeSymbol = 0;
        theSymbol = '';
      }

      var ch = text.charAt(i);

      if (ch === '{') {
        openSymbol++;

        if (closeSymbol > 0) {
          // Found an open symbol before all close symbols
          var msg = 'lint-illegal-open-symbol';
          errors.push({
            from: CodeMirror.Pos(line, startCol),
            message: msg,
            messageContext: [line + 1, endCol],
            severity: 'error',
            to: CodeMirror.Pos(line, endCol)
          });
          reset = true;
          continue;
        }

        if (openSymbol > 2) {
          // Too many open symbols encountered
          var msg$1 = 'linter-too-many-open-symbols';
          errors.push({
            from: CodeMirror.Pos(line, startCol),
            message: msg$1,
            messageContext: [line + 1, endCol],
            severity: 'error',
            to: CodeMirror.Pos(line, endCol)
          });
          reset = true;
          continue;
        }
      } else if (ch === '}') {
        closeSymbol++;

        if (openSymbol < 2) {
          // Found a close symbol before all the open symbols
          var msg$2 = 'linter-illegal-close-symbol';
          errors.push({
            from: CodeMirror.Pos(line, startCol),
            message: msg$2,
            messageContext: [line + 1, endCol],
            severity: 'error',
            to: CodeMirror.Pos(line, endCol)
          });
          reset = true;
          continue;
        }

        if (closeSymbol > 2) {
          // Too many close symbols encountered
          var msg$3 = 'linter-too-many-close-symbols';
          errors.push({
            from: CodeMirror.Pos(line, startCol),
            message: msg$3,
            messageContext: [line + 1, endCol],
            severity: 'error',
            to: CodeMirror.Pos(line, endCol)
          });
          reset = true;
          continue;
        }
      } else {
        //
        // Handle all other types of character
        //
        // Record the symbol text for checking
        if (openSymbol === 2 && closeSymbol === 0) {
          theSymbol = theSymbol + ch;
        }

        if (openSymbol === 1) {
          // Should have encountered another open symbol but not
          var msg$4 = 'linter-expected-open-symbol';
          errors.push({
            from: CodeMirror.Pos(line, startCol),
            message: msg$4,
            messageContext: [line + 1, endCol],
            severity: 'error',
            to: CodeMirror.Pos(line, endCol)
          });
          reset = true;
          continue;
        }

        if (closeSymbol === 1) {
          // Should have encountered another close symbol but not
          var msg$5 = 'linter-expected-close-symbol';
          errors.push({
            from: CodeMirror.Pos(line, startCol),
            message: msg$5,
            messageContext: [line + 1, endCol],
            severity: 'error',
            to: CodeMirror.Pos(line, endCol)
          });
          reset = true;
          continue;
        }

        if (ch === '\n') {
          // Encountered a carriage return so increment line and reset end column
          line++;
          endCol = 0;
        }
      }

      reset = openSymbol === 2 && closeSymbol === 2;

      if (reset) {
        // Text contains at least 1 parseable symbol so at least the text is not just constants
        haveSymbol = true; // Check the symbol conforms to the expected format

        if (theSymbol.length > 0 && !theSymbol.match(symRegex)) {
          var msg$6 = 'linter-wrong-symbol-format';
          errors.push({
            from: CodeMirror.Pos(line, startCol),
            message: msg$6,
            messageContext: ['{{' + theSymbol + '}}', format, line + 1, endCol],
            severity: 'error',
            to: CodeMirror.Pos(line, endCol)
          });
        }
      }
    }

    if (!haveSymbol) {
      var msg$7 = 'linter-no-symbols';
      errors.push({
        from: CodeMirror.Pos(0, 0),
        message: msg$7,
        severity: 'warning',
        to: CodeMirror.Pos(0, 0)
      });
    }
  };

  return MustacheModeLint;
}(AbstractLanguageLint);

var VelocityLint =
/*@__PURE__*/
function (AbstractLanguageLint$$1) {
  function VelocityLint() {
    AbstractLanguageLint$$1.call(this, 'velocity');
  }

  if (AbstractLanguageLint$$1) VelocityLint.__proto__ = AbstractLanguageLint$$1;
  VelocityLint.prototype = Object.create(AbstractLanguageLint$$1 && AbstractLanguageLint$$1.prototype);
  VelocityLint.prototype.constructor = VelocityLint;

  VelocityLint.prototype.parse = function parse(content) {
    var symbols = [];
    var tokens = Velocity.parse(content);

    for (var i = 0, list = tokens; i < list.length; i += 1) {
      var token = list[i];

      if (token.type === 'references') {
        symbols.push(new TemplateSymbol(token.id, 'string'));
      }
    }

    return symbols;
  };

  VelocityLint.prototype.validate = function validate(text, errors) {
    try {
      var tokens = Velocity.parse(text);
      var totalSymbols = 0;

      for (var i = 0, list = tokens; i < list.length; i += 1) {
        var token = list[i];

        if (token.type === 'references') {
          totalSymbols++;
        }
      }

      if (totalSymbols === 0) {
        var msg = 'linter-no-symbols';
        errors.push({
          from: CodeMirror.Pos(0, 0),
          message: msg,
          severity: 'warning',
          to: CodeMirror.Pos(0, 0)
        });
      }
    } catch (exception) {
      var msg$1 = exception.message;
      var startLine = 0;
      var endLine = 0;
      var startCol = 0;
      var endCol = 0;

      if (exception.hash) {
        var hash = exception.hash;

        if (hash.loc) {
          startLine = hash.loc.first_line > 0 ? hash.loc.first_line - 1 : 0;
          endLine = hash.loc.last_line > 0 ? hash.loc.last_line - 1 : 0;
          startCol = hash.loc.first_column > 0 ? hash.loc.first_column - 1 : 0;
          endCol = hash.loc.last_column > 0 ? hash.loc.last_column - 1 : 0;
        }
      }

      errors.push({
        from: CodeMirror.Pos(startLine, startCol),
        message: msg$1,
        severity: 'error',
        to: CodeMirror.Pos(endLine, endCol)
      });
    }
  };

  return VelocityLint;
}(AbstractLanguageLint);

var FreemarkerModeLint =
/*@__PURE__*/
function (AbstractLanguageLint$$1) {
  function FreemarkerModeLint() {
    AbstractLanguageLint$$1.call(this, 'freemarker');
  }

  if (AbstractLanguageLint$$1) FreemarkerModeLint.__proto__ = AbstractLanguageLint$$1;
  FreemarkerModeLint.prototype = Object.create(AbstractLanguageLint$$1 && AbstractLanguageLint$$1.prototype);
  FreemarkerModeLint.prototype.constructor = FreemarkerModeLint;

  FreemarkerModeLint.prototype.parse = function parse(content) {
    var symbols = [];
    var parser = new freemarkerParser.Parser();
    var result = parser.parse(content);

    for (var i = 0, list = result.tokens; i < list.length; i += 1) {
      var token = list[i];

      if (token.type === 'Interpolation') {
        symbols.push(new TemplateSymbol(token.params, 'string'));
      }
    }

    return symbols;
  };

  FreemarkerModeLint.prototype.define = function define() {
    var this$1 = this;
    CodeMirror.defineMode(this.name(), function (config, parserConfig) {
      return {
        token: function token(stream, state) {
          var ch;

          if (stream.match('${')) {
            // tslint:disable-next-line
            while ((ch = stream.next()) != null) {
              if (ch === '}') {
                return this$1.name();
              }
            }
          }

          while (stream.next() != null && !stream.match('${', false)) {// Read it but don't do anything
          }

          return null;
        }
      };
    });
    AbstractLanguageLint$$1.prototype.define.call(this);
  };

  FreemarkerModeLint.prototype.validate = function validate(text, errors) {
    try {
      var parser = new freemarkerParser.Parser();
      var result = parser.parse(text);

      if (result.ast && result.ast.errors) {
        for (var i = 0, list = result.ast.errors; i < list.length; i += 1) {
          var error = list[i];
          var startLine = error.loc.start.line > 0 ? error.loc.start.line - 1 : 0;
          var startCol = error.loc.start.column > 0 ? error.loc.start.column - 1 : 0;
          var endLine = error.loc.end.line > 0 ? error.loc.end.line - 1 : 0;
          var endCol = error.loc.end.column > 0 ? error.loc.end.column - 1 : 0;
          errors.push({
            from: CodeMirror.Pos(startLine, startCol),
            message: error.message,
            severity: 'error',
            to: CodeMirror.Pos(endLine, endCol)
          });
        }
      }

      var totalSymbols = 0;

      for (var i$1 = 0, list$1 = result.tokens; i$1 < list$1.length; i$1 += 1) {
        var token = list$1[i$1];

        if (token.type === 'Interpolation') {
          totalSymbols++;
        }
      }

      if (totalSymbols === 0) {
        var msg = 'linter-no-symbols';
        errors.push({
          from: CodeMirror.Pos(0, 0),
          message: msg,
          severity: 'warning',
          to: CodeMirror.Pos(0, 0)
        });
      }
    } catch (exception) {
      errors.push({
        from: CodeMirror.Pos(0, 0),
        message: exception.message,
        severity: 'error',
        to: CodeMirror.Pos(0, 0)
      });
    }
  };

  return FreemarkerModeLint;
}(AbstractLanguageLint);

function objectWithoutProperties$8(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}
/* tslint:disable */


require('codemirror/mode/sql/sql');

require('codemirror/addon/hint/show-hint');

require('codemirror/addon/hint/sql-hint');

require('codemirror/addon/edit/matchbrackets');

var TextEditor = function TextEditor(ref) {
  var id = ref.id;
  var rest = objectWithoutProperties$8(ref, ["id"]);
  var props = rest; // Set default options here

  return React.createElement("div", {
    "data-testid": "text-editor-" + (id ? toValidHtmlId(id) : 'codemirror'),
    className: 'text-editor'
  }, React.createElement(reactCodemirror2.UnControlled, Object.assign({}, props)));
};

var UnrecoverableError = function UnrecoverableError(ref) {
  var i18nTitle = ref.i18nTitle;
  var i18nInfo = ref.i18nInfo;
  var i18nHelp = ref.i18nHelp;
  var i18nRefreshLabel = ref.i18nRefreshLabel;
  var i18nReportIssue = ref.i18nReportIssue;
  var i18nShowErrorInfoLabel = ref.i18nShowErrorInfoLabel;
  var error = ref.error;
  var errorInfo = ref.errorInfo;
  var ref$1 = React.useState(false);
  var showErrorInfo = ref$1[0];
  var setShowErrorInfo = ref$1[1];

  var toggleErrorInfo = function toggleErrorInfo() {
    return setShowErrorInfo(!showErrorInfo);
  };

  return React.createElement(Container, null, React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Icon, {
    name: 'error-circle-o'
  }), React.createElement(patternflyReact.EmptyState.Title, null, i18nTitle), React.createElement(patternflyReact.EmptyState.Info, null, i18nInfo), React.createElement(patternflyReact.EmptyState.Help, null, i18nHelp), React.createElement(patternflyReact.EmptyState.Action, null, React.createElement(ButtonLink, {
    "data-testid": 'unrecoverable-error-refresh-button',
    href: '.',
    as: 'primary',
    size: 'lg'
  }, i18nRefreshLabel)), React.createElement(patternflyReact.EmptyState.Action, {
    secondary: true
  }, error && React.createElement(ButtonLink, {
    "data-testid": 'unrecoverable-error-show-error-button',
    onClick: toggleErrorInfo
  }, i18nShowErrorInfoLabel), React.createElement("a", {
    "data-testid": 'unrecoverable-error-report-issue-link',
    className: 'btn btn-default',
    href: 'https://github.com/syndesisio/syndesis/issues/new?template=simple.md&labels=cat/bug&title=Error%20report'
  }, i18nReportIssue)), showErrorInfo && error && React.createElement(patternflyReact.EmptyState.Help, {
    style: {
      textAlign: 'left'
    }
  }, React.createElement(reactCore.Text, null, error.name, ": ", error.message), errorInfo && React.createElement("pre", null, errorInfo.componentStack))));
};

var IframeWrapper =
/*@__PURE__*/
function (superclass) {
  function IframeWrapper() {
    superclass.apply(this, arguments);
  }

  if (superclass) IframeWrapper.__proto__ = superclass;
  IframeWrapper.prototype = Object.create(superclass && superclass.prototype);
  IframeWrapper.prototype.constructor = IframeWrapper;

  IframeWrapper.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, {
      style: {
        display: 'flex'
      }
    }, React.createElement("div", {
      style: {
        background: '#fff',
        borderTop: '2px solid transparent',
        boxShadow: '0 1px 1px rgba(3, 3, 3, 0.175)',
        flex: '1'
      }
    }, this.props.children));
  };

  return IframeWrapper;
}(React.Component);

var ConnectionCard =
/*@__PURE__*/
function (superclass) {
  function ConnectionCard(props) {
    var this$1 = this;
    superclass.call(this, props);

    this.onToggle = function (isMenuOpen) {
      this$1.setState({
        isMenuOpen: isMenuOpen
      });
    };

    this.onMenuSelect = function (event) {
      this$1.setState({
        isMenuOpen: !this$1.state.isMenuOpen
      });
    };

    this.state = {
      isMenuOpen: false,
      showDeleteDialog: false
    };

    if (this.props.menuProps) {
      this.doCancel = this.doCancel.bind(this);
      this.doDelete = this.doDelete.bind(this);
      this.showDeleteDialog = this.showDeleteDialog.bind(this);
    }
  }

  if (superclass) ConnectionCard.__proto__ = superclass;
  ConnectionCard.prototype = Object.create(superclass && superclass.prototype);
  ConnectionCard.prototype.constructor = ConnectionCard;

  ConnectionCard.prototype.doCancel = function doCancel() {
    this.setState({
      showDeleteDialog: false
    });
  };

  ConnectionCard.prototype.doDelete = function doDelete() {
    this.setState({
      showDeleteDialog: false
    });

    if (this.props.menuProps) {
      this.props.menuProps.onDelete();
    }
  };

  ConnectionCard.prototype.showDeleteDialog = function showDeleteDialog() {
    this.setState({
      showDeleteDialog: true
    });
  };

  ConnectionCard.prototype.render = function render() {
    return React.createElement(React.Fragment, null, this.props.menuProps && React.createElement(ConfirmationDialog, {
      buttonStyle: exports.ConfirmationButtonStyle.DANGER,
      i18nCancelButtonText: this.props.menuProps.i18nCancelLabel,
      i18nConfirmButtonText: this.props.menuProps.i18nDeleteLabel,
      i18nConfirmationMessage: this.props.menuProps.i18nDeleteModalMessage,
      i18nTitle: this.props.menuProps.i18nDeleteModalTitle,
      icon: exports.ConfirmationIconType.DANGER,
      showDialog: this.state.showDeleteDialog,
      onCancel: this.doCancel,
      onConfirm: this.doDelete
    }), React.createElement(patternflyReact.Card, {
      "data-testid": "connection-card-" + toValidHtmlId(this.props.name) + "-card",
      matchHeight: true,
      className: 'connection-card'
    }, this.props.techPreview && React.createElement("div", {
      className: "connection-card__tech-preview",
      "data-testid": 'connection-card-tech-preview-heading'
    }, this.props.i18nTechPreview, '  ', React.createElement(reactCore.Popover, {
      bodyContent: React.createElement(React.Fragment, null, this.props.techPreviewPopoverHtml),
      "aria-label": this.props.i18nTechPreview,
      position: 'left'
    }, React.createElement(patternflyReact.Icon, {
      type: 'pf',
      name: 'info'
    }))), this.props.menuProps && React.createElement("div", {
      className: "connection-card__dropdown"
    }, React.createElement(reactCore.Dropdown, {
      id: "connection-" + this.props.name + "-menu",
      onSelect: this.onMenuSelect,
      toggle: React.createElement(reactCore.KebabToggle, {
        id: "connection-card-kebab",
        onToggle: this.onToggle
      }),
      isOpen: this.state.isMenuOpen,
      isPlain: true,
      dropdownItems: [React.createElement(PfDropdownItem, {
        key: "view-action"
      }, React.createElement(reactRouterDom.Link, {
        className: "pf-c-dropdown__menu-item",
        "data-testid": 'connection-card-view-action',
        to: this.props.href,
        role: 'menuitem',
        tabIndex: 1
      }, this.props.menuProps.i18nViewLabel)), React.createElement(PfDropdownItem, {
        key: "edit-action"
      }, React.createElement(reactRouterDom.Link, {
        className: "pf-c-dropdown__menu-item",
        "data-testid": 'connection-card-edit-action',
        to: this.props.menuProps.editHref,
        role: 'menuitem',
        tabIndex: 2
      }, this.props.menuProps.i18nEditLabel)), React.createElement(PfDropdownItem, {
        disabled: !this.props.menuProps.isDeleteEnabled,
        key: "delete-action",
        onClick: this.showDeleteDialog
      }, !this.props.menuProps.isDeleteEnabled ? React.createElement(reactCore.Tooltip, {
        content: this.props.i18nCannotDelete,
        position: 'bottom'
      }, React.createElement(reactCore.Button, {
        className: "pf-c-dropdown__menu-item",
        isDisabled: true,
        variant: 'link'
      }, this.props.menuProps.i18nDeleteLabel)) : React.createElement("a", {
        className: "pf-c-dropdown__menu-item",
        "data-testid": 'connection-card-delete-action',
        href: 'javascript:void(0)',
        role: 'menuitem',
        tabIndex: 3
      }, this.props.menuProps.i18nDeleteLabel))],
      position: reactCore.DropdownPosition.right
    })), React.createElement(reactRouterDom.Link, {
      "data-testid": 'connection-card-details-link',
      to: this.props.href,
      className: 'connection-card__content'
    }, React.createElement(patternflyReact.Card.Body, null, React.createElement("div", {
      className: 'connection-card__body'
    }, React.createElement("div", {
      className: "connection-card__icon"
    }, this.props.icon), React.createElement(reactCore.Title, {
      size: "lg",
      className: "connection-card__title h2",
      "data-testid": 'connection-card-title'
    }, this.props.name), React.createElement(reactCore.Text, {
      className: "connection-card__description"
    }, this.props.description))), this.props.configurationRequired && React.createElement(patternflyReact.Card.Footer, {
      className: 'connection-card__footer--config-required alert alert-warning',
      "data-testid": 'connection-card-config-required-footer'
    }, React.createElement(patternflyReact.Icon, {
      type: 'pf',
      name: 'warning-triangle-o',
      size: '2x'
    }), this.props.i18nConfigurationRequired))));
  };

  return ConnectionCard;
}(React.PureComponent);
/**
 * Provides the layout for the integration editor. It uses the PatternFly Wizard
 * component under the hood.
 * The footer is pre-defined and follows the PF Wizard pattern, with
 * Cancel/Previous/Next buttons.
 *
 * @todo in the CSS we use hardcoded values for the heights of various
 * elements of the page to be able to size the element to take all the available
 * height and show the right scrollbars.
 * We should really find a smarter way to handle this.
 */


var ConnectionCreatorLayout = function ConnectionCreatorLayout(ref) {
  var header = ref.header;
  var content = ref.content;
  return React.createElement("div", {
    className: 'integration-editor-layout'
  }, React.createElement("div", {
    className: 'integration-editor-layout__header'
  }, header), React.createElement("div", {
    className: 'integration-editor-layout__body'
  }, React.createElement("div", {
    className: 'integration-editor-layout__contentOuter'
  }, React.createElement("div", {
    className: 'integration-editor-layout__contentInner'
  }, content))));
};

var ConnectionDetailsForm =
/*@__PURE__*/
function (superclass) {
  function ConnectionDetailsForm() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectionDetailsForm.__proto__ = superclass;
  ConnectionDetailsForm.prototype = Object.create(superclass && superclass.prototype);
  ConnectionDetailsForm.prototype.constructor = ConnectionDetailsForm;

  ConnectionDetailsForm.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(Container, null, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, null, this.props.i18nTitle)), React.createElement(patternflyReact.Card.Body, null, React.createElement("form", {
      className: "required-pf",
      role: "form",
      onSubmit: this.props.handleSubmit
    }, this.props.validationResults.map(function (e, idx) {
      return React.createElement(patternflyReact.Alert, {
        key: idx,
        type: e.type
      }, e.message);
    }), this.props.children, React.createElement("div", null, this.props.isEditing ? React.createElement(patternflyReact.Button, {
      "data-testid": 'connection-details-form-validate-button',
      bsStyle: "default",
      disabled: this.props.isWorking || !this.props.isValid,
      onClick: this.props.onValidate
    }, this.props.isWorking ? React.createElement(Loader, {
      size: 'sm',
      inline: true
    }) : null, this.props.i18nValidateLabel) : React.createElement(patternflyReact.Button, {
      "data-testid": 'connection-details-form-edit-button',
      bsStyle: "primary",
      onClick: this.props.onStartEditing
    }, this.props.i18nEditLabel)))), this.props.isEditing ? React.createElement(patternflyReact.Card.Footer, null, React.createElement(patternflyReact.Button, {
      "data-testid": 'connection-details-form-cancel-button',
      bsStyle: "default",
      className: "connection-details-form__editButton",
      disabled: this.props.isWorking,
      onClick: this.props.onCancelEditing
    }, this.props.i18nCancelLabel), React.createElement(patternflyReact.Button, {
      "data-testid": 'connection-details-form-save-button',
      bsStyle: "primary",
      className: "connection-details-form__editButton",
      disabled: this.props.isWorking || !this.props.isValid,
      onClick: this.props.handleSubmit
    }, this.props.i18nSaveLabel)) : null))));
  };

  return ConnectionDetailsForm;
}(React.Component);

ConnectionDetailsForm.defaultProps = {
  validationResults: []
};
/**
 * Line 1: icon, name, edit icon (makes name editable when clicked)
 * Line 2: description label and value
 * Line 3: usage label and value
 */

var ConnectionDetailsHeader =
/*@__PURE__*/
function (superclass) {
  function ConnectionDetailsHeader() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectionDetailsHeader.__proto__ = superclass;
  ConnectionDetailsHeader.prototype = Object.create(superclass && superclass.prototype);
  ConnectionDetailsHeader.prototype.constructor = ConnectionDetailsHeader;

  ConnectionDetailsHeader.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, {
      variant: 'light'
    }, React.createElement(reactCore.Stack, {
      gutter: "md"
    }, React.createElement(reactCore.Split, {
      gutter: "md",
      className: 'connection-details-header__row'
    }, this.props.connectionIcon, React.createElement(InlineTextEdit, {
      className: "connection-details-header__connectionName",
      value: this.props.connectionName,
      allowEditing: this.props.allowEditing && !this.props.isWorking,
      placeholder: this.props.i18nNamePlaceholder,
      isTextArea: false,
      onChange: this.props.onChangeName
    })), React.createElement(reactCore.TextContent, null, React.createElement(reactCore.TextList, {
      component: reactCore.TextListVariants.dl
    }, React.createElement(reactCore.TextListItem, {
      className: "connection-details-header__propertyLabel",
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nDescriptionLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, React.createElement(InlineTextEdit, {
      value: this.props.connectionDescription || '',
      allowEditing: this.props.allowEditing && !this.props.isWorking,
      i18nPlaceholder: this.props.i18nDescriptionPlaceholder,
      isTextArea: true,
      onChange: this.props.onChangeDescription
    })), React.createElement(reactCore.TextListItem, {
      className: "connection-details-header__propertyLabel",
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nUsageLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.i18nUsageMessage)))));
  };

  return ConnectionDetailsHeader;
}(React.Component);

var ConnectionDetailsOauthCard = function ConnectionDetailsOauthCard(ref) {
  var i18nTitle = ref.i18nTitle;
  var i18nDescription = ref.i18nDescription;
  var i18nValidateButton = ref.i18nValidateButton;
  var i18nReconnectButton = ref.i18nReconnectButton;
  var onValidate = ref.onValidate;
  var isValidating = ref.isValidating;
  var onReconnect = ref.onReconnect;
  var isReconnecting = ref.isReconnecting;
  return React.createElement(reactCore.PageSection, null, React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, null, i18nTitle)), React.createElement(patternflyReact.Card.Body, null, i18nDescription), React.createElement(patternflyReact.Card.Footer, null, React.createElement(ButtonLink, {
    disabled: isValidating,
    onClick: onValidate
  }, i18nValidateButton, ' ', isValidating && React.createElement(Loader, {
    inline: true,
    size: 'xs'
  })), "\xA0", React.createElement(ButtonLink, {
    disabled: isReconnecting,
    onClick: onReconnect,
    as: 'primary'
  }, i18nReconnectButton, ' ', isReconnecting && React.createElement(Loader, {
    inline: true,
    size: 'xs'
  })))));
};

var ConnectionsGrid =
/*@__PURE__*/
function (superclass) {
  function ConnectionsGrid() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectionsGrid.__proto__ = superclass;
  ConnectionsGrid.prototype = Object.create(superclass && superclass.prototype);
  ConnectionsGrid.prototype.constructor = ConnectionsGrid;

  ConnectionsGrid.prototype.render = function render() {
    return React.createElement(patternflyReact.CardGrid, {
      fluid: true,
      matchHeight: true
    }, React.createElement(patternflyReact.CardGrid.Row, null, this.props.children));
  };

  return ConnectionsGrid;
}(React.Component);

var ConnectionsGridCell =
/*@__PURE__*/
function (superclass) {
  function ConnectionsGridCell() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectionsGridCell.__proto__ = superclass;
  ConnectionsGridCell.prototype = Object.create(superclass && superclass.prototype);
  ConnectionsGridCell.prototype.constructor = ConnectionsGridCell;

  ConnectionsGridCell.prototype.render = function render() {
    return React.createElement(patternflyReact.CardGrid.Col, {
      xs: 6,
      md: 3
    }, this.props.children);
  };

  return ConnectionsGridCell;
}(React.Component);

var ConnectionSkeleton = function ConnectionSkeleton(props) {
  return React.createElement(patternflyReact.Card, {
    matchHeight: true
  }, React.createElement(patternflyReact.Card.Body, null, React.createElement(ContentLoader, Object.assign({
    height: 250,
    width: 200,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb"
  }, props), React.createElement("circle", {
    cx: "100",
    cy: "50",
    r: "40"
  }), React.createElement("rect", {
    x: "5",
    y: "125",
    rx: "5",
    ry: "5",
    width: "190",
    height: "30"
  }), React.createElement("rect", {
    x: "25",
    y: "180",
    rx: "5",
    ry: "5",
    width: "150",
    height: "15"
  }), React.createElement("rect", {
    x: "40",
    y: "205",
    rx: "5",
    ry: "5",
    width: "120",
    height: "15"
  }))));
};

var ConnectionsListView =
/*@__PURE__*/
function (superclass) {
  function ConnectionsListView() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectionsListView.__proto__ = superclass;
  ConnectionsListView.prototype = Object.create(superclass && superclass.prototype);
  ConnectionsListView.prototype.constructor = ConnectionsListView;

  ConnectionsListView.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(reactCore.PageSection, {
      noPadding: true,
      variant: 'light'
    }, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, React.createElement(ButtonLink, {
      "data-testid": 'connections-list-view-create-connection-button',
      href: this.props.linkToConnectionCreate,
      as: this.props.createConnectionButtonStyle || 'primary'
    }, this.props.i18nLinkCreateConnection)))), React.createElement(reactCore.PageSection, null, this.props.children));
  };

  return ConnectionsListView;
}(React.Component);

var ConnectorAuthorization = function ConnectorAuthorization(ref) {
  var i18nTitle = ref.i18nTitle;
  var i18nDescription = ref.i18nDescription;
  var i18nConnectButton = ref.i18nConnectButton;
  var isConnecting = ref.isConnecting;
  var onConnect = ref.onConnect;
  return React.createElement(patternflyReact.Card, {
    style: {
      margin: 'auto',
      maxWidth: 600
    }
  }, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, {
    className: "metrics-uptime__header"
  }, React.createElement("div", null, i18nTitle))), React.createElement(patternflyReact.Card.Body, null, React.createElement("p", null, i18nDescription)), React.createElement(patternflyReact.Card.Footer, null, React.createElement(ButtonLink, {
    onClick: onConnect,
    disabled: isConnecting,
    as: 'primary'
  }, i18nConnectButton, ' ', isConnecting && React.createElement(Loader, {
    size: 'xs',
    inline: true
  }))));
};
/**
 * A component to render a save form, to be used in the integration
 * editor. This does *not* build the form itself, form's field should be passed
 * as the `children` value.
 * @see [i18nTitle]{@link IConnectorConfigurationFormProps#i18nTitle}
 */


var ConnectorConfigurationForm =
/*@__PURE__*/
function (superclass) {
  function ConnectorConfigurationForm() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectorConfigurationForm.__proto__ = superclass;
  ConnectorConfigurationForm.prototype = Object.create(superclass && superclass.prototype);
  ConnectorConfigurationForm.prototype.constructor = ConnectorConfigurationForm;

  ConnectorConfigurationForm.prototype.render = function render() {
    return React.createElement(Container, null, React.createElement("form", {
      className: "required-pf",
      role: "form",
      onSubmit: this.props.handleSubmit,
      style: {
        margin: 'auto',
        maxWidth: 600
      }
    }, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, React.createElement("div", {
      className: "card-pf-heading"
    }, this.props.i18nFormTitle && React.createElement("div", {
      className: "card-pf-title"
    }, this.props.i18nFormTitle)), React.createElement("div", {
      className: "card-pf-body"
    }, this.props.validationResults.map(function (e, idx) {
      return React.createElement(patternflyReact.Alert, {
        key: idx,
        type: e.type
      }, e.message);
    }), this.props.children), React.createElement("div", {
      className: "card-pf-footer"
    }, React.createElement(ButtonLink, {
      "data-testid": 'connection-creator-layout-back-button',
      href: this.props.backHref,
      className: 'wizard-pf-back'
    }, React.createElement("i", {
      className: "fa fa-angle-left"
    }), " Back"), "\xA0", this.props.onValidate && React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
      "data-testid": 'connection-creator-layout-back-button',
      onClick: this.props.onValidate,
      className: 'wizard-pf-back',
      disabled: this.props.isValidating || this.props.isNextLoading || this.props.isNextDisabled
    }, this.props.isValidating ? React.createElement(Loader, {
      size: 'xs',
      inline: true
    }) : null, "Validate"), "\xA0"), React.createElement(ButtonLink, {
      "data-testid": 'connection-creator-layout-next-button',
      onClick: this.props.onNext,
      as: 'primary',
      className: 'wizard-pf-next',
      disabled: this.props.isNextLoading || this.props.isNextDisabled
    }, this.props.isNextLoading ? React.createElement(Loader, {
      size: 'xs',
      inline: true
    }) : null, this.props.isLastStep ? this.props.i18nSave : React.createElement(React.Fragment, null, this.props.i18nNext, " ", React.createElement("i", {
      className: "fa fa-angle-right"
    }))))))));
  };

  return ConnectorConfigurationForm;
}(React.Component);

ConnectorConfigurationForm.defaultProps = {
  validationResults: []
};
/**
 * Provides the layout for the integration editor. It uses the PatternFly Wizard
 * component under the hood.
 * The footer is pre-defined and follows the PF Wizard pattern, with
 * Cancel/Previous/Next buttons.
 *
 * @todo in the CSS we use hardcoded values for the heights of various
 * elements of the page to be able to size the element to take all the available
 * height and show the right scrollbars.
 * We should really find a smarter way to handle this.
 */

var ApiConnectorCreatorLayout = function ApiConnectorCreatorLayout(ref) {
  var header = ref.header;
  var content = ref.content;
  return React.createElement("div", {
    className: 'integration-editor-layout'
  }, React.createElement("div", {
    className: 'integration-editor-layout__header api-connector-creator-layout__header'
  }, header), React.createElement("div", {
    className: 'integration-editor-layout__body'
  }, React.createElement("div", {
    className: 'integration-editor-layout__contentOuter'
  }, React.createElement("div", {
    className: 'integration-editor-layout__contentInner'
  }, content))));
};

var ApiConnectorDetailCard =
/*@__PURE__*/
function (superclass) {
  function ApiConnectorDetailCard() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiConnectorDetailCard.__proto__ = superclass;
  ApiConnectorDetailCard.prototype = Object.create(superclass && superclass.prototype);
  ApiConnectorDetailCard.prototype.constructor = ApiConnectorDetailCard;

  ApiConnectorDetailCard.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      className: "api-connector-card"
    }, React.createElement(patternflyReact.CardBody, null, React.createElement("div", {
      className: 'api-connector-card__content'
    }, React.createElement("div", null, React.createElement("img", {
      className: "api-connector-card__icon",
      src: this.props.icon
    })), React.createElement("div", {
      className: "api-connector__title h2",
      "data-testid": 'api-connector-detail-card-title'
    }, this.props.name), React.createElement(reactCore.Text, {
      className: "api-connector-card__description"
    }, this.props.description))));
  };

  return ApiConnectorDetailCard;
}(React.Component);

var ApiConnectorDetailsForm =
/*@__PURE__*/
function (superclass) {
  function ApiConnectorDetailsForm() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiConnectorDetailsForm.__proto__ = superclass;
  ApiConnectorDetailsForm.prototype = Object.create(superclass && superclass.prototype);
  ApiConnectorDetailsForm.prototype.constructor = ApiConnectorDetailsForm;

  ApiConnectorDetailsForm.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      className: "api-connector-details-form__card"
    }, this.props.apiConnectorName && React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, {
      className: "api-connector-details-form__title"
    }, this.props.apiConnectorName)), React.createElement(patternflyReact.Card.Body, {
      className: "api-connector-details-form__body"
    }, React.createElement("form", {
      className: "required-pf",
      role: "form",
      onSubmit: this.props.handleSubmit
    }, React.createElement("fieldset", {
      disabled: !this.props.isEditing
    }, React.createElement("div", {
      className: "form-group api-connector-details-form__iconContainer"
    }, React.createElement("label", {
      className: "control-label",
      htmlFor: "iconFileInput"
    }, this.props.i18nIconLabel), React.createElement("div", null, this.props.apiConnectorIcon ? React.createElement("img", {
      className: "api-connector-details-form__icon",
      src: this.props.apiConnectorIcon
    }) : React.createElement("div", {
      className: "api-connector-details-form__icon"
    }, React.createElement("i", {
      className: "fa fa-upload"
    })), React.createElement("input", {
      "data-testid": 'api-connector-details-form-icon-file-input',
      type: "file",
      id: "iconFileInput",
      onChange: this.props.onUploadImage
    }))), this.props.fields))), React.createElement(patternflyReact.Card.Footer, null, this.props.footer));
  };

  return ApiConnectorDetailsForm;
}(React.Component);

var ApiConnectorListItem =
/*@__PURE__*/
function (superclass) {
  function ApiConnectorListItem(props) {
    superclass.call(this, props);
    this.state = {
      showDeleteDialog: false
    };
    this.doCancel = this.doCancel.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.showDeleteDialog = this.showDeleteDialog.bind(this);
  }

  if (superclass) ApiConnectorListItem.__proto__ = superclass;
  ApiConnectorListItem.prototype = Object.create(superclass && superclass.prototype);
  ApiConnectorListItem.prototype.constructor = ApiConnectorListItem;

  ApiConnectorListItem.prototype.doCancel = function doCancel() {
    this.setState({
      showDeleteDialog: false
    });
  };

  ApiConnectorListItem.prototype.doDelete = function doDelete() {
    this.setState({
      showDeleteDialog: false
    }); // TODO: disable components while delete is processing

    this.props.onDelete(this.props.apiConnectorId);
  };

  ApiConnectorListItem.prototype.getDeleteTooltip = function getDeleteTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "deleteTip"
    }, this.props.i18nDeleteTip ? this.props.i18nDeleteTip : this.props.i18nDelete);
  };

  ApiConnectorListItem.prototype.getDetailsTooltip = function getDetailsTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "detailsTip"
    }, this.props.i18nDetailsTip ? this.props.i18nDetailsTip : this.props.i18nDetails);
  };

  ApiConnectorListItem.prototype.showDeleteDialog = function showDeleteDialog() {
    this.setState({
      showDeleteDialog: true
    });
  };

  ApiConnectorListItem.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(ConfirmationDialog, {
      buttonStyle: exports.ConfirmationButtonStyle.DANGER,
      i18nCancelButtonText: this.props.i18nCancelLabel,
      i18nConfirmButtonText: this.props.i18nDelete,
      i18nConfirmationMessage: this.props.i18nDeleteModalMessage,
      i18nTitle: this.props.i18nDeleteModalTitle,
      icon: exports.ConfirmationIconType.DANGER,
      showDialog: this.state.showDeleteDialog,
      onCancel: this.doCancel,
      onConfirm: this.doDelete
    }), React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "api-connector-list-item-" + toValidHtmlId(this.props.apiConnectorName) + "-list-item",
      actions: React.createElement(React.Fragment, null, React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getDetailsTooltip(),
        placement: "top"
      }, React.createElement(ButtonLink, {
        "data-testid": 'api-connector-list-item-details-button',
        href: this.props.detailsPageLink,
        as: 'default'
      }, this.props.i18nDetails)), React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getDeleteTooltip(),
        placement: "top"
      }, React.createElement(patternflyReact.Button, {
        "data-testid": 'api-connector-list-item-delete-button',
        bsStyle: "default",
        disabled: this.props.usedBy !== 0,
        onClick: this.showDeleteDialog
      }, this.props.i18nDelete))),
      additionalInfo: [React.createElement(patternflyReact.ListViewInfoItem, {
        key: 1
      }, this.props.i18nUsedByMessage)],
      description: this.props.apiConnectorDescription ? this.props.apiConnectorDescription : '',
      heading: this.props.apiConnectorName,
      hideCloseIcon: true,
      leftContent: this.props.apiConnectorIcon ? React.createElement("div", {
        className: "blank-slate-pf-icon"
      }, React.createElement("img", {
        src: this.props.apiConnectorIcon,
        alt: this.props.apiConnectorName,
        width: 46
      })) : null,
      stacked: true
    }));
  };

  return ApiConnectorListItem;
}(React.Component); // tslint:disable react-unused-props-and-state


var ApiConnectorListSkeleton = function ApiConnectorListSkeleton(ref) {
  var width = ref.width;
  var style = ref.style;
  return React.createElement(ContentLoader, {
    height: 226,
    width: width,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: style
  }, React.createElement("circle", {
    cx: "30",
    cy: "40",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "40",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "35",
    rx: "5",
    ry: "5",
    width: "200",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "35",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "110",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "110",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "105",
    rx: "5",
    ry: "5",
    width: "180",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "105",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "180",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "180",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "175",
    rx: "5",
    ry: "5",
    width: "195",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "175",
    rx: "5",
    ry: "5",
    width: "85",
    height: "15"
  }));
};

var ApiConnectorListView =
/*@__PURE__*/
function (superclass) {
  function ApiConnectorListView() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiConnectorListView.__proto__ = superclass;
  ApiConnectorListView.prototype = Object.create(superclass && superclass.prototype);
  ApiConnectorListView.prototype.constructor = ApiConnectorListView;

  ApiConnectorListView.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getCreateConnectorTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'api-connector-list-view-create-button',
      href: this.props.linkCreateApiConnector,
      as: 'primary'
    }, this.props.i18nLinkCreateApiConnector)))), this.props.i18nTitle !== '' && React.createElement(reactCore.Title, {
      size: "xl"
    }, this.props.i18nTitle), this.props.i18nDescription !== '' && React.createElement(reactCore.Text, {
      dangerouslySetInnerHTML: {
        __html: this.props.i18nDescription
      }
    }), this.props.children ? React.createElement(patternflyReact.ListView, null, this.props.children) : React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Icon, null), React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyStateTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyStateInfo), React.createElement(patternflyReact.EmptyState.Action, null, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getCreateConnectorTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'api-connector-list-view-empty-state-create-button',
      href: this.props.linkCreateApiConnector,
      as: 'primary'
    }, this.props.i18nLinkCreateApiConnector)))));
  };

  ApiConnectorListView.prototype.getCreateConnectorTooltip = function getCreateConnectorTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "createTip"
    }, this.props.i18nLinkCreateApiConnectorTip ? this.props.i18nLinkCreateApiConnectorTip : this.props.i18nLinkCreateApiConnector);
  };

  return ApiConnectorListView;
}(React.Component);

var ApiConnectorReview =
/*@__PURE__*/
function (superclass) {
  function ApiConnectorReview() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiConnectorReview.__proto__ = superclass;
  ApiConnectorReview.prototype = Object.create(superclass && superclass.prototype);
  ApiConnectorReview.prototype.constructor = ApiConnectorReview;

  ApiConnectorReview.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, null, this.props.i18nTitle)), React.createElement(patternflyReact.Card.Body, null, this.props.i18nValidationFallbackMessage ? React.createElement("h5", {
      className: "api-connector-review__validationFallbackMessage"
    }, this.props.i18nValidationFallbackMessage) : React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
      headingLevel: "h5",
      size: "md",
      className: "customization-details__heading"
    }, this.props.i18nApiDefinitionHeading), React.createElement(Container, null, React.createElement(reactCore.TextList, {
      component: reactCore.TextListVariants.dl
    }, React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nNameLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.apiConnectorName), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nDescriptionLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.apiConnectorDescription))), React.createElement(reactCore.Title, {
      headingLevel: "h5",
      size: "md",
      className: "customization-details__heading"
    }, this.props.i18nImportedHeading), React.createElement(Container, null, React.createElement(reactCore.Text, {
      component: reactCore.TextVariants.p,
      dangerouslySetInnerHTML: {
        __html: this.props.i18nOperationsHtmlMessage
      }
    })), this.props.i18nOperationTagHtmlMessages && React.createElement(reactCore.TextList, {
      className: "api-connector-review__tagMessageList"
    }, this.props.i18nOperationTagHtmlMessages.map(function (msg, index) {
      return React.createElement(reactCore.TextListItem, {
        key: index,
        dangerouslySetInnerHTML: {
          __html: msg
        }
      });
    })), this.props.i18nErrorsHeading && this.props.errorMessages && React.createElement(reactCore.Title, {
      headingLevel: "h5",
      size: "md",
      className: "customization-details__heading"
    }, this.props.i18nErrorsHeading), this.props.errorMessages ? this.props.errorMessages.map(function (errorMsg, index) {
      return React.createElement(reactCore.Text, {
        component: reactCore.TextVariants.p,
        key: index
      }, index + 1, ". ", errorMsg);
    }) : null, this.props.i18nWarningsHeading && this.props.warningMessages && React.createElement(reactCore.Title, {
      headingLevel: "h5",
      size: "md",
      className: "customization-details__heading"
    }, this.props.i18nWarningsHeading), this.props.warningMessages ? this.props.warningMessages.map(function (warningMsg, index) {
      return React.createElement(reactCore.Text, {
        key: index,
        component: reactCore.TextVariants.p
      }, index + 1, ". ", warningMsg);
    }) : null)));
  };

  return ApiConnectorReview;
}(React.Component);

function isAuthTypeValid(authType) {
  return ['apiKey', 'basic', 'none'].find(function (v) {
    return v === authType;
  }) !== undefined;
}

var ApiClientConnectorCreateSecurity =
/*@__PURE__*/
function (superclass) {
  function ApiClientConnectorCreateSecurity(props) {
    superclass.call(this, props);
    this.state = {
      selectedType: this.props.authenticationTypeDefault || 'none',
      valid: isAuthTypeValid(this.props.authenticationTypeDefault)
    };
    this.onSelectType = this.onSelectType.bind(this);
    this.setAccessTokenUrl = this.setAccessTokenUrl.bind(this);
    this.setAuthorizationUrl = this.setAuthorizationUrl.bind(this);
  }

  if (superclass) ApiClientConnectorCreateSecurity.__proto__ = superclass;
  ApiClientConnectorCreateSecurity.prototype = Object.create(superclass && superclass.prototype);
  ApiClientConnectorCreateSecurity.prototype.constructor = ApiClientConnectorCreateSecurity;
  /**
   * The action fired when the user selects the authentication
   * type they want to use for the client connector.
   * @param newType
   */

  ApiClientConnectorCreateSecurity.prototype.onSelectType = function onSelectType(newType) {
    this.setState({
      selectedType: newType,

      /**
       * Check if the security type is either Basic or None, in which case the form
       * should be valid.
       */
      valid: isAuthTypeValid(newType)
    });
  };

  ApiClientConnectorCreateSecurity.prototype.setAccessTokenUrl = function setAccessTokenUrl(e) {
    this.setState({
      accessTokenUrl: e.currentTarget.value,
      valid: true
    });
  };

  ApiClientConnectorCreateSecurity.prototype.setAuthorizationUrl = function setAuthorizationUrl(e) {
    this.setState({
      authorizationUrl: e.currentTarget.value,
      valid: true
    });
  };

  ApiClientConnectorCreateSecurity.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(patternflyReact.Card, {
      style: {
        maxWidth: '600px',
        margin: ' auto'
      }
    }, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, null, this.props.i18nTitle)), React.createElement(patternflyReact.Card.Body, null, React.createElement(patternflyReact.FormGroup, {
      controlId: 'authenticationType',
      disabled: false
    }, this.props.authenticationTypes.map(function (authType, idx) {
      return React.createElement("div", {
        key: authType.value + '-' + idx
      }, React.createElement(patternflyReact.Radio, {
        id: 'authenticationType',
        "aria-label": 'Authentication Type',
        checked: this$1.state.selectedType === authType.value,
        name: 'authenticationType',
        onClick: function onClick() {
          return this$1.onSelectType(authType.value);
        },
        readOnly: true
      }, authType.label || this$1.props.i18nNoSecurity));
    }), this.state.selectedType.includes('oauth2') && React.createElement(React.Fragment, null, React.createElement(patternflyReact.FormGroup, {
      controlId: 'authorizationUrl',
      disabled: false
    }, React.createElement(patternflyReact.ControlLabel, null, this.props.i18nAuthorizationUrl), React.createElement(patternflyReact.FormControl, {
      type: 'text',
      value: this.state.authorizationUrl || this.props.authorizationUrl,
      onChange: this.setAuthorizationUrl
    })), React.createElement(patternflyReact.FormGroup, {
      controlId: 'accessTokenUrl',
      disabled: false
    }, React.createElement(patternflyReact.ControlLabel, null, this.props.i18nAccessTokenUrl), React.createElement(patternflyReact.FormControl, {
      type: 'text',
      value: this.state.accessTokenUrl || this.props.accessToken,
      onChange: this.setAccessTokenUrl
    }))))), React.createElement(patternflyReact.Card.Footer, null, React.createElement("div", null, React.createElement(ButtonLink, {
      href: this.props.backHref
    }, this.props.i18nBtnBack), "\xA0", React.createElement(ButtonLink, {
      onClick: function onClick() {
        return this$1.props.onNext(this$1.state.accessTokenUrl, this$1.state.selectedType, this$1.state.authorizationUrl);
      },
      as: 'primary',
      disabled: !this.state.valid
    }, this.props.i18nBtnNext))));
  };

  return ApiClientConnectorCreateSecurity;
}(React.Component);

var ApiClientConnectorCreateUpload =
/*@__PURE__*/
function (superclass) {
  function ApiClientConnectorCreateUpload() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiClientConnectorCreateUpload.__proto__ = superclass;
  ApiClientConnectorCreateUpload.prototype = Object.create(superclass && superclass.prototype);
  ApiClientConnectorCreateUpload.prototype.constructor = ApiClientConnectorCreateUpload;

  ApiClientConnectorCreateUpload.prototype.render = function render() {
    return (
      /**
       * TODO: Move drag and drop stuff to its own component,
       * keep this is as a list of options: Upload or Use a URL
       */
      React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, null, this.props.i18nTitle)), React.createElement(patternflyReact.Card.Body, null, React.createElement(DndFileChooser, {
        disableDropzone: this.props.dndDisabled,
        fileExtensions: '.json',
        i18nHelpMessage: this.props.i18nDndHelpMessage,
        i18nInstructions: this.props.i18nDndInstructions,
        i18nNoFileSelectedMessage: this.props.i18nDndNoFileSelectedMessage,
        i18nSelectedFileLabel: this.props.i18nDndSelectedFileLabel,
        i18nUploadFailedMessage: this.props.i18nDndUploadFailedMessage,
        i18nUploadSuccessMessage: this.props.i18nDndUploadSuccessMessage,
        onUploadAccepted: this.props.onDndUploadAccepted,
        onUploadRejected: this.props.onDndUploadRejected
      })))
    );
  };

  return ApiClientConnectorCreateUpload;
}(React.Component);

var ExtensionDetail =
/*@__PURE__*/
function (superclass) {
  function ExtensionDetail(props) {
    superclass.call(this, props);
    this.state = {
      showDeleteDialog: false
    };
    this.doCancel = this.doCancel.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.showDeleteDialog = this.showDeleteDialog.bind(this);
  }

  if (superclass) ExtensionDetail.__proto__ = superclass;
  ExtensionDetail.prototype = Object.create(superclass && superclass.prototype);
  ExtensionDetail.prototype.constructor = ExtensionDetail;

  ExtensionDetail.prototype.doCancel = function doCancel() {
    this.setState({
      showDeleteDialog: false
    });
  };

  ExtensionDetail.prototype.doDelete = function doDelete() {
    this.setState({
      showDeleteDialog: false
    }); // TODO: disable components while delete is processing

    this.props.onDelete();
  };

  ExtensionDetail.prototype.getDeleteTooltip = function getDeleteTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "deleteTip"
    }, this.props.i18nDeleteTip ? this.props.i18nDeleteTip : this.props.i18nDelete);
  };

  ExtensionDetail.prototype.getUpdateTooltip = function getUpdateTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "updateTip"
    }, this.props.i18nUpdateTip ? this.props.i18nUpdateTip : this.props.i18nUpdate);
  };

  ExtensionDetail.prototype.showDeleteDialog = function showDeleteDialog() {
    this.setState({
      showDeleteDialog: true
    });
  };

  ExtensionDetail.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(ConfirmationDialog, {
      buttonStyle: exports.ConfirmationButtonStyle.DANGER,
      i18nCancelButtonText: this.props.i18nCancelText,
      i18nConfirmButtonText: this.props.i18nDelete,
      i18nConfirmationMessage: this.props.i18nDeleteModalMessage,
      i18nTitle: this.props.i18nDeleteModalTitle,
      icon: exports.ConfirmationIconType.DANGER,
      showDialog: this.state.showDeleteDialog,
      onCancel: this.doCancel,
      onConfirm: this.doDelete
    }), React.createElement(reactCore.PageSection, {
      variant: 'light'
    }, React.createElement(reactCore.Level, {
      gutter: 'sm'
    }, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
      size: "xl",
      headingLevel: reactCore.TitleLevel.h1,
      className: "extension-detail__extensionTitle"
    }, this.props.extensionName), React.createElement(reactCore.Text, {
      className: "extension-detail__extensionId"
    }, this.props.i18nIdMessage)), React.createElement(reactCore.LevelItem, {
      className: "extension-detail__titleButtons"
    }, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getUpdateTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'extension-detail-update-button',
      href: this.props.linkUpdateExtension,
      as: 'primary'
    }, this.props.i18nUpdate)), React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getDeleteTooltip(),
      placement: "top"
    }, React.createElement(patternflyReact.Button, {
      bsStyle: "default",
      disabled: this.props.extensionUses !== 0,
      onClick: this.showDeleteDialog
    }, this.props.i18nDelete))))), React.createElement(reactCore.PageSection, null, React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.CardBody, null, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
      headingLevel: "h5",
      size: "md",
      className: "customization-details__heading"
    }, this.props.i18nOverviewSectionTitle), React.createElement(Container, null, this.props.overviewSection), React.createElement(reactCore.Title, {
      headingLevel: "h5",
      size: "md",
      className: "customization-details__heading"
    }, this.props.i18nSupportsSectionTitle), React.createElement(Container, null, this.props.supportsSection), React.createElement(reactCore.Title, {
      headingLevel: "h5",
      size: "md",
      className: "customization-details__heading"
    }, this.props.i18nUsageSectionTitle), React.createElement(Container, null, this.props.integrationsSection))))));
  };

  return ExtensionDetail;
}(React.Component);

var ExtensionImportCard =
/*@__PURE__*/
function (superclass) {
  function ExtensionImportCard() {
    superclass.apply(this, arguments);
  }

  if (superclass) ExtensionImportCard.__proto__ = superclass;
  ExtensionImportCard.prototype = Object.create(superclass && superclass.prototype);
  ExtensionImportCard.prototype.constructor = ExtensionImportCard;

  ExtensionImportCard.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.Card.Body, null, this.props.i18nAlertMessage ? React.createElement(patternflyReact.Alert, {
      type: 'error'
    }, React.createElement("span", null, this.props.i18nAlertMessage)) : null, React.createElement(DndFileChooser, {
      disableDropzone: this.props.dndDisabled,
      fileExtensions: '.jar',
      i18nHelpMessage: this.props.i18nDndHelpMessage,
      i18nInstructions: this.props.i18nDndInstructions,
      i18nNoFileSelectedMessage: this.props.i18nDndNoFileSelectedMessage,
      i18nSelectedFileLabel: this.props.i18nDndSelectedFileLabel,
      i18nUploadFailedMessage: this.props.i18nDndUploadFailedMessage,
      i18nUploadSuccessMessage: this.props.i18nDndUploadSuccessMessage,
      onUploadAccepted: this.props.onDndUploadAccepted,
      onUploadRejected: this.props.onDndUploadRejected
    })));
  };

  return ExtensionImportCard;
}(React.Component);
/**
 * A component that displays the extension import review information.
 */


var ExtensionImportReview =
/*@__PURE__*/
function (superclass) {
  function ExtensionImportReview(props) {
    superclass.call(this, props);
    this.handleImport = this.handleImport.bind(this);
  }

  if (superclass) ExtensionImportReview.__proto__ = superclass;
  ExtensionImportReview.prototype = Object.create(superclass && superclass.prototype);
  ExtensionImportReview.prototype.constructor = ExtensionImportReview;

  ExtensionImportReview.prototype.getActions = function getActions() {
    var this$1 = this;

    if (!this.props.actions) {
      return React.createElement(patternflyReact.Grid.Col, null);
    }

    return React.createElement(reactCore.TextContent, null, React.createElement(reactCore.TextList, {
      className: "extension-import-review__actions-list"
    }, this.props.actions ? this.props.actions.map(function (action, index) {
      return React.createElement(reactCore.TextListItem, {
        key: index,
        dangerouslySetInnerHTML: {
          __html: this$1.props.i18nActionText(action.name, action.description)
        }
      });
    }) : null));
  };

  ExtensionImportReview.prototype.handleImport = function handleImport() {
    return this.props.onImport(this.props.extensionUid);
  };

  ExtensionImportReview.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      className: "extension-import-review"
    }, React.createElement(patternflyReact.CardBody, null, React.createElement(reactCore.Stack, {
      gutter: "md"
    }, React.createElement(reactCore.Title, {
      headingLevel: "h1",
      size: "xl",
      className: "extension-import-review__title"
    }, this.props.i18nTitle), React.createElement(reactCore.TextContent, null, React.createElement(reactCore.TextList, {
      component: reactCore.TextListVariants.dl
    }, React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt,
      className: "extension-import-review__propertyLabel"
    }, this.props.i18nIdLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd,
      className: "extension-import-review__propertyValue"
    }, this.props.extensionId), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt,
      className: "extension-import-review__propertyLabel"
    }, this.props.i18nNameLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd,
      className: "extension-import-review__propertyValue"
    }, this.props.extensionName), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt,
      className: "extension-import-review__propertyLabel"
    }, this.props.i18nDescriptionLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd,
      className: "extension-import-review__propertyValue"
    }, this.props.extensionDescription ? this.props.extensionDescription : null), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt,
      className: "extension-import-review__propertyLabel"
    }, this.props.i18nTypeLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd,
      className: "extension-import-review__propertyValue"
    }, this.props.i18nExtensionTypeMessage), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt,
      className: "extension-import-review__propertyLabel"
    }, this.props.i18nActionsLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.getActions()))), React.createElement("div", {
      className: "extension-import-review__buttonBar"
    }, React.createElement(patternflyReact.Button, {
      bsStyle: "primary",
      onClick: this.handleImport
    }, this.props.i18nImport), React.createElement(ButtonLink, {
      "data-testid": 'extension-import-review-cancel-button',
      className: "extension-import-review__cancelButton",
      href: this.props.cancelLink,
      as: 'default'
    }, this.props.i18nCancel)))));
  };

  return ExtensionImportReview;
}(React.Component);

var ExtensionIntegrationsTable =
/*@__PURE__*/
function (superclass) {
  function ExtensionIntegrationsTable() {
    superclass.apply(this, arguments);
  }

  if (superclass) ExtensionIntegrationsTable.__proto__ = superclass;
  ExtensionIntegrationsTable.prototype = Object.create(superclass && superclass.prototype);
  ExtensionIntegrationsTable.prototype.constructor = ExtensionIntegrationsTable;

  ExtensionIntegrationsTable.prototype.getColumns = function getColumns() {
    var this$1 = this;

    var headerFormat = function headerFormat(value) {
      return React.createElement(patternflyReact.Table.Heading, null, value);
    };

    var clickableValueFormat = function clickableValueFormat(value, ref) {
      var rowData = ref.rowData; // rowData is an Integration type so 'name' property is what makes the integration unique

      var onClick = function onClick() {
        return this$1.onIntegrationSelected(rowData.id);
      };

      return React.createElement(patternflyReact.Table.Cell, null, React.createElement("a", {
        "data-testid": "extension-integrations-table-" + toValidHtmlId(rowData.name) + "-integration-link",
        href: "javascript:void(0)",
        onClick: onClick
      }, value));
    }; // Creates 2 columns:
    // 1. first column is integration name
    // 2. second column is optional integration description.


    return [{
      cell: {
        formatters: [clickableValueFormat]
      },
      header: {
        formatters: [headerFormat],
        label: this.props.i18nName
      },
      property: 'name'
    }, {
      cell: {
        formatters: [function (value) {
          return React.createElement(patternflyReact.Table.Cell, null, value);
        }]
      },
      header: {
        formatters: [headerFormat],
        label: this.props.i18nDescription
      },
      property: 'description'
    }];
  };

  ExtensionIntegrationsTable.prototype.onIntegrationSelected = function onIntegrationSelected(integrationId) {
    this.props.onSelectIntegration(integrationId);
  };

  ExtensionIntegrationsTable.prototype.render = function render() {
    return React.createElement("div", {
      className: "extension-group"
    }, React.createElement(reactCore.Text, null, this.props.i18nUsageMessage), this.props.data.length !== 0 ? React.createElement(patternflyReact.Table.PfProvider, {
      striped: true,
      bordered: true,
      hover: true,
      columns: this.getColumns()
    }, React.createElement(patternflyReact.Table.Header, null), React.createElement(patternflyReact.Table.Body, {
      rows: this.props.data,
      rowKey: "name"
    })) : null);
  };

  return ExtensionIntegrationsTable;
}(React.Component);

var ExtensionListItem =
/*@__PURE__*/
function (superclass) {
  function ExtensionListItem(props) {
    superclass.call(this, props);
    this.state = {
      showDeleteDialog: false
    };
    this.doCancel = this.doCancel.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.showDeleteDialog = this.showDeleteDialog.bind(this);
  }

  if (superclass) ExtensionListItem.__proto__ = superclass;
  ExtensionListItem.prototype = Object.create(superclass && superclass.prototype);
  ExtensionListItem.prototype.constructor = ExtensionListItem;

  ExtensionListItem.prototype.doCancel = function doCancel() {
    this.setState({
      showDeleteDialog: false
    });
  };

  ExtensionListItem.prototype.doDelete = function doDelete() {
    this.setState({
      showDeleteDialog: false
    }); // TODO: disable components while delete is processing

    this.props.onDelete(this.props.extensionId);
  };

  ExtensionListItem.prototype.getDeleteTooltip = function getDeleteTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "deleteTip"
    }, this.props.i18nDeleteTip ? this.props.i18nDeleteTip : this.props.i18nDelete);
  };

  ExtensionListItem.prototype.getDetailsTooltip = function getDetailsTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "detailsTip"
    }, this.props.i18nDetailsTip ? this.props.i18nDetailsTip : this.props.i18nDetails);
  };

  ExtensionListItem.prototype.getUpdateTooltip = function getUpdateTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "updateTip"
    }, this.props.i18nUpdateTip ? this.props.i18nUpdateTip : this.props.i18nUpdate);
  };

  ExtensionListItem.prototype.showDeleteDialog = function showDeleteDialog() {
    this.setState({
      showDeleteDialog: true
    });
  };

  ExtensionListItem.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(ConfirmationDialog // extensionId={this.props.extensionId}
    , {
      // extensionId={this.props.extensionId}
      buttonStyle: exports.ConfirmationButtonStyle.DANGER,
      i18nCancelButtonText: this.props.i18nCancelText,
      i18nConfirmButtonText: this.props.i18nDelete,
      i18nConfirmationMessage: this.props.i18nDeleteModalMessage,
      i18nTitle: this.props.i18nDeleteModalTitle,
      icon: exports.ConfirmationIconType.DANGER,
      showDialog: this.state.showDeleteDialog,
      onCancel: this.doCancel,
      onConfirm: this.doDelete
    }), React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "extension-list-item-" + toValidHtmlId(this.props.extensionName) + "-list-item",
      actions: React.createElement(React.Fragment, null, React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getDetailsTooltip(),
        placement: "top"
      }, React.createElement(ButtonLink, {
        "data-testid": 'extension-list-item-details-button',
        href: this.props.detailsPageLink,
        as: 'default'
      }, this.props.i18nDetails)), React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getUpdateTooltip(),
        placement: "top"
      }, React.createElement(ButtonLink, {
        "data-testid": 'extension-list-item-update-button',
        href: this.props.linkUpdateExtension,
        as: 'default'
      }, this.props.i18nUpdate)), React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getDeleteTooltip(),
        placement: "top"
      }, React.createElement(patternflyReact.Button, {
        "data-testid": 'extension-list-item-delete-button',
        bsStyle: "default",
        disabled: this.props.usedBy !== 0,
        onClick: this.showDeleteDialog
      }, this.props.i18nDelete))),
      additionalInfo: [React.createElement(patternflyReact.ListViewInfoItem, {
        key: 1
      }, this.props.i18nExtensionType), React.createElement(patternflyReact.ListViewInfoItem, {
        key: 2
      }, this.props.i18nUsedByMessage)],
      description: this.props.extensionDescription ? this.props.extensionDescription : '',
      heading: this.props.extensionName,
      hideCloseIcon: true,
      leftContent: this.props.extensionIcon,
      stacked: true
    }));
  };

  return ExtensionListItem;
}(React.Component); // tslint:disable react-unused-props-and-state


var ExtensionListSkeleton = function ExtensionListSkeleton(ref) {
  var width = ref.width;
  var style = ref.style;
  return React.createElement(ContentLoader, {
    height: 226,
    width: width,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: style
  }, React.createElement("circle", {
    cx: "30",
    cy: "40",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "40",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "35",
    rx: "5",
    ry: "5",
    width: "200",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "35",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "110",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "110",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "105",
    rx: "5",
    ry: "5",
    width: "180",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "105",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "180",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "180",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "175",
    rx: "5",
    ry: "5",
    width: "195",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "175",
    rx: "5",
    ry: "5",
    width: "85",
    height: "15"
  }));
};

var ExtensionListView =
/*@__PURE__*/
function (superclass) {
  function ExtensionListView() {
    superclass.apply(this, arguments);
  }

  if (superclass) ExtensionListView.__proto__ = superclass;
  ExtensionListView.prototype = Object.create(superclass && superclass.prototype);
  ExtensionListView.prototype.constructor = ExtensionListView;

  ExtensionListView.prototype.getImportTooltip = function getImportTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "importTip"
    }, this.props.i18nLinkImportExtensionTip ? this.props.i18nLinkImportExtensionTip : this.props.i18nLinkImportExtension);
  };

  ExtensionListView.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getImportTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'extension-list-view-import-button',
      href: this.props.linkImportExtension,
      as: 'primary'
    }, this.props.i18nLinkImportExtension)))), this.props.i18nTitle !== '' && React.createElement(reactCore.Title, {
      size: "lg"
    }, this.props.i18nTitle), this.props.i18nDescription !== '' && React.createElement(reactCore.Text, {
      dangerouslySetInnerHTML: {
        __html: this.props.i18nDescription
      }
    }), this.props.children ? React.createElement(patternflyReact.ListView, null, this.props.children) : React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Icon, null), React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyStateTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyStateInfo), React.createElement(patternflyReact.EmptyState.Action, null, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getImportTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'extension-list-view-empty-state-import-button',
      href: this.props.linkImportExtension,
      as: 'primary'
    }, this.props.i18nLinkImportExtension)))));
  };

  return ExtensionListView;
}(React.Component);
/**
 * A component that displays the overview section of the extension details page.
 */


var ExtensionOverview =
/*@__PURE__*/
function (superclass) {
  function ExtensionOverview() {
    superclass.apply(this, arguments);
  }

  if (superclass) ExtensionOverview.__proto__ = superclass;
  ExtensionOverview.prototype = Object.create(superclass && superclass.prototype);
  ExtensionOverview.prototype.constructor = ExtensionOverview;

  ExtensionOverview.prototype.render = function render() {
    return React.createElement(reactCore.TextList, {
      component: reactCore.TextListVariants.dl
    }, React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nName), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.extensionName), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nDescription), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.extensionDescription ? this.props.extensionDescription : null), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nType), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.i18nTypeMessage), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nLastUpdate), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, this.props.i18nLastUpdateDate ? this.props.i18nLastUpdateDate : null));
  };

  return ExtensionOverview;
}(React.Component);
/**
 * A component that displays the support section of the extension details page.
 */


var ExtensionSupports =
/*@__PURE__*/
function (superclass) {
  function ExtensionSupports() {
    superclass.apply(this, arguments);
  }

  if (superclass) ExtensionSupports.__proto__ = superclass;
  ExtensionSupports.prototype = Object.create(superclass && superclass.prototype);
  ExtensionSupports.prototype.constructor = ExtensionSupports;

  ExtensionSupports.prototype.render = function render() {
    return React.createElement("div", {
      className: "extension-group"
    }, this.props.extensionActions.length !== 0 ? React.createElement(reactCore.TextList, {
      component: reactCore.TextListVariants.dl
    }, this.props.extensionActions.map(function (action, index) {
      return React.createElement(React.Fragment, {
        key: index
      }, React.createElement(reactCore.TextListItem, {
        component: reactCore.TextListItemVariants.dt
      }, action.name), React.createElement(reactCore.TextListItem, {
        component: reactCore.TextListItemVariants.dd
      }, action.description));
    })) : null);
  };

  return ExtensionSupports;
}(React.Component);

var ConnectionsMetric =
/*@__PURE__*/
function (superclass) {
  function ConnectionsMetric() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectionsMetric.__proto__ = superclass;
  ConnectionsMetric.prototype = Object.create(superclass && superclass.prototype);
  ConnectionsMetric.prototype.constructor = ConnectionsMetric;

  ConnectionsMetric.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      accented: true,
      aggregated: true,
      matchHeight: true
    }, React.createElement(patternflyReact.Card.Body, {
      className: 'connections-metric__body'
    }, React.createElement(reactCore.Text, null, this.props.i18nTitle)));
  };

  return ConnectionsMetric;
}(React.PureComponent);

var Dashboard =
/*@__PURE__*/
function (superclass) {
  function Dashboard() {
    superclass.apply(this, arguments);
  }

  if (superclass) Dashboard.__proto__ = superclass;
  Dashboard.prototype = Object.create(superclass && superclass.prototype);
  Dashboard.prototype.constructor = Dashboard;

  Dashboard.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(SimplePageHeader, {
      i18nTitle: this.props.i18nTitle,
      titleSize: 'xl'
    }), React.createElement(reactCore.PageSection, null, React.createElement(patternflyReact.Grid, {
      fluid: true
    }, React.createElement(patternflyReact.Grid.Row, {
      className: 'show-grid dashboard__integrations__actions'
    }, React.createElement(patternflyReact.Grid.Col, {
      xs: 6,
      xsOffset: 6
    }, React.createElement(ButtonLink, {
      "data-testid": 'dashboard-create-integration-button',
      href: this.props.linkToIntegrationCreation,
      as: 'primary',
      className: 'pull-right'
    }, this.props.i18nLinkCreateIntegration), React.createElement(reactRouterDom.Link, {
      "data-testid": 'dashboard-integrations-link',
      to: this.props.linkToIntegrations,
      className: 'pull-right view'
    }, this.props.i18nLinkToIntegrations))), React.createElement(patternflyReact.Grid.Row, {
      className: 'dashboard__metrics'
    }, React.createElement(patternflyReact.CardGrid, {
      fluid: true,
      matchHeight: true
    }, React.createElement(patternflyReact.CardGrid.Row, null, React.createElement(patternflyReact.CardGrid.Col, {
      sm: 6,
      md: 3
    }, this.props.integrationsOverview), React.createElement(patternflyReact.CardGrid.Col, {
      sm: 6,
      md: 3
    }, this.props.connectionsOverview), React.createElement(patternflyReact.CardGrid.Col, {
      sm: 6,
      md: 3
    }, this.props.messagesOverview), React.createElement(patternflyReact.CardGrid.Col, {
      sm: 6,
      md: 3
    }, this.props.uptimeOverview)))), React.createElement(patternflyReact.Grid.Row, {
      className: 'dashboard__integrations'
    }, React.createElement(patternflyReact.Grid.Col, {
      sm: 12,
      md: 7
    }, this.props.topIntegrations), React.createElement(patternflyReact.Grid.Col, {
      sm: 12,
      md: 5
    }, this.props.integrationBoard), React.createElement(patternflyReact.Grid.Col, {
      sm: 12,
      md: 5
    }, this.props.integrationUpdates)), React.createElement(patternflyReact.Grid.Row, {
      className: 'dashboard__connections__actions'
    }, React.createElement(reactCore.Title, {
      size: 'lg',
      className: 'pull-left'
    }, this.props.i18nConnections), React.createElement(ButtonLink, {
      "data-testid": 'dashboard-create-connection-button',
      href: this.props.linkToConnectionCreation,
      as: 'primary',
      className: 'pull-right'
    }, this.props.i18nLinkCreateConnection), React.createElement(reactRouterDom.Link, {
      "data-testid": 'dashboard-connections-link',
      to: this.props.linkToConnections,
      className: 'pull-right view'
    }, this.props.i18nLinkToConnections)), React.createElement(patternflyReact.Grid.Row, null, React.createElement(patternflyReact.CardGrid, {
      fluid: true,
      matchHeight: true
    }, React.createElement(patternflyReact.CardGrid.Row, null, this.props.connections))))));
  };

  return Dashboard;
}(React.PureComponent);

var IntegrationBoard =
/*@__PURE__*/
function (superclass) {
  function IntegrationBoard() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationBoard.__proto__ = superclass;
  IntegrationBoard.prototype = Object.create(superclass && superclass.prototype);
  IntegrationBoard.prototype.constructor = IntegrationBoard;

  IntegrationBoard.prototype.render = function render() {
    var data = {
      colors: {
        Pending: patternflyReact.patternfly.pfPaletteColors.black200,
        Published: patternflyReact.patternfly.pfPaletteColors.blue400,
        Stopped: patternflyReact.patternfly.pfPaletteColors.black300
      },
      columns: [[this.props.i18nIntegrationStateRunning, this.props.runningIntegrations], [this.props.i18nIntegrationStateStopped, this.props.stoppedIntegrations], [this.props.i18nIntegrationStatePending, this.props.pendingIntegrations]],
      type: 'donut'
    };
    return React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, null, this.props.i18nTitle)), React.createElement(patternflyReact.Card.Body, null, React.createElement(patternflyReact.DonutChart, {
      id: "integration-board",
      size: {
        height: 120
      },
      data: data,
      tooltip: {
        contents: patternflyReact.patternfly.pfDonutTooltipContents,
        show: true
      },
      title: {
        secondary: this.props.i18nIntegrations,
        type: this.props.i18nTotal
      },
      legend: {
        show: true,
        position: 'right'
      }
    })));
  };

  return IntegrationBoard;
}(React.PureComponent);

var RecentUpdatesCard =
/*@__PURE__*/
function (superclass) {
  function RecentUpdatesCard() {
    superclass.apply(this, arguments);
  }

  if (superclass) RecentUpdatesCard.__proto__ = superclass;
  RecentUpdatesCard.prototype = Object.create(superclass && superclass.prototype);
  RecentUpdatesCard.prototype.constructor = RecentUpdatesCard;

  RecentUpdatesCard.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      accented: false
    }, React.createElement(patternflyReact.Card.Heading, null, React.createElement(patternflyReact.Card.Title, null, this.props.i18nTitle)), React.createElement(patternflyReact.Card.Body, null, this.props.children));
  };

  return RecentUpdatesCard;
}(React.Component);

var IntegrationDetailActivity =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailActivity() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailActivity.__proto__ = superclass;
  IntegrationDetailActivity.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailActivity.prototype.constructor = IntegrationDetailActivity;

  IntegrationDetailActivity.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(Container, null, React.createElement("div", {
      className: "integration-detail-activity-toolbar pull-right"
    }, this.props.linkToOpenShiftLog && React.createElement(React.Fragment, null, React.createElement(reactRouterDom.Link, {
      "data-testid": 'integration-detail-activity-view-log-link',
      to: this.props.linkToOpenShiftLog
    }, this.props.i18nViewLogOpenShift), "\xA0|\xA0"), React.createElement("span", {
      className: "integration-detail-activity-toolbar-last-refresh"
    }, this.props.i18nLastRefresh), "\xA0\xA0", React.createElement(patternflyReact.Button, {
      "data-testid": 'integration-detail-activity-refresh-button',
      onClick: this.props.onRefresh
    }, this.props.i18nBtnRefresh))), this.props.children ? React.createElement(patternflyReact.ListView, null, this.props.children) : null);
  };

  return IntegrationDetailActivity;
}(React.Component);

var headerFormat = function headerFormat(value) {
  return React.createElement(patternflyReact.Table.Heading, null, value);
};

var cellFormat = function cellFormat(value) {
  return React.createElement(patternflyReact.Table.Cell, null, value);
};

var statusCellFormat = function statusCellFormat(status) {
  return React.createElement(patternflyReact.Table.Cell, {
    className: "integration-detail-activity-item__status"
  }, status === 'Success' ? React.createElement(React.Fragment, null, React.createElement(patternflyReact.Icon, {
    type: "pf",
    name: "ok"
  }), " Success") : React.createElement(React.Fragment, null, React.createElement(patternflyReact.Icon, {
    type: "pf",
    name: "error-circle-o"
  }), " Error"));
};

var outputCellFormat = function outputCellFormat(output) {
  return React.createElement(patternflyReact.Table.Cell, {
    className: "integration-detail-activity-item__output"
  }, React.createElement("pre", {
    className: "integration-detail-activity-item__output-step-data"
  }, output || 'No output'));
};

var IntegrationDetailActivityItem =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailActivityItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailActivityItem.__proto__ = superclass;
  IntegrationDetailActivityItem.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailActivityItem.prototype.constructor = IntegrationDetailActivityItem;

  IntegrationDetailActivityItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView.Item, {
      className: "integration-detail-activity-item",
      key: this.props.time,
      actions: React.createElement("div", {
        className: "integration-detail-activity-item__status-item"
      }, this.props.errorCount > 0 ? React.createElement("span", null, React.createElement(patternflyReact.Icon, {
        type: "pf",
        name: "error-circle-o"
      }), '  ', this.props.i18nErrorsFound) : React.createElement("span", null, React.createElement(patternflyReact.Icon, {
        type: "pf",
        name: "ok"
      }), '  ', this.props.i18nNoErrors)),
      leftContent: this.props.date,
      heading: React.createElement(React.Fragment, null),
      description: this.props.time,
      additionalInfo: [React.createElement(patternflyReact.ListView.InfoItem, {
        key: 1
      }, this.props.i18nVersion, "\xA0", this.props.version)]
    }, this.props.steps ? React.createElement(patternflyReact.Table.PfProvider, {
      className: "integration-detail-activity-item__expanded-table",
      striped: true,
      bordered: true,
      hover: true,
      columns: [{
        cell: {
          formatters: [cellFormat],
          property: 'step'
        },
        header: {
          formatters: [headerFormat],
          label: 'Step'
        }
      }, {
        cell: {
          formatters: [cellFormat],
          property: 'time'
        },
        header: {
          formatters: [headerFormat],
          label: 'Time'
        }
      }, {
        cell: {
          formatters: [cellFormat],
          property: 'duration'
        },
        header: {
          formatters: [headerFormat],
          label: 'Duration'
        }
      }, {
        cell: {
          formatters: [statusCellFormat],
          property: 'status'
        },
        header: {
          formatters: [headerFormat],
          label: 'Status'
        }
      }, {
        cell: {
          formatters: [outputCellFormat],
          property: 'output'
        },
        header: {
          formatters: [headerFormat],
          label: 'Output'
        }
      }]
    }, React.createElement(patternflyReact.Table.Header, null), this.props.steps) : React.createElement("span", null, this.props.i18nNoSteps));
  };

  return IntegrationDetailActivityItem;
}(React.Component);

var IntegrationDetailActivityItemSteps =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailActivityItemSteps() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailActivityItemSteps.__proto__ = superclass;
  IntegrationDetailActivityItemSteps.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailActivityItemSteps.prototype.constructor = IntegrationDetailActivityItemSteps;

  IntegrationDetailActivityItemSteps.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(patternflyReact.Table.Body, {
      rows: [{
        duration: this.props.duration,
        output: this.props.output,
        status: this.props.status,
        step: this.props.name,
        time: this.props.time
      }],
      rowKey: this.props.name
    }));
  };

  return IntegrationDetailActivityItemSteps;
}(React.Component);

(function (TagNameValidationError) {
  TagNameValidationError["NoErrors"] = "NoErrors";
  TagNameValidationError["NoName"] = "NoName";
  TagNameValidationError["NameInUse"] = "NameInUse";
})(exports.TagNameValidationError || (exports.TagNameValidationError = {}));

var CiCdEditDialog =
/*@__PURE__*/
function (superclass) {
  function CiCdEditDialog(props) {
    superclass.call(this, props);
    this.state = {
      tagName: this.props.tagName
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  if (superclass) CiCdEditDialog.__proto__ = superclass;
  CiCdEditDialog.prototype = Object.create(superclass && superclass.prototype);
  CiCdEditDialog.prototype.constructor = CiCdEditDialog;

  CiCdEditDialog.prototype.handleChange = function handleChange(event) {
    var this$1 = this;
    var name = event.target.value.trim();
    this.setState({
      tagName: name
    }, function () {
      return this$1.props.onValidate(name);
    });
  };

  CiCdEditDialog.prototype.handleClick = function handleClick() {
    this.props.onSave(this.state.tagName);
  };

  CiCdEditDialog.prototype.render = function render() {
    return React.createElement(Dialog, {
      body: React.createElement(reactCore.TextContent, null, React.createElement("form", {
        className: "form-horizontal"
      }, React.createElement(reactCore.Text, {
        component: reactCore.TextVariants.p
      }, this.props.i18nDescription), React.createElement("div", {
        className: this.props.validationError === exports.TagNameValidationError.NoErrors ? 'form-group' : 'form-group has-error'
      }, React.createElement("label", {
        className: "col-sm-3 control-label",
        htmlFor: "tagNameInput"
      }, this.props.i18nInputLabel), React.createElement("div", {
        className: "col-sm-9"
      }, React.createElement("input", {
        id: "tagNameInput",
        className: "form-control",
        type: "text",
        defaultValue: this.props.tagName,
        onChange: this.handleChange
      }), this.props.validationError === exports.TagNameValidationError.NoErrors && React.createElement("span", {
        className: "help-block"
      }, "\xA0"), this.props.validationError === exports.TagNameValidationError.NoName && React.createElement("span", {
        className: "help-block"
      }, this.props.i18nNoNameError), this.props.validationError === exports.TagNameValidationError.NameInUse && React.createElement("span", {
        className: "help-block"
      }, this.props.i18nNameInUseError))))),
      footer: React.createElement(React.Fragment, null, React.createElement(patternflyReact.Button, {
        "data-testid": 'cicd-edit-dialog-cancel-button',
        onClick: this.props.onHide
      }, this.props.i18nCancelButtonText), React.createElement(patternflyReact.Button, {
        "data-testid": 'cicd-edit-dialog-save-button',
        bsStyle: 'primary',
        onClick: this.handleClick,
        disabled: this.state.tagName === '' || this.props.validationError !== exports.TagNameValidationError.NoErrors
      }, this.props.i18nSaveButtonText)),
      onHide: this.props.onHide,
      title: this.props.i18nTitle
    });
  };

  return CiCdEditDialog;
}(React.Component);

var CiCdList =
/*@__PURE__*/
function (superclass) {
  function CiCdList() {
    superclass.apply(this, arguments);
  }

  if (superclass) CiCdList.__proto__ = superclass;
  CiCdList.prototype = Object.create(superclass && superclass.prototype);
  CiCdList.prototype.constructor = CiCdList;

  CiCdList.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView, null, this.props.children);
  };

  return CiCdList;
}(React.Component);

var CiCdListEmptyState =
/*@__PURE__*/
function (superclass) {
  function CiCdListEmptyState() {
    superclass.apply(this, arguments);
  }

  if (superclass) CiCdListEmptyState.__proto__ = superclass;
  CiCdListEmptyState.prototype = Object.create(superclass && superclass.prototype);
  CiCdListEmptyState.prototype.constructor = CiCdListEmptyState;

  CiCdListEmptyState.prototype.render = function render() {
    return React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Icon, null), React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nInfo), React.createElement(patternflyReact.EmptyState.Action, null, React.createElement(patternflyReact.Button, {
      "data-testid": 'cicd-list-empty-state-add-new-button',
      bsStyle: "primary",
      bsSize: "large",
      onClick: this.props.onAddNew
    }, this.props.i18nAddNewButtonText)));
  };

  return CiCdListEmptyState;
}(React.Component);

var CiCdListItem =
/*@__PURE__*/
function (superclass) {
  function CiCdListItem(props) {
    superclass.call(this, props);
    this.handleEditClicked = this.handleEditClicked.bind(this);
    this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
  }

  if (superclass) CiCdListItem.__proto__ = superclass;
  CiCdListItem.prototype = Object.create(superclass && superclass.prototype);
  CiCdListItem.prototype.constructor = CiCdListItem;

  CiCdListItem.prototype.handleEditClicked = function handleEditClicked() {
    this.props.onEditClicked(this.props.name);
  };

  CiCdListItem.prototype.handleRemoveClicked = function handleRemoveClicked() {
    this.props.onRemoveClicked(this.props.name);
  };

  CiCdListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "cicd-list-item-" + toValidHtmlId(this.props.name) + "-list-item",
      heading: this.props.name,
      description: this.props.i18nUsesText,
      additionalInfo: [],
      actions: React.createElement("div", null, React.createElement(patternflyReact.Button, {
        "data-testid": 'cicd-list-item-create-button',
        onClick: this.handleEditClicked
      }, this.props.i18nEditButtonText), React.createElement(patternflyReact.Button, {
        "data-testid": 'cicd-list-item-remove-button',
        onClick: this.handleRemoveClicked
      }, this.props.i18nRemoveButtonText))
    });
  };

  return CiCdListItem;
}(React.Component);

var CiCdListView =
/*@__PURE__*/
function (superclass) {
  function CiCdListView() {
    superclass.apply(this, arguments);
  }

  if (superclass) CiCdListView.__proto__ = superclass;
  CiCdListView.prototype = Object.create(superclass && superclass.prototype);
  CiCdListView.prototype.constructor = CiCdListView;

  CiCdListView.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, this.props.resultsCount !== 0 && React.createElement(patternflyReact.Button, {
      "data-testid": 'cicd-list-view-add-new-button',
      className: "btn btn-primary",
      onClick: this.props.onAddNew
    }, this.props.i18nAddNewButtonText))), this.props.children);
  };

  return CiCdListView;
}(React.Component);

var CiCdManagePageUI =
/*@__PURE__*/
function (superclass) {
  function CiCdManagePageUI(props) {
    superclass.call(this, props);
    this.state = {
      showAddDialog: false,
      showEditDialog: false,
      showRemoveDialog: false
    };
    this.openAddDialog = this.openAddDialog.bind(this);
    this.closeAddDialog = this.closeAddDialog.bind(this);
    this.openEditDialog = this.openEditDialog.bind(this);
    this.closeEditDialog = this.closeEditDialog.bind(this);
    this.openRemoveDialog = this.openRemoveDialog.bind(this);
    this.closeRemoveDialog = this.closeRemoveDialog.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemoveConfirm = this.handleRemoveConfirm.bind(this);
  }

  if (superclass) CiCdManagePageUI.__proto__ = superclass;
  CiCdManagePageUI.prototype = Object.create(superclass && superclass.prototype);
  CiCdManagePageUI.prototype.constructor = CiCdManagePageUI;

  CiCdManagePageUI.prototype.handleSave = function handleSave(name) {
    if (this.state.showEditDialog) {
      this.closeEditDialog();
      this.props.onEditItem(this.state.currentItemName, name);
    }

    if (this.state.showAddDialog) {
      this.closeAddDialog();
      this.props.onAddItem(name);
    }

    if (this.state.showRemoveDialog) {
      this.closeRemoveDialog();
      this.props.onRemoveItem(name);
    }
  };

  CiCdManagePageUI.prototype.handleRemoveConfirm = function handleRemoveConfirm() {
    this.handleSave(this.state.currentItemName);
  };

  CiCdManagePageUI.prototype.openRemoveDialog = function openRemoveDialog(name) {
    this.setState({
      currentItemName: name,
      showRemoveDialog: true
    });
  };

  CiCdManagePageUI.prototype.closeRemoveDialog = function closeRemoveDialog() {
    this.setState({
      showRemoveDialog: false
    });
  };

  CiCdManagePageUI.prototype.openAddDialog = function openAddDialog() {
    this.setState({
      showAddDialog: true
    });
  };

  CiCdManagePageUI.prototype.closeAddDialog = function closeAddDialog() {
    this.setState({
      showAddDialog: false
    });
  };

  CiCdManagePageUI.prototype.openEditDialog = function openEditDialog(name) {
    this.setState({
      currentItemName: name,
      showEditDialog: true
    });
  };

  CiCdManagePageUI.prototype.closeEditDialog = function closeEditDialog() {
    this.setState({
      showEditDialog: false
    });
  };

  CiCdManagePageUI.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(SimplePageHeader, {
      i18nTitle: this.props.i18nPageTitle,
      i18nDescription: this.props.i18nPageDescription
    }), this.state.showAddDialog && React.createElement(CiCdEditDialog, {
      i18nTitle: this.props.i18nAddTagDialogTitle,
      i18nDescription: this.props.i18nAddTagDialogDescription,
      tagName: '',
      i18nInputLabel: this.props.i18nTagInputLabel,
      i18nSaveButtonText: this.props.i18nSaveButtonText,
      i18nCancelButtonText: this.props.i18nCancelButtonText,
      i18nNoNameError: this.props.i18nNoNameError,
      i18nNameInUseError: this.props.i18nNameInUseError,
      validationError: this.props.nameValidationError,
      onHide: this.closeAddDialog,
      onSave: this.handleSave,
      onValidate: this.props.onValidateItem
    }), this.state.showEditDialog && React.createElement(CiCdEditDialog, {
      i18nTitle: this.props.i18nEditTagDialogTitle,
      i18nDescription: this.props.i18nEditTagDialogDescription,
      tagName: this.state.currentItemName,
      i18nInputLabel: this.props.i18nTagInputLabel,
      i18nSaveButtonText: this.props.i18nSaveButtonText,
      i18nCancelButtonText: this.props.i18nCancelButtonText,
      i18nNoNameError: this.props.i18nNoNameError,
      i18nNameInUseError: this.props.i18nNameInUseError,
      validationError: this.props.nameValidationError,
      onHide: this.closeEditDialog,
      onSave: this.handleSave,
      onValidate: this.props.onValidateItem
    }), this.state.showRemoveDialog && React.createElement(ConfirmationDialog, {
      buttonStyle: exports.ConfirmationButtonStyle.NORMAL,
      icon: exports.ConfirmationIconType.DANGER,
      i18nCancelButtonText: this.props.i18nConfirmCancelButtonText,
      i18nConfirmButtonText: this.props.i18nConfirmRemoveButtonText,
      i18nConfirmationMessage: this.props.i18nRemoveConfirmationMessage(this.state.currentItemName),
      i18nTitle: this.props.i18nRemoveConfirmationTitle,
      i18nDetailsMessage: this.props.i18nRemoveConfirmationDetailMessage,
      showDialog: this.state.showRemoveDialog,
      onCancel: this.closeRemoveDialog,
      onConfirm: this.handleRemoveConfirm
    }), React.createElement(CiCdListView, {
      activeFilters: this.props.activeFilters,
      currentFilterType: this.props.currentFilterType,
      currentSortType: this.props.currentSortType,
      currentValue: this.props.currentValue,
      filterTypes: this.props.filterTypes,
      isSortAscending: this.props.isSortAscending,
      resultsCount: this.props.resultsCount,
      sortTypes: this.props.sortTypes,
      onUpdateCurrentValue: this.props.onUpdateCurrentValue,
      onValueKeyPress: this.props.onValueKeyPress,
      onFilterAdded: this.props.onFilterAdded,
      onSelectFilterType: this.props.onSelectFilterType,
      onFilterValueSelected: this.props.onFilterValueSelected,
      onRemoveFilter: this.props.onRemoveFilter,
      onClearFilters: this.props.onClearFilters,
      onToggleCurrentSortDirection: this.props.onToggleCurrentSortDirection,
      onUpdateCurrentSortType: this.props.onUpdateCurrentSortType,
      i18nResultsCount: this.props.i18nResultsCount,
      i18nAddNewButtonText: this.props.i18nAddNewButtonText,
      onAddNew: this.openAddDialog
    }, this.props.children({
      openAddDialog: this.openAddDialog,
      openEditDialog: this.openEditDialog,
      openRemoveDialog: this.openRemoveDialog
    })));
  };

  return CiCdManagePageUI;
}(React.Component);

function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}

var ItemSkeleton = function ItemSkeleton() {
  return React.createElement(ContentLoader, {
    height: 68,
    width: 500,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: {
      height: 68,
      width: '100%'
    }
  }, React.createElement("rect", {
    x: "15",
    y: "20",
    rx: "5",
    ry: "5",
    width: 400 * getRandom(0.6, 1),
    height: "18"
  }));
};

var CiCdListSkeleton =
/*@__PURE__*/
function (superclass) {
  function CiCdListSkeleton() {
    superclass.apply(this, arguments);
  }

  if (superclass) CiCdListSkeleton.__proto__ = superclass;
  CiCdListSkeleton.prototype = Object.create(superclass && superclass.prototype);
  CiCdListSkeleton.prototype.constructor = CiCdListSkeleton;

  CiCdListSkeleton.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: 'list-group-item',
      "data-testid": 'cicd-list-skeleton-item-0'
    }, React.createElement("div", null, React.createElement(ItemSkeleton, null))), React.createElement("div", {
      className: 'list-group-item',
      "data-testid": 'cicd-list-skeleton-item-1'
    }, React.createElement("div", null, React.createElement(ItemSkeleton, null))), React.createElement("div", {
      className: 'list-group-item',
      "data-testid": 'cicd-list-skeleton-item-2'
    }, React.createElement("div", null, React.createElement(ItemSkeleton, null))));
  };

  return CiCdListSkeleton;
}(React.PureComponent);

var TagIntegrationDialog =
/*@__PURE__*/
function (superclass) {
  function TagIntegrationDialog(props) {
    superclass.call(this, props);
    this.state = {
      disableSave: true
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  if (superclass) TagIntegrationDialog.__proto__ = superclass;
  TagIntegrationDialog.prototype = Object.create(superclass && superclass.prototype);
  TagIntegrationDialog.prototype.constructor = TagIntegrationDialog;

  TagIntegrationDialog.prototype.handleChange = function handleChange(items, initialItems) {
    var disableSave = initialItems.map(function (item, index) {
      return item.name === items[index].name && item.selected === items[index].selected;
    }).reduce(function (acc, current) {
      return acc && current;
    }, true);
    this.itemsDraft = items;
    this.setState({
      disableSave: disableSave
    });
  };

  TagIntegrationDialog.prototype.handleClick = function handleClick() {
    this.props.onSave(this.itemsDraft);
  };

  TagIntegrationDialog.prototype.render = function render() {
    return React.createElement(Dialog, {
      body: this.props.children({
        handleChange: this.handleChange
      }),
      footer: React.createElement(React.Fragment, null, React.createElement(patternflyReact.Button, {
        "data-testid": 'tag-integration-dialog-cancel-button',
        onClick: this.props.onHide
      }, this.props.i18nCancelButtonText), React.createElement(patternflyReact.Button, {
        "data-testid": 'tag-integration-dialog-save-button',
        bsStyle: 'primary',
        onClick: this.handleClick,
        disabled: this.state.disableSave
      }, this.props.i18nSaveButtonText)),
      title: this.props.i18nTitle,
      onHide: this.props.onHide
    });
  };

  return TagIntegrationDialog;
}(React.Component);

var TagIntegrationListItem =
/*@__PURE__*/
function (superclass) {
  function TagIntegrationListItem(props) {
    superclass.call(this, props);
    this.handleChange = this.handleChange.bind(this);
  }

  if (superclass) TagIntegrationListItem.__proto__ = superclass;
  TagIntegrationListItem.prototype = Object.create(superclass && superclass.prototype);
  TagIntegrationListItem.prototype.constructor = TagIntegrationListItem;

  TagIntegrationListItem.prototype.handleChange = function handleChange(event) {
    this.props.onChange(this.props.name, event.target.checked);
  };

  TagIntegrationListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListViewItem, {
      checkboxInput: React.createElement("input", {
        "data-testid": "tag-integration-list-item-" + toValidHtmlId(this.props.name) + "-selected-input",
        type: "checkbox",
        defaultChecked: this.props.selected,
        onChange: this.handleChange
      }),
      heading: this.props.name,
      description: '',
      additionalInfo: []
    });
  };

  return TagIntegrationListItem;
}(React.Component);

var TagIntegrationDialogEmptyState =
/*@__PURE__*/
function (superclass) {
  function TagIntegrationDialogEmptyState() {
    superclass.apply(this, arguments);
  }

  if (superclass) TagIntegrationDialogEmptyState.__proto__ = superclass;
  TagIntegrationDialogEmptyState.prototype = Object.create(superclass && superclass.prototype);
  TagIntegrationDialogEmptyState.prototype.constructor = TagIntegrationDialogEmptyState;

  TagIntegrationDialogEmptyState.prototype.render = function render() {
    return React.createElement(patternflyReact.EmptyState, {
      style: {
        background: 'inherit',
        border: 'none'
        /* todo component specific override */

      }
    }, React.createElement(patternflyReact.EmptyState.Icon, null), React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nInfo), React.createElement(patternflyReact.EmptyState.Action, null, React.createElement(ButtonLink, {
      "data-testid": 'tag-integration-dialog-empty-state-manage-cicd-button',
      as: "primary",
      size: "lg",
      href: this.props.href
    }, this.props.i18nGoToManageCiCdButtonText)));
  };

  return TagIntegrationDialogEmptyState;
}(React.Component);

var TagIntegrationDialogBody =
/*@__PURE__*/
function (superclass) {
  function TagIntegrationDialogBody(props) {
    superclass.call(this, props);
    this.state = {
      items: this.props.initialItems
    };
    this.handleChange = this.handleChange.bind(this);
  }

  if (superclass) TagIntegrationDialogBody.__proto__ = superclass;
  TagIntegrationDialogBody.prototype = Object.create(superclass && superclass.prototype);
  TagIntegrationDialogBody.prototype.constructor = TagIntegrationDialogBody;

  TagIntegrationDialogBody.prototype.handleChange = function handleChange(name, selected) {
    var items = this.props.initialItems.map(function (item) {
      return item.name === name ? {
        name: name,
        selected: selected
      } : item;
    });
    this.props.onChange(items, this.props.initialItems);
  };

  TagIntegrationDialogBody.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(React.Fragment, null, this.state.items.length > 0 && React.createElement(React.Fragment, null, React.createElement(CiCdList, null, this.state.items.map(function (item, index) {
      return React.createElement(TagIntegrationListItem, {
        key: index,
        name: item.name,
        selected: item.selected,
        onChange: this$1.handleChange
      });
    }))), this.state.items.length === 0 && React.createElement(TagIntegrationDialogEmptyState, {
      href: this.props.manageCiCdHref,
      i18nTitle: this.props.i18nEmptyStateTitle,
      i18nInfo: this.props.i18nEmptyStateInfo,
      i18nGoToManageCiCdButtonText: this.props.i18nEmptyStateButtonText
    }));
  };

  return TagIntegrationDialogBody;
}(React.Component);

var IntegrationActions =
/*@__PURE__*/
function (superclass) {
  function IntegrationActions() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationActions.__proto__ = superclass;
  IntegrationActions.prototype = Object.create(superclass && superclass.prototype);
  IntegrationActions.prototype.constructor = IntegrationActions;

  IntegrationActions.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
      "data-testid": 'integration-actions-view-button',
      className: "view-integration-btn",
      href: this.props.detailsHref,
      as: 'default'
    }, "View"), React.createElement(patternflyReact.DropdownKebab, {
      className: "integration-actions__dropdown-kebab",
      id: "integration-" + this.props.integrationId + "-action-menu",
      pullRight: true
    }, this.props.actions.map(function (a, idx) {
      return React.createElement("li", {
        role: 'presentation',
        key: idx
      }, a.href ? React.createElement(reactRouterDom.Link, {
        "data-testid": "integration-actions-" + toValidHtmlId(a.label.toString()),
        to: a.href,
        onClick: a.onClick,
        role: 'menuitem',
        tabIndex: idx + 1
      }, a.label) : React.createElement("a", {
        "data-testid": "integration-actions-" + toValidHtmlId(a.label.toString()),
        href: 'javascript:void(0)',
        onClick: a.onClick,
        role: 'menuitem',
        tabIndex: idx + 1
      }, a.label));
    })));
  };

  return IntegrationActions;
}(React.Component); // tslint:disable react-unused-props-and-state


var IntegrationActionSelectorCard = function IntegrationActionSelectorCard(ref) {
  var content = ref.content;
  var title = ref.title;
  return React.createElement("div", {
    className: "card-pf"
  }, React.createElement("div", {
    className: "card-pf-title"
  }, title), React.createElement("div", {
    className: "card-pf-body"
  }, content));
};

(function (AlertLevel) {
  AlertLevel["ERROR"] = "error";
  AlertLevel["WARN"] = "warning";
  AlertLevel["INFO"] = "info";
})(exports.AlertLevel || (exports.AlertLevel = {}));

var IntegrationBulletinBoardAlert =
/*@__PURE__*/
function (superclass) {
  function IntegrationBulletinBoardAlert() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationBulletinBoardAlert.__proto__ = superclass;
  IntegrationBulletinBoardAlert.prototype = Object.create(superclass && superclass.prototype);
  IntegrationBulletinBoardAlert.prototype.constructor = IntegrationBulletinBoardAlert;

  IntegrationBulletinBoardAlert.prototype.render = function render() {
    return React.createElement(patternflyReact.Alert, {
      type: this.props.level
    }, React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: this.props.message
      }
    }), this.props.detail && React.createElement(patternflyReact.ExpandCollapse, {
      align: "left",
      bordered: false,
      expanded: false,
      textExpanded: this.props.i18nTextExpanded,
      textCollapsed: this.props.i18nTextCollapsed
    }, React.createElement("pre", null, this.props.detail)));
  };

  return IntegrationBulletinBoardAlert;
}(React.Component);

var IntegrationDetailBreadcrumb =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailBreadcrumb() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailBreadcrumb.__proto__ = superclass;
  IntegrationDetailBreadcrumb.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailBreadcrumb.prototype.constructor = IntegrationDetailBreadcrumb;

  IntegrationDetailBreadcrumb.prototype.render = function render() {
    return React.createElement(Breadcrumb, {
      actions: React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
        "data-testid": 'integration-detail-breadcrumb-export-button',
        to: this.props.exportHref,
        onClick: this.props.exportAction,
        children: this.props.exportLabel
      }), "\xA0\xA0", React.createElement(ButtonLink, {
        "data-testid": 'integration-detail-breadcrumb-edit-button',
        className: "btn btn-primary",
        href: this.props.editHref,
        children: this.props.editLabel
      }), React.createElement(patternflyReact.DropdownKebab, {
        id: "integration-" + this.props.integrationId + "-action-menu",
        pullRight: true
      }, this.props.menuActions ? this.props.menuActions.map(function (a, idx) {
        return React.createElement("li", {
          role: 'presentation',
          key: idx
        }, a.href ? React.createElement(reactRouterDom.Link, {
          "data-testid": "integration-detail-breadcrumb-" + toValidHtmlId(a.label.toString()),
          to: a.href,
          onClick: a.onClick,
          role: 'menuitem',
          tabIndex: idx + 1
        }, a.label) : React.createElement("a", {
          "data-testid": "integration-detail-breadcrumb-" + toValidHtmlId(a.label.toString()),
          href: 'javascript:void(0)',
          onClick: a.onClick,
          role: 'menuitem',
          tabIndex: idx + 1
        }, a.label));
      }) : null))
    }, React.createElement("span", null, React.createElement(reactRouterDom.Link, {
      "data-testid": 'integration-detail-breadcrumb-home-link',
      to: this.props.homeHref
    }, this.props.i18nHome)), React.createElement("span", null, React.createElement(reactRouterDom.Link, {
      "data-testid": 'integration-detail-breadcrumb-integrations-link',
      to: this.props.integrationsHref
    }, this.props.i18nIntegrations)), React.createElement("span", null, this.props.i18nPageTitle));
  };

  return IntegrationDetailBreadcrumb;
}(React.Component);

var IntegrationDetailDescription =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailDescription() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailDescription.__proto__ = superclass;
  IntegrationDetailDescription.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailDescription.prototype.constructor = IntegrationDetailDescription;

  IntegrationDetailDescription.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(reactCore.Text, null, this.props.description));
  };

  return IntegrationDetailDescription;
}(React.PureComponent);

var IntegrationDetailEditableName =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailEditableName() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailEditableName.__proto__ = superclass;
  IntegrationDetailEditableName.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailEditableName.prototype.constructor = IntegrationDetailEditableName;

  IntegrationDetailEditableName.prototype.render = function render() {
    return React.createElement(React.Fragment, null, this.props.name && React.createElement(reactCore.Title, {
      size: "lg",
      className: "integration-detail-editable-name pf-u-mr-lg"
    }, this.props.name));
  };

  return IntegrationDetailEditableName;
}(React.PureComponent);

var IntegrationDetailHistoryListView =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailHistoryListView() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailHistoryListView.__proto__ = superclass;
  IntegrationDetailHistoryListView.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailHistoryListView.prototype.constructor = IntegrationDetailHistoryListView;

  IntegrationDetailHistoryListView.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(patternflyReact.Grid, {
      fluid: true,
      key: 1,
      className: "integration-detail-history-list-view"
    }, this.props.isDraft ? React.createElement(patternflyReact.Grid.Row, {
      className: "show-grid integration-detail-history-list-view__draft-row"
    }, React.createElement(patternflyReact.Grid.Col, {
      xs: 2,
      md: 2,
      className: "integration-detail-history-list-view__description"
    }, this.props.i18nTextDraft, ":"), React.createElement(patternflyReact.Grid.Col, {
      xs: 10,
      md: 10
    }, React.createElement(patternflyReact.ListViewItem, {
      key: 1,
      heading: this.props.i18nTextDraft,
      actions: React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
        "data-testid": 'integration-detail-history-list-view-publish-button',
        to: this.props.publishHref,
        onClick: this.props.publishAction,
        children: this.props.publishLabel
      }), React.createElement(ButtonLink, {
        "data-testid": 'integration-detail-history-list-view-edit-button',
        href: this.props.editHref,
        children: this.props.editLabel
      })),
      stacked: false
    }))) : null, this.props.children && this.props.hasHistory ? React.createElement(patternflyReact.Grid.Row, {
      className: "show-grid"
    }, React.createElement(patternflyReact.Grid.Col, {
      xs: 2,
      md: 2,
      className: "integration-detail-history-list-view__description"
    }, React.createElement("span", null, this.props.i18nTextHistory, ":")), React.createElement(patternflyReact.Grid.Col, {
      xs: 10,
      md: 10
    }, this.props.children ? React.createElement(patternflyReact.ListView, null, this.props.children) : null)) : null));
  };

  return IntegrationDetailHistoryListView;
}(React.Component);

var states = {
  Error: React.createElement(patternflyReact.ListView.Icon, {
    type: "pf",
    name: "error-circle-o"
  }),
  Pending: React.createElement(patternflyReact.ListView.Icon, {
    name: "blank"
  }),
  Published: React.createElement(patternflyReact.ListView.Icon, {
    type: "pf",
    name: "ok"
  }),
  Unpublished: React.createElement(patternflyReact.ListView.Icon, {
    name: "blank"
  })
};

var IntegrationDetailHistoryListViewItem =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailHistoryListViewItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailHistoryListViewItem.__proto__ = superclass;
  IntegrationDetailHistoryListViewItem.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailHistoryListViewItem.prototype.constructor = IntegrationDetailHistoryListViewItem;

  IntegrationDetailHistoryListViewItem.prototype.render = function render() {
    function getIntegrationState(currentState) {
      return states[currentState] || null;
    }

    return React.createElement(patternflyReact.ListViewItem, {
      actions: this.props.actions,
      heading: React.createElement(React.Fragment, null, this.props.i18nTextVersion, ": ", this.props.version),
      description: React.createElement(React.Fragment, null, this.props.i18nTextLastPublished, this.props.updatedAt),
      leftContent: getIntegrationState(this.props.currentState),
      stacked: false
    });
  };

  return IntegrationDetailHistoryListViewItem;
}(React.Component);

var IntegrationDetailHistoryListViewItemActions =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailHistoryListViewItemActions() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailHistoryListViewItemActions.__proto__ = superclass;
  IntegrationDetailHistoryListViewItemActions.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailHistoryListViewItemActions.prototype.constructor = IntegrationDetailHistoryListViewItemActions;

  IntegrationDetailHistoryListViewItemActions.prototype.render = function render() {
    return React.createElement(patternflyReact.DropdownKebab, {
      id: "integration-" + this.props.integrationId + "-action-menu",
      pullRight: true
    }, this.props.actions.map(function (a, index) {
      return React.createElement("li", {
        role: 'presentation',
        key: index
      }, a.href ? React.createElement(reactRouterDom.Link, {
        "data-testid": "integration-detail-history-list-view-item-actions-" + toValidHtmlId(a.label.toString()),
        to: a.href,
        onClick: a.onClick,
        role: 'menuitem',
        tabIndex: index + 1
      }, a.label) : React.createElement("a", {
        "data-testid": "integration-detail-history-list-view-item-actions-" + toValidHtmlId(a.label.toString()),
        href: 'javascript:void(0)',
        onClick: a.onClick,
        role: 'menuitem',
        tabIndex: index + 1
      }, a.label));
    }));
  };

  return IntegrationDetailHistoryListViewItemActions;
}(React.Component); // Integration states


var PUBLISHED = 'Published';
var UNPUBLISHED = 'Unpublished';
var PENDING = 'Pending';
var ERROR = 'Error'; // Detailed state log link types

var IntegrationStatusDetail =
/*@__PURE__*/
function (superclass) {
  function IntegrationStatusDetail() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationStatusDetail.__proto__ = superclass;
  IntegrationStatusDetail.prototype = Object.create(superclass && superclass.prototype);
  IntegrationStatusDetail.prototype.constructor = IntegrationStatusDetail;

  IntegrationStatusDetail.prototype.render = function render() {
    var fallbackText = this.props.i18nProgressPending;

    switch (this.props.targetState) {
      case PUBLISHED:
        fallbackText = this.props.i18nProgressStarting;
        break;

      case UNPUBLISHED:
        fallbackText = this.props.i18nProgressStopping;
        break;
    }

    return React.createElement("div", {
      "data-testid": 'integration-status-detail',
      className: 'integration-status-detail'
    }, this.props.value && this.props.currentStep && this.props.totalSteps ? React.createElement(ProgressWithLink, {
      currentStep: this.props.currentStep,
      totalSteps: this.props.totalSteps,
      value: this.props.value,
      logUrl: this.props.logUrl,
      i18nLogUrlText: this.props.i18nLogUrlText
    }) : React.createElement(React.Fragment, null, React.createElement(patternflyReact.Spinner, {
      loading: true,
      inline: true
    }), fallbackText));
  };

  return IntegrationStatusDetail;
}(React.Component);

var IntegrationDetailInfo =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailInfo() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailInfo.__proto__ = superclass;
  IntegrationDetailInfo.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailInfo.prototype.constructor = IntegrationDetailInfo;

  IntegrationDetailInfo.prototype.render = function render() {
    return React.createElement("div", {
      className: "integration-detail-info"
    }, this.props.name, React.createElement(React.Fragment, null, this.props.currentState === 'Pending' && React.createElement(IntegrationStatusDetail, {
      targetState: this.props.targetState,
      value: this.props.monitoringValue,
      currentStep: this.props.monitoringCurrentStep,
      totalSteps: this.props.monitoringTotalSteps,
      logUrl: this.props.monitoringLogUrl,
      i18nProgressPending: this.props.i18nProgressPending,
      i18nProgressStarting: this.props.i18nProgressStarting,
      i18nProgressStopping: this.props.i18nProgressStopping,
      i18nLogUrlText: this.props.i18nLogUrlText
    }), this.props.currentState === 'Published' && this.props.version && React.createElement("div", {
      className: "integration-detail-info__status"
    }, React.createElement("span", {
      className: "pficon pficon-ok integration-detail-info__status-icon"
    }), "Published version ", this.props.version), this.props.currentState === 'Unpublished' && React.createElement(patternflyReact.Label, null, "Stopped")));
  };

  return IntegrationDetailInfo;
}(React.PureComponent);

var IntegrationExposedURL = function IntegrationExposedURL(ref) {
  var url = ref.url;
  return React.createElement(React.Fragment, null, url && React.createElement(reactCore.PageSection, null, React.createElement(CopyToClipboard, null, url)));
};

function objectWithoutProperties$9(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var ApiProviderReviewOperations =
/*@__PURE__*/
function (superclass) {
  function ApiProviderReviewOperations() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiProviderReviewOperations.__proto__ = superclass;
  ApiProviderReviewOperations.prototype = Object.create(superclass && superclass.prototype);
  ApiProviderReviewOperations.prototype.constructor = ApiProviderReviewOperations;

  ApiProviderReviewOperations.prototype.render = function render() {
    var ref = this.props;
    var children = ref.children;
    var rest = objectWithoutProperties$9(ref, ["children"]);
    var props = rest;
    return React.createElement(reactCore.PageSection, null, React.createElement(ListViewToolbar, Object.assign({}, props)), React.createElement(patternflyReact.ListView, null, children));
  };

  return ApiProviderReviewOperations;
}(React.Component);

var ApiProviderReviewOperationsItem =
/*@__PURE__*/
function (superclass) {
  function ApiProviderReviewOperationsItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiProviderReviewOperationsItem.__proto__ = superclass;
  ApiProviderReviewOperationsItem.prototype = Object.create(superclass && superclass.prototype);
  ApiProviderReviewOperationsItem.prototype.constructor = ApiProviderReviewOperationsItem;

  ApiProviderReviewOperationsItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView.Item, {
      actions: React.createElement(ButtonLink, {
        "data-testid": 'api-provider-operations-create-flow',
        onClick: this.props.onCreateFlow,
        href: this.props.createFlowHref,
        as: this.props.createAsPrimary ? 'primary' : 'default'
      }, this.props.i18nCreateFlow),
      additionalInfo: [React.createElement(patternflyReact.ListView.InfoItem, {
        key: 1,
        className: 'item__additional-info'
      }, this.props.operationDescription)],
      className: 'api-provider-review-operations-item',
      description: React.createElement("div", {
        className: 'item__operation-path'
      }, this.props.operationPath),
      heading: React.createElement(HttpMethodColors, {
        method: this.props.operationHttpMethod
      }),
      stacked: false
    });
  };

  return ApiProviderReviewOperationsItem;
}(React.Component);

var ApiProviderSetInfo =
/*@__PURE__*/
function (superclass) {
  function ApiProviderSetInfo() {
    superclass.apply(this, arguments);
  }

  if (superclass) ApiProviderSetInfo.__proto__ = superclass;
  ApiProviderSetInfo.prototype = Object.create(superclass && superclass.prototype);
  ApiProviderSetInfo.prototype.constructor = ApiProviderSetInfo;

  ApiProviderSetInfo.prototype.render = function render() {
    return React.createElement(Container, null, React.createElement("form", {
      className: 'required-pf',
      role: 'form',
      onSubmit: this.props.handleSubmit
    }, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, React.createElement("div", {
      className: "card-pf-body"
    }, this.props.children)))));
  };

  return ApiProviderSetInfo;
}(React.Component);

var ChoiceCardHeader = function ChoiceCardHeader(ref) {
  var i18nConditions = ref.i18nConditions;
  return React.createElement("h2", {
    className: "card-pf-title"
  }, i18nConditions);
};

var ChoiceConfigurationView =
/*@__PURE__*/
function (superclass) {
  function ChoiceConfigurationView() {
    superclass.apply(this, arguments);
  }

  if (superclass) ChoiceConfigurationView.__proto__ = superclass;
  ChoiceConfigurationView.prototype = Object.create(superclass && superclass.prototype);
  ChoiceConfigurationView.prototype.constructor = ChoiceConfigurationView;

  ChoiceConfigurationView.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(patternflyReact.ListView, null, this.props.flowItems.map(function (item, index) {
      return React.createElement(patternflyReact.ListViewItem, {
        key: index,
        actions: React.createElement(ButtonLink, {
          "data-testid": "choice-view-mode-item-" + toValidHtmlId(item.condition) + "-view-flow-button",
          href: item.href,
          as: "primary"
        }, this$1.props.i18nOpenFlow),
        heading: React.createElement("strong", null, index + 1, ". ", this$1.props.i18nWhen),
        description: item.condition,
        additionalInfo: []
      });
    }), React.createElement(patternflyReact.ListViewItem, {
      key: 'otherwise',
      actions: this.props.useDefaultFlow && React.createElement(ButtonLink, {
        "data-testid": "choice-view-mode-view-default-flow-button",
        href: this.props.defaultFlowHref,
        as: "primary"
      }, this.props.i18nOpenFlow),
      description: React.createElement(React.Fragment, null, this.props.useDefaultFlow && React.createElement(patternflyReact.Icon, {
        name: "check"
      }), !this.props.useDefaultFlow && React.createElement(patternflyReact.Icon, {
        name: "ban"
      }), "\xA0", this.props.i18nUseDefaultFlow),
      heading: React.createElement("strong", null, this.props.i18nOtherwise)
    }));
  };

  return ChoiceConfigurationView;
}(React.Component);

var EditorPageCard =
/*@__PURE__*/
function (superclass) {
  function EditorPageCard() {
    superclass.apply(this, arguments);
  }

  if (superclass) EditorPageCard.__proto__ = superclass;
  EditorPageCard.prototype = Object.create(superclass && superclass.prototype);
  EditorPageCard.prototype.constructor = EditorPageCard;

  EditorPageCard.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(Container, null, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, this.props.header && React.createElement("div", {
      className: "card-pf-header"
    }, this.props.header), React.createElement("div", {
      className: "card-pf-body"
    }, React.createElement(Container, null, this.props.children)), React.createElement("div", {
      className: "card-pf-footer"
    }, React.createElement(ButtonLink, {
      "data-testid": 'editor-page-card-done-button',
      onClick: this.props.submitForm,
      disabled: !this.props.isValid,
      as: 'primary'
    }, this.props.i18nDone))))));
  };

  return EditorPageCard;
}(React.Component);

var PageSectionLoader =
/*@__PURE__*/
function (superclass) {
  function PageSectionLoader() {
    superclass.apply(this, arguments);
  }

  if (superclass) PageSectionLoader.__proto__ = superclass;
  PageSectionLoader.prototype = Object.create(superclass && superclass.prototype);
  PageSectionLoader.prototype.constructor = PageSectionLoader;

  PageSectionLoader.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(Container, null, React.createElement(Loader, {
      size: "lg"
    })));
  };

  return PageSectionLoader;
}(React.Component);

var TemplateStepTypeSelector =
/*@__PURE__*/
function (superclass) {
  function TemplateStepTypeSelector(props) {
    superclass.call(this, props);
    this.handleChange = this.handleChange.bind(this);
  }

  if (superclass) TemplateStepTypeSelector.__proto__ = superclass;
  TemplateStepTypeSelector.prototype = Object.create(superclass && superclass.prototype);
  TemplateStepTypeSelector.prototype.constructor = TemplateStepTypeSelector;

  TemplateStepTypeSelector.prototype.handleChange = function handleChange(event) {
    var ref = event.currentTarget;
    var value = ref.value;
    this.props.onTemplateTypeChange(value);
  };

  TemplateStepTypeSelector.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Text, null, this.props.i18nSpecifyTemplateType)), React.createElement("div", {
      className: "template-language-choices"
    }, React.createElement("div", {
      className: "radio-inline"
    }, React.createElement("label", {
      htmlFor: "freemarker-choice"
    }, React.createElement("input", {
      type: "radio",
      id: "freemarker-choice",
      name: "template-lang-choice",
      value: 'freemarker',
      checked: this.props.templateType === 'freemarker',
      onChange: this.handleChange
    }), this.props.i18nFreemarkerLabel)), React.createElement("div", {
      className: "radio-inline"
    }, React.createElement("label", {
      htmlFor: "mustache-choice"
    }, React.createElement("input", {
      type: "radio",
      id: "mustache-choice",
      name: "template-lang-choice",
      value: 'mustache',
      checked: this.props.templateType === 'mustache',
      onChange: this.handleChange
    }), this.props.i18nMustacheLabel)), React.createElement("div", {
      className: "radio-inline"
    }, React.createElement("label", {
      htmlFor: "velocity-choice"
    }, React.createElement("input", {
      type: "radio",
      id: "velocity-choice",
      name: "template-lang-choice",
      value: 'velocity',
      checked: this.props.templateType === 'velocity',
      onChange: this.handleChange
    }), this.props.i18nVelocityLabel))));
  };

  return TemplateStepTypeSelector;
}(React.Component);

function objectWithoutProperties$a(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var TemplateStepLinters = {
  freemarker: new FreemarkerModeLint(),
  mustache: new MustacheModeLint(),
  velocity: new VelocityLint()
};

var TemplateStepTemplateEditor = function TemplateStepTemplateEditor(ref) {
  var textEditorDescription = ref.textEditorDescription;
  var i18nFileUploadLimit = ref.i18nFileUploadLimit;
  var initialValue = ref.initialValue;
  var mode = ref.mode;
  var formatAnnotation = ref.formatAnnotation;
  var onUpdateLinting = ref.onUpdateLinting;
  var options = ref.options;
  if (options === void 0) options = {};
  var rest = objectWithoutProperties$a(ref, ["textEditorDescription", "i18nFileUploadLimit", "initialValue", "mode", "formatAnnotation", "onUpdateLinting", "options"]);
  var props = rest;
  options = Object.assign({}, {
    dragDrop: true,
    gutters: ['CodeMirror-lint-markers'],
    lineNumbers: true,
    lineWrapping: true,
    lint: {
      formatAnnotation: formatAnnotation,
      lintOnChange: true,
      onUpdateLinting: onUpdateLinting,
      tooltips: 'gutter'
    },
    mode: mode,
    readOnly: false,
    showCursorWhenSelecting: true,
    styleActiveLine: true,
    tabSize: 2
  }, options);
  return React.createElement(React.Fragment, null, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Text, null, textEditorDescription)), React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Text, null, React.createElement("small", null, React.createElement("i", null, i18nFileUploadLimit)))), React.createElement(TextEditor, Object.assign({
    value: initialValue,
    options: options
  }, props)));
};

var kinds = [{
  label: 'Type specification not required',
  value: 'any'
}, {
  label: 'JSON Schema',
  value: 'json-schema'
}, {
  label: 'JSON Instance',
  value: 'json-instance'
}, {
  label: 'XML Schema',
  value: 'xml-schema'
}, {
  label: 'XML Instance',
  value: 'xml-instance'
}];

var DescribeDataShapeForm =
/*@__PURE__*/
function (superclass) {
  function DescribeDataShapeForm(props) {
    superclass.call(this, props);
  }

  if (superclass) DescribeDataShapeForm.__proto__ = superclass;
  DescribeDataShapeForm.prototype = Object.create(superclass && superclass.prototype);
  DescribeDataShapeForm.prototype.constructor = DescribeDataShapeForm;

  DescribeDataShapeForm.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(reactCore.PageSection, null, React.createElement(Container, null, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, React.createElement("div", {
      className: "card-pf-body"
    }, React.createElement("form", null, React.createElement(patternflyReact.FormGroup, null, React.createElement(patternflyReact.ControlLabel, null, this.props.i18nSelectType), React.createElement(patternflyReact.ControlLabel, null, React.createElement(patternflyReact.FieldLevelHelp, {
      content: this.props.i18nSelectTypeHelp
    })), React.createElement(patternflyReact.FormControl, {
      "data-testid": 'describe-data-shape-form-kind-input',
      componentClass: "select",
      value: this.props.kind,
      onChange: function onChange(event) {
        return this$1.props.onKindChange(event.target.value);
      }
    }, kinds.map(function (kind, index) {
      return React.createElement("option", {
        key: index,
        value: kind.value
      }, kind.label);
    }))), this.props.kind !== 'any' && React.createElement(React.Fragment, null, React.createElement(patternflyReact.FormGroup, null, React.createElement(patternflyReact.ControlLabel, null, this.props.i18nDefinition), React.createElement(patternflyReact.FieldLevelHelp, {
      content: this.props.i18nDefinitionHelp
    }), React.createElement(TextEditor, {
      id: 'describe-data-shape-form-definition-editor',
      value: this.props.definition || '',
      onChange: function onChange(editor, data, text) {
        return this$1.props.onDefinitionChange(text);
      },
      options: {
        lineNumbers: true,
        lineWrapping: true,
        readOnly: false,
        showCursorWhenSelecting: true,
        styleActiveLine: true,
        tabSize: 2
      }
    })), React.createElement(patternflyReact.FormGroup, null, React.createElement(patternflyReact.ControlLabel, null, this.props.i18nDataTypeName), React.createElement(patternflyReact.ControlLabel, null, React.createElement(patternflyReact.FieldLevelHelp, {
      content: this.props.i18nDataTypeNameHelp
    })), React.createElement(patternflyReact.FormControl, {
      "data-testid": 'describe-data-shape-form-name-input',
      type: "text",
      value: this.props.name,
      onChange: function onChange(event) {
        return this$1.props.onNameChange(event.target.value);
      }
    })), React.createElement(patternflyReact.FormGroup, null, React.createElement(patternflyReact.ControlLabel, null, this.props.i18nDataTypeDescription), React.createElement(patternflyReact.ControlLabel, null, React.createElement(patternflyReact.FieldLevelHelp, {
      content: this.props.i18nDataTypeDescriptionHelp
    })), React.createElement(patternflyReact.FormControl, {
      type: "text",
      "data-testid": 'describe-data-shape-form-description-input',
      value: this.props.description,
      onChange: function onChange(event) {
        return this$1.props.onDescriptionChange(event.target.value);
      }
    }))))), React.createElement("div", {
      className: "card-pf-footer"
    }, this.props.backActionHref && React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
      "data-testid": 'describe-data-shape-form-back-button',
      href: this.props.backActionHref
    }, React.createElement("i", {
      className: 'fa fa-chevron-left'
    }), ' ', this.props.i18nBackAction), "\xA0"), React.createElement(ButtonLink, {
      "data-testid": 'describe-data-shape-form-next-button',
      onClick: this.props.onNext,
      as: 'primary'
    }, this.props.i18nNext))))));
  };

  return DescribeDataShapeForm;
}(React.Component);

var IntegrationEditorActionsListItem =
/*@__PURE__*/
function (superclass) {
  function IntegrationEditorActionsListItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationEditorActionsListItem.__proto__ = superclass;
  IntegrationEditorActionsListItem.prototype = Object.create(superclass && superclass.prototype);
  IntegrationEditorActionsListItem.prototype.constructor = IntegrationEditorActionsListItem;

  IntegrationEditorActionsListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView.Item, {
      "data-testid": "integration-editor-actions-list-item-" + toValidHtmlId(this.props.integrationName) + "-list-item",
      actions: this.props.actions,
      heading: React.createElement("b", null, this.props.integrationName),
      description: this.props.integrationName === this.props.integrationDescription ? undefined : this.props.integrationDescription,
      stacked: false
    });
  };

  return IntegrationEditorActionsListItem;
}(React.Component);
/**
 * A component to render a list of actions, to be used in the integration
 * editor.
 */


var IntegrationEditorChooseAction =
/*@__PURE__*/
function (superclass) {
  function IntegrationEditorChooseAction() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationEditorChooseAction.__proto__ = superclass;
  IntegrationEditorChooseAction.prototype = Object.create(superclass && superclass.prototype);
  IntegrationEditorChooseAction.prototype.constructor = IntegrationEditorChooseAction;

  IntegrationEditorChooseAction.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(patternflyReact.ListView, null, this.props.children));
  };

  return IntegrationEditorChooseAction;
}(React.Component);

var IntegrationEditorConnectionsListItem =
/*@__PURE__*/
function (superclass) {
  function IntegrationEditorConnectionsListItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationEditorConnectionsListItem.__proto__ = superclass;
  IntegrationEditorConnectionsListItem.prototype = Object.create(superclass && superclass.prototype);
  IntegrationEditorConnectionsListItem.prototype.constructor = IntegrationEditorConnectionsListItem;

  IntegrationEditorConnectionsListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView.Item, {
      "data-testid": "integration-editor-connections-list-item-" + toValidHtmlId(this.props.integrationName) + "-list-item",
      actions: this.props.actions,
      heading: this.props.integrationName,
      description: this.props.integrationDescription,
      leftContent: this.props.icon,
      stacked: true
    });
  };

  return IntegrationEditorConnectionsListItem;
}(React.Component);
/**
 * A component to render a save form, to be used in the integration
 * editor. This does *not* build the form itself, form's field should be passed
 * as the `children` value.
 * @see [i18nTitle]{@link IIntegrationEditorFormProps#i18nTitle}
 * @see [i18nSubtitle]{@link IIntegrationEditorFormProps#i18nSubtitle}
 */


var IntegrationEditorForm =
/*@__PURE__*/
function (superclass) {
  function IntegrationEditorForm() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationEditorForm.__proto__ = superclass;
  IntegrationEditorForm.prototype = Object.create(superclass && superclass.prototype);
  IntegrationEditorForm.prototype.constructor = IntegrationEditorForm;

  IntegrationEditorForm.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(Container, null, React.createElement("form", {
      className: "form-horizontal required-pf",
      role: "form",
      onSubmit: this.props.handleSubmit
    }, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, this.props.i18nFormTitle && React.createElement("div", {
      className: "card-pf-title"
    }, this.props.i18nFormTitle), this.props.error ? React.createElement(patternflyReact.Alert, {
      type: 'warning'
    }, React.createElement("span", null, this.props.error)) : null, React.createElement("div", {
      className: "card-pf-body"
    }, React.createElement(Container, null, this.props.children)), React.createElement("div", {
      className: "card-pf-footer"
    }, this.props.backActionHref && React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
      id: 'integration-editor-form-back-button',
      href: this.props.backActionHref
    }, React.createElement("i", {
      className: 'fa fa-chevron-left'
    }), ' ', this.props.i18nBackAction), "\xA0"), React.createElement(ButtonLink, {
      id: 'integration-editor-form-next-button',
      onClick: this.props.submitForm,
      disabled: !this.props.isValid || this.props.isLoading,
      as: 'primary'
    }, this.props.i18nNext, this.props.isLoading ? React.createElement(React.Fragment, null, "\xA0\xA0", React.createElement(Loader, {
      inline: true,
      size: 'xs'
    })) : null)))))));
  };

  return IntegrationEditorForm;
}(React.Component); // tslint:disable react-unused-props-and-state

/**
 * Provides the layout for the integration editor. It uses the PatternFly Wizard
 * component under the hood.
 * The footer is pre-defined and follows the PF Wizard pattern, with
 * Cancel/Previous/Next buttons.
 *
 * @todo in the CSS we use hardcoded values for the heights of various
 * elements of the page to be able to size the element to take all the available
 * height and show the right scrollbars.
 * We should really find a smarter way to handle this.
 */


var IntegrationEditorLayout = function IntegrationEditorLayout(ref) {
  var title = ref.title;
  var description = ref.description;
  var toolbar = ref.toolbar;
  var sidebar = ref.sidebar;
  var content = ref.content;
  var onPublish = ref.onPublish;
  var onCancel = ref.onCancel;
  var onSave = ref.onSave;
  var saveHref = ref.saveHref;
  var cancelHref = ref.cancelHref;
  var publishHref = ref.publishHref;
  var isSaveLoading = ref.isSaveLoading;
  var isSaveDisabled = ref.isSaveDisabled;
  var isPublishLoading = ref.isPublishLoading;
  var isPublishDisabled = ref.isPublishDisabled;
  var extraActions = ref.extraActions;
  return React.createElement("div", {
    className: 'integration-editor-layout'
  }, React.createElement("div", {
    className: 'integration-editor-layout__header'
  }, React.createElement(reactCore.PageSection, {
    variant: 'light'
  }, toolbar, React.createElement(reactCore.Level, {
    gutter: 'sm'
  }, React.createElement(reactCore.LevelItem, null, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
    size: '2xl',
    headingLevel: reactCore.TitleLevel.h1
  }, title), React.createElement(reactCore.Text, null, description))), React.createElement(reactCore.LevelItem, null, (cancelHref || onCancel) && React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
    id: 'integration-editor-cancel-button',
    onClick: onCancel,
    href: cancelHref
  }, "Cancel"), "\xA0\xA0\xA0"), (saveHref || onSave) && React.createElement(React.Fragment, null, React.createElement(ButtonLink, {
    id: 'integration-editor-save-button',
    onClick: onSave,
    href: saveHref,
    disabled: isSaveLoading || isSaveDisabled,
    as: publishHref || onPublish ? 'default' : 'primary'
  }, isSaveLoading ? React.createElement(Loader, {
    size: 'xs',
    inline: true
  }) : null, "Save"), "\xA0"), (publishHref || onPublish) && React.createElement(ButtonLink, {
    id: 'integration-editor-publish-button',
    onClick: onPublish,
    href: publishHref,
    as: 'primary',
    disabled: isPublishLoading || isPublishDisabled
  }, "Publish"), extraActions)))), React.createElement("div", {
    className: 'integration-editor-layout__body'
  }, React.createElement("div", {
    className: 'integration-editor-layout__sidebarOuter'
  }, React.createElement("div", {
    className: 'integration-editor-layout__sidebarInner'
  }, sidebar)), React.createElement("div", {
    className: 'integration-editor-layout__contentOuter'
  }, React.createElement("div", {
    className: 'integration-editor-layout__contentInner'
  }, content))));
};
/**
 * A component to render an alert for unconfigurable actions.
 * @see [i18nAlert]{@link IIntegrationEditorNothingToConfigureProps#i18nAlert}
 */


var IntegrationEditorNothingToConfigure =
/*@__PURE__*/
function (superclass) {
  function IntegrationEditorNothingToConfigure() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationEditorNothingToConfigure.__proto__ = superclass;
  IntegrationEditorNothingToConfigure.prototype = Object.create(superclass && superclass.prototype);
  IntegrationEditorNothingToConfigure.prototype.constructor = IntegrationEditorNothingToConfigure;

  IntegrationEditorNothingToConfigure.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, React.createElement(Container, null, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, React.createElement("div", {
      className: "card-pf-body"
    }, React.createElement(Container, null, React.createElement(reactCore.Text, {
      className: "alert alert-info"
    }, React.createElement("span", {
      className: "pficon pficon-info"
    }), this.props.i18nAlert))), React.createElement("div", {
      className: "card-pf-footer"
    }, React.createElement(ButtonLink, {
      "data-testid": 'integration-editor-nothing-to-configure-back-button',
      href: this.props.backActionHref
    }, React.createElement("i", {
      className: 'fa fa-chevron-left'
    }), ' ', this.props.i18nBackAction), "\xA0", React.createElement(ButtonLink, {
      "data-testid": 'integration-editor-nothing-to-configure-next-button',
      onClick: this.props.submitForm,
      as: 'primary'
    }, this.props.i18nNext))))));
  };

  return IntegrationEditorNothingToConfigure;
}(React.Component);

var IntegrationEditorStepsAdderHeader = function IntegrationEditorStepsAdderHeader() {
  return React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
    size: '2xl',
    headingLevel: reactCore.TitleLevel.h1
  }, "Add to Integration"), React.createElement(reactCore.Text, null, "You can continue adding steps and connections to your integration as well."));
};

var IntegrationEditorStepsList =
/*@__PURE__*/
function (superclass) {
  function IntegrationEditorStepsList() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationEditorStepsList.__proto__ = superclass;
  IntegrationEditorStepsList.prototype = Object.create(superclass && superclass.prototype);
  IntegrationEditorStepsList.prototype.constructor = IntegrationEditorStepsList;

  IntegrationEditorStepsList.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView, {
      className: 'integration-editor-steps-list'
    }, this.props.children);
  };

  return IntegrationEditorStepsList;
}(React.Component);

var IntegrationEditorStepsListItem = function IntegrationEditorStepsListItem(props) {
  var ref = React.useState(false);
  var showWarningPopover = ref[0];
  var setShowWarningPopover = ref[1];

  var toggleWarningPopover = function toggleWarningPopover() {
    return setShowWarningPopover(!showWarningPopover);
  };

  var itemRef = React.useRef(null);
  return React.createElement(patternflyReact.ListView.Item, {
    "data-testid": "integration-editor-steps-list-item-" + toValidHtmlId(props.stepName) + "-list-item",
    actions: props.actions,
    heading: props.stepName,
    children: props.children,
    className: 'integration-editor-steps-list-item__list-item',
    initExpanded: typeof props.children !== 'undefined',
    description: props.stepDescription,
    additionalInfo: [React.createElement(React.Fragment, {
      key: 0
    }, React.createElement("div", null, React.createElement("p", null, React.createElement("strong", null, "Action:"), "\xA0", React.createElement("span", null, props.action)), React.createElement("p", null, React.createElement("strong", null, "Data Type:"), "\xA0", React.createElement("span", null, props.shape, props.showWarning && React.createElement(ButtonLink, {
      "data-testid": 'integration-editor-steps-list-item-warning-button',
      as: 'link',
      onClick: toggleWarningPopover,
      ref: itemRef
    }, React.createElement("i", {
      className: 'pficon pficon-warning-triangle-o'
    }))), React.createElement(patternflyReact.Overlay, {
      placement: 'top',
      show: showWarningPopover,
      target: itemRef.current
    }, React.createElement(patternflyReact.Popover, {
      id: 'iedsli-shape-warning',
      title: props.i18nWarningTitle
    }, props.i18nWarningMessage)))))],
    leftContent: props.icon,
    stacked: true,
    hideCloseIcon: true
  });
};
/**
 * Provides the layout for the integration editor. It uses the PatternFly Wizard
 * component under the hood.
 * The footer is pre-defined and follows the PF Wizard pattern, with
 * Cancel/Previous/Next buttons.
 *
 * @todo in the CSS we use hardcoded values for the heights of various
 * elements of the page to be able to size the element to take all the available
 * height and show the right scrollbars.
 * We should really find a smarter way to handle this.
 */


var IntegrationEditorWizard = function IntegrationEditorWizard(ref) {
  var header = ref.header;
  var sidebar = ref.sidebar;
  var content = ref.content;
  var onCancel = ref.onCancel;
  var onBack = ref.onBack;
  var onNext = ref.onNext;
  var cancelHref = ref.cancelHref;
  var backHref = ref.backHref;
  var nextHref = ref.nextHref;
  var isNextLoading = ref.isNextLoading;
  var isNextDisabled = ref.isNextDisabled;
  var isLastStep = ref.isLastStep;
  if (isLastStep === void 0) isLastStep = false;
  return React.createElement("div", {
    className: classnames('wizard-pf-body integration-editor-wizard syn-scrollable', {
      'has-footer': true
    })
  }, header, React.createElement("div", {
    className: "wizard-pf-row integration-editor-wizard__body syn-scrollable--body"
  }, React.createElement("div", {
    className: "wizard-pf-sidebar"
  }, sidebar), React.createElement("div", {
    className: 'wizard-pf-main cards-pf integration-editor-wizard__contentWrapper'
  }, React.createElement("div", {
    className: "integration-editor-wizard__content"
  }, content))), React.createElement("div", {
    className: "wizard-pf-footer integration-editor-wizard__footer"
  }, React.createElement(ButtonLink, {
    "data-testid": 'integration-editor-wizard-back-button',
    onClick: onBack,
    href: backHref,
    className: 'wizard-pf-back'
  }, React.createElement("i", {
    className: "fa fa-angle-left"
  }), " Back"), React.createElement(ButtonLink, {
    "data-testid": 'integration-editor-wizard-next-button',
    onClick: onNext,
    href: nextHref,
    as: 'primary',
    className: 'wizard-pf-next',
    disabled: isNextLoading || isNextDisabled
  }, isNextLoading ? React.createElement(Loader, {
    size: 'xs',
    inline: true
  }) : null, isLastStep ? 'Done' : React.createElement(React.Fragment, null, "Next ", React.createElement("i", {
    className: "fa fa-angle-right"
  }))), React.createElement(ButtonLink, {
    "data-testid": 'integration-editor-wizard-cancel-button',
    onClick: onCancel,
    href: cancelHref,
    className: 'wizard-pf-cancel'
  }, "Cancel")));
};

var ImportPageUI =
/*@__PURE__*/
function (superclass) {
  function ImportPageUI() {
    superclass.apply(this, arguments);
  }

  if (superclass) ImportPageUI.__proto__ = superclass;
  ImportPageUI.prototype = Object.create(superclass && superclass.prototype);
  ImportPageUI.prototype.constructor = ImportPageUI;

  ImportPageUI.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(SimplePageHeader, {
      i18nTitle: this.props.i18nPageTitle,
      i18nDescription: this.props.i18nPageDescription
    }), React.createElement(reactCore.PageSection, null, React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.CardBody, null, React.createElement(DndFileChooser, {
      allowMultiple: true,
      fileExtensions: '.zip',
      onUploadRejected: this.props.onUploadRejected,
      disableDropzone: false,
      onUploadAccepted: this.props.onUploadAccepted,
      i18nNoFileSelectedMessage: this.props.i18nNoFileSelectedMessage,
      i18nSelectedFileLabel: this.props.i18nSelectedFileLabel,
      i18nInstructions: this.props.i18nInstructions,
      i18nUploadFailedMessages: this.props.i18nUploadFailedMessages,
      i18nUploadSuccessMessages: this.props.i18nUploadSuccessMessages,
      i18nHelpMessage: this.props.i18nHelpMessage
    })))));
  };

  return ImportPageUI;
}(React.Component);

var IntegrationDetailMetrics =
/*@__PURE__*/
function (superclass) {
  function IntegrationDetailMetrics() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationDetailMetrics.__proto__ = superclass;
  IntegrationDetailMetrics.prototype = Object.create(superclass && superclass.prototype);
  IntegrationDetailMetrics.prototype.constructor = IntegrationDetailMetrics;

  IntegrationDetailMetrics.prototype.render = function render() {
    var okMessagesCount = this.props.messages - this.props.errors;
    var startAsDate = new Date(this.props.start);
    var startAsHuman = startAsDate.toLocaleString();
    return React.createElement(reactCore.PageSection, {
      className: "integration-detail-metrics"
    }, React.createElement(patternflyReact.CardGrid, {
      fluid: true,
      matchHeight: true
    }, React.createElement(patternflyReact.Row, {
      style: {
        marginBottom: '20px',
        marginTop: '20px'
      }
    }, React.createElement(patternflyReact.Col, {
      xs: 6,
      sm: 3,
      md: 3
    }, React.createElement(patternflyReact.Card, {
      "data-testid": 'integration-detail-metrics-total-errors-card',
      accented: true,
      aggregated: true,
      matchHeight: true
    }, React.createElement(patternflyReact.CardTitle, null, this.props.i18nTotalErrors), React.createElement(patternflyReact.CardBody, null, React.createElement(patternflyReact.AggregateStatusNotifications, null, React.createElement(patternflyReact.AggregateStatusNotification, null, React.createElement(patternflyReact.Icon, {
      type: "pf",
      name: "error-circle-o"
    }), this.props.errors))))), React.createElement(patternflyReact.Col, {
      xs: 6,
      sm: 3,
      md: 3
    }, React.createElement(patternflyReact.Card, {
      "data-testid": 'integration-detail-metrics-last-processed-card',
      accented: true,
      aggregated: true,
      matchHeight: true
    }, React.createElement(patternflyReact.CardTitle, null, this.props.i18nLastProcessed), React.createElement(patternflyReact.CardBody, null, React.createElement(patternflyReact.AggregateStatusNotifications, null, React.createElement(patternflyReact.AggregateStatusNotification, null, this.props.lastProcessed))))), React.createElement(patternflyReact.Col, {
      xs: 6,
      sm: 3,
      md: 3
    }, React.createElement(patternflyReact.Card, {
      "data-testid": 'integration-detail-metrics-total-messages-card',
      accented: true,
      aggregated: true,
      matchHeight: true
    }, React.createElement(patternflyReact.CardTitle, null, React.createElement(patternflyReact.AggregateStatusCount, null, this.props.messages, "\xA0"), this.props.i18nTotalMessages), React.createElement(patternflyReact.CardBody, null, React.createElement(patternflyReact.AggregateStatusNotifications, null, React.createElement(patternflyReact.AggregateStatusNotification, null, React.createElement(patternflyReact.Icon, {
      type: "pf",
      name: "ok"
    }), okMessagesCount, "\xA0"), React.createElement(patternflyReact.AggregateStatusNotification, null, React.createElement(patternflyReact.Icon, {
      type: "pf",
      name: "error-circle-o"
    }), this.props.errors))))), React.createElement(patternflyReact.Col, {
      xs: 6,
      sm: 3,
      md: 3
    }, React.createElement(patternflyReact.Card, {
      "data-testid": 'integration-detail-metrics-uptime-card',
      accented: true,
      aggregated: true,
      matchHeight: true
    }, React.createElement(patternflyReact.Card.Title, {
      className: "integration-detail-metrics__uptime-header"
    }, React.createElement("div", null, this.props.i18nUptime), React.createElement("div", {
      className: "integration-detail-metrics__uptime-uptime"
    }, this.props.i18nSince, startAsHuman)), React.createElement(patternflyReact.Card.Body, null, React.createElement(patternflyReact.AggregateStatusNotifications, null, React.createElement(patternflyReact.AggregateStatusNotification, null, this.props.durationDifference))))))));
  };

  return IntegrationDetailMetrics;
}(React.Component);

var ConditionsBackButtonItem = function ConditionsBackButtonItem(ref) {
  var href = ref.href;
  var title = ref.title;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "conditions-back-button-item__back-button-wrapper"
  }, React.createElement(ButtonLink, {
    "data-testid": "conditions-back-button-item-back-button",
    as: "default",
    href: href
  }, title)), React.createElement("div", {
    className: "pf-c-dropdown__separator",
    role: "separator"
  }));
};

var ConditionsDropdown = function ConditionsDropdown(ref) {
  var selectedFlow = ref.selectedFlow;
  var children = ref.children;
  var ref$1 = React.useState(false);
  var isOpen = ref$1[0];
  var setIsOpen = ref$1[1];

  var closeDropdown = function closeDropdown() {
    return setIsOpen(false);
  };

  var toggleDropdown = function toggleDropdown() {
    return setIsOpen(!isOpen);
  };

  return React.createElement(reactCore.Dropdown, {
    onSelect: closeDropdown,
    toggle: React.createElement(reactCore.DropdownToggle, {
      onToggle: toggleDropdown
    }, selectedFlow),
    isOpen: isOpen
  }, children);
};

var ConditionsDropdownBody = function ConditionsDropdownBody(ref) {
  var condition = ref.condition;
  var description = ref.description;
  return React.createElement(React.Fragment, null, React.createElement("strong", {
    className: "conditions-dropdown-item__condition",
    "data-verb": condition
  }, condition), "\xA0", description);
};

var ConditionsDropdownHeader = function ConditionsDropdownHeader(ref) {
  var children = ref.children;
  var title = ref.title;
  return React.createElement("section", {
    className: "pf-c-dropdown__group"
  }, React.createElement("h1", {
    className: "pf-c-dropdown__group-title"
  }, title), React.createElement("ul", null, children));
};

var ConditionsDropdownItem = function ConditionsDropdownItem(ref) {
  var condition = ref.condition;
  var description = ref.description;
  var link = ref.link;
  var name = ref.name;
  return React.createElement("li", null, React.createElement(reactRouterDom.Link, {
    "data-testid": "conditions-dropdown-item-" + toValidHtmlId(condition) + "-link",
    className: "pf-c-dropdown__menu-item",
    to: link
  }, React.createElement("div", null, React.createElement("strong", null, name)), React.createElement("strong", {
    className: "conditions-dropdown-item__condition",
    "data-verb": condition
  }, condition), "\xA0", description));
};

var IntegrationFlowAddStep =
/*@__PURE__*/
function (superclass) {
  function IntegrationFlowAddStep(props) {
    superclass.call(this, props);
    this.state = {
      showTooltip: false
    };
    this.containerRef = React.createRef();
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  if (superclass) IntegrationFlowAddStep.__proto__ = superclass;
  IntegrationFlowAddStep.prototype = Object.create(superclass && superclass.prototype);
  IntegrationFlowAddStep.prototype.constructor = IntegrationFlowAddStep;

  IntegrationFlowAddStep.prototype.showTooltip = function showTooltip() {
    this.setState({
      showTooltip: true
    });
  };

  IntegrationFlowAddStep.prototype.hideTooltip = function hideTooltip() {
    this.setState({
      showTooltip: false
    });
  };

  IntegrationFlowAddStep.prototype.toggleTooltip = function toggleTooltip() {
    this.setState({
      showTooltip: !this.state.showTooltip
    });
  };

  IntegrationFlowAddStep.prototype.render = function render() {
    return React.createElement("div", {
      className: 'integration-flow-add-step',
      onMouseEnter: this.showTooltip,
      onMouseLeave: this.hideTooltip,
      onTouchStart: this.toggleTooltip
    }, this.props.addStepHref && React.createElement("div", {
      className: 'integration-flow-add-step__iconWrapper',
      ref: this.containerRef
    }, React.createElement(reactRouterDom.Link, {
      "data-testid": 'integration-flow-add-step-add-step-link',
      to: this.props.addStepHref
    }, React.createElement("i", {
      className: "fa fa-plus",
      title: this.props.i18nAddStep
    }))), this.props.showDetails && this.props.children);
  };

  return IntegrationFlowAddStep;
}(React.Component);

IntegrationFlowAddStep.defaultProps = {
  active: false
};

var IntegrationFlowStep =
/*@__PURE__*/
function (superclass) {
  function IntegrationFlowStep() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationFlowStep.__proto__ = superclass;
  IntegrationFlowStep.prototype = Object.create(superclass && superclass.prototype);
  IntegrationFlowStep.prototype.constructor = IntegrationFlowStep;

  IntegrationFlowStep.prototype.render = function render() {
    var tooltip = React.createElement(patternflyReact.Tooltip, {
      id: 'integration-flow-step'
    }, this.props.i18nTooltip);
    var icon = React.createElement("div", {
      className: 'integration-flow-step__icon'
    }, this.props.icon);
    return React.createElement("div", {
      className: classnames('integration-flow-step', {
        'is-active': this.props.active,
        'is-expanded': this.props.showDetails
      })
    }, this.props.showDetails ? React.createElement(React.Fragment, null, React.createElement("div", {
      className: 'integration-flow-step__iconWrapper'
    }, icon), this.props.children) : React.createElement("div", {
      className: 'integration-flow-step__iconWrapper'
    }, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: tooltip,
      placement: "right",
      trigger: ['hover', 'focus'],
      rootClose: false
    }, icon)));
  };

  return IntegrationFlowStep;
}(React.Component);

IntegrationFlowStep.defaultProps = {
  active: false
};

var Title = function Title(ref) {
  var children = ref.children;
  return React.createElement("div", {
    className: 'integration-flow-step-details__title'
  }, children);
};

var GenericDescription = function GenericDescription(ref) {
  var children = ref.children;
  return React.createElement("div", {
    className: 'integration-flow-step-details__body'
  }, children);
};

var StepOverview = function StepOverview(ref) {
  var nameI18nLabel = ref.nameI18nLabel;
  var name = ref.name;
  var actionI18nLabel = ref.actionI18nLabel;
  var action = ref.action;
  var dataTypeI18nLabel = ref.dataTypeI18nLabel;
  var dataType = ref.dataType;
  return React.createElement("div", {
    className: 'integration-flow-step-details__body'
  }, React.createElement("dl", {
    className: 'integration-flow-step-details__overview'
  }, React.createElement("dt", null, nameI18nLabel), React.createElement("dd", null, name)), action && React.createElement("dl", {
    className: 'integration-flow-step-details__overview'
  }, React.createElement("dt", null, actionI18nLabel), React.createElement("dd", null, action)), dataType && React.createElement("dl", {
    className: 'integration-flow-step-details__overview'
  }, React.createElement("dt", null, dataTypeI18nLabel), React.createElement("dd", null, dataType)));
};
/**
 * A render prop component that provides the right components than can be used
 * inside a step element of the integration editor sidebar.
 */


var IntegrationFlowStepDetails =
/*@__PURE__*/
function (superclass) {
  function IntegrationFlowStepDetails() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationFlowStepDetails.__proto__ = superclass;
  IntegrationFlowStepDetails.prototype = Object.create(superclass && superclass.prototype);
  IntegrationFlowStepDetails.prototype.constructor = IntegrationFlowStepDetails;

  IntegrationFlowStepDetails.prototype.render = function render() {
    return React.createElement("div", {
      className: classnames('integration-flow-step-details', {
        'is-active': this.props.active
      })
    }, this.props.children({
      GenericDescription: GenericDescription,
      StepOverview: StepOverview,
      Title: Title
    }));
  };

  return IntegrationFlowStepDetails;
}(React.Component);

IntegrationFlowStepDetails.defaultProps = {
  active: false
}; // tslint:disable react-unused-props-and-state

/**
 * A component to show an unconfigured (or being configured) step in the
 * sidebar of the integration editor.
 *
 * @see [icon]{@link IIntegrationFlowStepProps#icon}
 * @see [active]{@link IIntegrationFlowStepProps#active}
 * @see [i18nTitle]{@link IIntegrationFlowStepGenericProps#i18nTitle}
 * @see [i18nTooltip]{@link IIntegrationFlowStepProps#i18nTooltip}
 * @see [showDetails]{@link IIntegrationFlowStepProps#showDetails}
 * @see [description]{@link IIntegrationFlowStepGenericProps#description}
 * @see [href]{@link IIntegrationFlowStepProps#href}
 */

var IntegrationFlowStepGeneric = function IntegrationFlowStepGeneric(ref) {
  var icon = ref.icon;
  var active = ref.active;
  if (active === void 0) active = false;
  var i18nTitle = ref.i18nTitle;
  var i18nTooltip = ref.i18nTooltip;
  var showDetails = ref.showDetails;
  var description = ref.description;
  return React.createElement(IntegrationFlowStep, {
    icon: icon,
    active: active,
    i18nTooltip: i18nTooltip,
    showDetails: showDetails
  }, React.createElement(IntegrationFlowStepDetails, {
    active: active
  }, function (ref) {
    var Title = ref.Title;
    var GenericDescription = ref.GenericDescription;
    return React.createElement(React.Fragment, null, React.createElement(Title, null, i18nTitle), React.createElement(GenericDescription, null, description));
  }));
}; // tslint:disable react-unused-props-and-state

/**
 * A component to show an already configured step in the sidebar of the
 * integration editor.
 *
 * @see [i18nTitle]{@link IIntegrationFlowStepWithOverviewProps#i18nTitle}
 * @see [i18nTooltip]{@link IIntegrationFlowStepProps#i18nTooltip}
 * @see [icon]{@link IIntegrationFlowStepProps#icon}
 * @see [active]{@link IIntegrationFlowStepProps#active}
 * @see [showDetails]{@link IIntegrationFlowStepProps#showDetails}
 * @see [name]{@link IIntegrationFlowStepWithOverviewProps#name}
 * @see [action]{@link IIntegrationFlowStepWithOverviewProps#action}
 * @see [dataType]{@link IIntegrationFlowStepWithOverviewProps#dataType}
 * @constructor
 */


var IntegrationFlowStepWithOverview = function IntegrationFlowStepWithOverview(ref) {
  var i18nTitle = ref.i18nTitle;
  var i18nTooltip = ref.i18nTooltip;
  var icon = ref.icon;
  var active = ref.active;
  if (active === void 0) active = false;
  var showDetails = ref.showDetails;
  var name = ref.name;
  var action = ref.action;
  var dataType = ref.dataType;
  return React.createElement(IntegrationFlowStep, {
    icon: icon,
    active: active,
    i18nTooltip: i18nTooltip,
    showDetails: showDetails
  }, React.createElement(IntegrationFlowStepDetails, {
    active: active
  }, function (ref) {
    var Title = ref.Title;
    var StepOverview = ref.StepOverview;
    return React.createElement(React.Fragment, null, React.createElement(Title, null, i18nTitle), React.createElement(StepOverview, {
      nameI18nLabel: 'Name:',
      name: name,
      actionI18nLabel: 'Action:',
      action: action,
      dataTypeI18nLabel: 'Data Type:',
      dataType: dataType
    }));
  }));
}; // tslint:disable react-unused-props-and-state


var IntegrationIcon = function IntegrationIcon(ref) {
  var startConnectionIcon = ref.startConnectionIcon;
  var finishConnectionIcon = ref.finishConnectionIcon;
  return React.createElement("div", {
    className: 'integration-icon'
  }, startConnectionIcon, React.createElement("i", {
    className: "fa fa-angle-right integration-icon__divider"
  }), finishConnectionIcon);
};
/**
 * A component to render a save form, to be used in the integration
 * editor. This does *not* build the form itself, form's field should be passed
 * as the `children` value.
 * @see [i18nTitle]{@link IIntegrationSaveFormProps#i18nTitle}
 */


var IntegrationSaveForm = function IntegrationSaveForm(ref) {
  var i18nFormTitle = ref.i18nFormTitle;
  var handleSubmit = ref.handleSubmit;
  var onPublish = ref.onPublish;
  var onSave = ref.onSave;
  var isSaveDisabled = ref.isSaveDisabled;
  var isSaveLoading = ref.isSaveLoading;
  var isPublishDisabled = ref.isPublishDisabled;
  var isPublishLoading = ref.isPublishLoading;
  var i18nSave = ref.i18nSave;
  var i18nSaveAndPublish = ref.i18nSaveAndPublish;
  var children = ref.children;
  return React.createElement(reactCore.PageSection, null, React.createElement("form", {
    className: "form-horizontal required-pf",
    role: "form",
    onSubmit: handleSubmit,
    style: {
      margin: 'auto',
      maxWidth: 600
    }
  }, React.createElement("div", {
    className: "row row-cards-pf"
  }, React.createElement("div", {
    className: "card-pf"
  }, i18nFormTitle && React.createElement("div", {
    className: "card-pf-title"
  }, i18nFormTitle), React.createElement("div", {
    className: "card-pf-body"
  }, React.createElement(Container, null, children)), React.createElement("div", {
    className: "card-pf-footer"
  }, React.createElement(ButtonLink, {
    id: 'integration-editor-save-button',
    onClick: onSave,
    disabled: isSaveLoading || isSaveDisabled
  }, isSaveLoading ? React.createElement(Loader, {
    size: 'xs',
    inline: true
  }) : null, i18nSave), "\xA0", React.createElement(ButtonLink, {
    id: 'integration-editor-publish-button',
    onClick: onPublish,
    as: 'primary',
    disabled: isPublishLoading || isPublishDisabled
  }, i18nSaveAndPublish))))));
};

var IntegrationStatus =
/*@__PURE__*/
function (superclass) {
  function IntegrationStatus() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationStatus.__proto__ = superclass;
  IntegrationStatus.prototype = Object.create(superclass && superclass.prototype);
  IntegrationStatus.prototype.constructor = IntegrationStatus;

  IntegrationStatus.prototype.render = function render() {
    var labelType = this.props.currentState === ERROR ? 'danger' : this.props.currentState === PUBLISHED || this.props.currentState === PENDING ? 'primary' : 'default';
    var label = PENDING; // it's a parachute

    switch (this.props.currentState) {
      case PUBLISHED:
        label = this.props.i18nPublished;
        break;

      case UNPUBLISHED:
        label = this.props.i18nUnpublished;
        break;

      case ERROR:
        label = this.props.i18nError;
        break;
    }

    return React.createElement(patternflyReact.Label, {
      "data-testid": 'integration-status-status-label',
      className: classnames('', this.props.className),
      type: labelType
    }, label);
  };

  return IntegrationStatus;
}(React.Component);

var IntegrationStepsHorizontalItem =
/*@__PURE__*/
function (superclass) {
  function IntegrationStepsHorizontalItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationStepsHorizontalItem.__proto__ = superclass;
  IntegrationStepsHorizontalItem.prototype = Object.create(superclass && superclass.prototype);
  IntegrationStepsHorizontalItem.prototype.constructor = IntegrationStepsHorizontalItem;

  IntegrationStepsHorizontalItem.prototype.render = function render() {
    return React.createElement("div", {
      className: "integration-steps-horizontal-item"
    }, this.props.isFirst === false ? React.createElement(patternflyReact.Icon, {
      name: 'angle-right',
      className: "step-arrow"
    }) : null, !this.props.href && React.createElement("div", null, React.createElement("div", {
      className: 'step-icon',
      title: this.props.title
    }, this.props.icon), React.createElement("p", null, this.props.name)), this.props.href && React.createElement(reactRouterDom.Link, {
      to: this.props.href
    }, React.createElement("div", null, React.createElement("div", {
      className: 'step-icon',
      title: this.props.title
    }, this.props.icon), React.createElement("p", null, this.props.name))));
  };

  return IntegrationStepsHorizontalItem;
}(React.Component);

var IntegrationStepsHorizontalView =
/*@__PURE__*/
function (superclass) {
  function IntegrationStepsHorizontalView() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationStepsHorizontalView.__proto__ = superclass;
  IntegrationStepsHorizontalView.prototype = Object.create(superclass && superclass.prototype);
  IntegrationStepsHorizontalView.prototype.constructor = IntegrationStepsHorizontalView;

  IntegrationStepsHorizontalView.prototype.render = function render() {
    return React.createElement("div", {
      className: "show-grid"
    }, this.props.children);
  };

  return IntegrationStepsHorizontalView;
}(React.Component);
/**
 * A component to render an expandable container meant to be used to show an
 * integration's steps.
 * @see [children]{@link IIntegrationVerticalFlowProps#children}
 */


var IntegrationVerticalFlow = function IntegrationVerticalFlow(ref) {
  var children = ref.children;
  var initialExpanded = ref.initialExpanded;
  if (initialExpanded === void 0) initialExpanded = true;
  var ref$1 = React.useState(initialExpanded !== undefined ? initialExpanded : (localStorage.getItem('iec-vertical-flow-expanded') || 'y') === 'y');
  var expanded = ref$1[0];
  var setExpanded = ref$1[1];

  var toggleExpanded = function toggleExpanded() {
    localStorage.setItem('iec-vertical-flow-expanded', !expanded ? 'y' : 'n');
    setExpanded(!expanded);
  };

  return React.createElement("div", {
    className: classnames('integration-vertical-flow', {
      'is-expanded': expanded
    })
  }, React.createElement("div", {
    className: "integration-vertical-flow__expand"
  }, React.createElement(ButtonLink, {
    "data-testid": 'integration-vertical-flow-expand-collapse-button',
    className: "integration-vertical-flow__toggle",
    onClick: toggleExpanded,
    as: 'link'
  }, expanded === false ? React.createElement(React.Fragment, null, "Expand", ' ', React.createElement("i", {
    className: "fa fa-angle-double-right integration-vertical-flow__icon"
  })) : React.createElement(React.Fragment, null, "Collapse", ' ', React.createElement("i", {
    className: "fa fa-angle-double-left integration-vertical-flow__icon"
  })))), React.createElement("div", {
    className: "integration-vertical-flow__body"
  }, children({
    expanded: expanded
  })));
};

var IntegrationsList =
/*@__PURE__*/
function (superclass) {
  function IntegrationsList() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationsList.__proto__ = superclass;
  IntegrationsList.prototype = Object.create(superclass && superclass.prototype);
  IntegrationsList.prototype.constructor = IntegrationsList;

  IntegrationsList.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView, null, this.props.children);
  };

  return IntegrationsList;
}(React.Component);

var IntegrationsListItem =
/*@__PURE__*/
function (superclass) {
  function IntegrationsListItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationsListItem.__proto__ = superclass;
  IntegrationsListItem.prototype = Object.create(superclass && superclass.prototype);
  IntegrationsListItem.prototype.constructor = IntegrationsListItem;

  IntegrationsListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListView.Item, {
      "data-testid": "integrations-list-item-" + toValidHtmlId(this.props.integrationName) + "-list-item",
      checkboxInput: this.props.checkboxComponent || undefined,
      actions: this.props.actions,
      heading: this.props.integrationName,
      className: 'integration-list-item',
      additionalInfo: [React.createElement(patternflyReact.ListView.InfoItem, {
        key: 1,
        className: 'integration-list-item__additional-info'
      }, this.props.currentState === 'Pending' ? React.createElement(IntegrationStatusDetail, {
        targetState: this.props.targetState,
        value: this.props.monitoringValue,
        currentStep: this.props.monitoringCurrentStep,
        totalSteps: this.props.monitoringTotalSteps,
        logUrl: this.props.monitoringLogUrl,
        i18nProgressPending: this.props.i18nProgressPending,
        i18nProgressStarting: this.props.i18nProgressStarting,
        i18nProgressStopping: this.props.i18nProgressStopping,
        i18nLogUrlText: this.props.i18nLogUrlText
      }) : React.createElement(IntegrationStatus, {
        currentState: this.props.currentState,
        i18nPublished: this.props.i18nPublished,
        i18nUnpublished: this.props.i18nUnpublished,
        i18nError: this.props.i18nError
      })), React.createElement(patternflyReact.ListView.InfoItem, {
        key: 2,
        className: 'integration-list-item__additional-info'
      }, this.props.isConfigurationRequired && React.createElement("div", {
        className: 'integration-list-item__config-required'
      }, React.createElement(patternflyReact.Icon, {
        type: 'pf',
        name: 'warning-triangle-o',
        className: "pf-u-mr-xs"
      }), this.props.i18nConfigurationRequired))],
      leftContent: React.createElement(IntegrationIcon, {
        startConnectionIcon: this.props.startConnectionIcon,
        finishConnectionIcon: this.props.finishConnectionIcon
      }),
      stacked: false
    });
  };

  return IntegrationsListItem;
}(React.Component);

var IntegrationsListItemBasic =
/*@__PURE__*/
function (superclass) {
  function IntegrationsListItemBasic() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationsListItemBasic.__proto__ = superclass;
  IntegrationsListItemBasic.prototype = Object.create(superclass && superclass.prototype);
  IntegrationsListItemBasic.prototype.constructor = IntegrationsListItemBasic;

  IntegrationsListItemBasic.prototype.render = function render() {
    var ref = this.props;
    var className = ref.className;
    var checkboxComponent = ref.checkboxComponent;
    var integrationName = ref.integrationName;
    var additionalInfo = ref.additionalInfo;
    return React.createElement(patternflyReact.ListView.Item, {
      className: classnames('', className),
      checkboxInput: checkboxComponent || undefined,
      heading: integrationName,
      additionalInfo: [React.createElement(patternflyReact.ListView.InfoItem, {
        key: 1
      }, additionalInfo)],
      stacked: true
    });
  };

  return IntegrationsListItemBasic;
}(React.Component);

var IntegrationsListItemUnreadable = function IntegrationsListItemUnreadable(ref) {
  var integrationName = ref.integrationName;
  var i18nDescription = ref.i18nDescription;
  var rawObject = ref.rawObject;

  var onClick = function onClick() {
    return window.alert(rawObject);
  };

  return React.createElement(patternflyReact.ListView.Item, {
    heading: integrationName,
    actions: React.createElement(ButtonLink, {
      "data-testid": 'integrations-list-item-unreadable-json-button',
      onClick: onClick
    }, "Integration JSON"),
    description: i18nDescription,
    stacked: true
  });
};

function getRandom$1(min, max) {
  return Math.random() * (max - min) + min;
}

var ItemSkeleton$1 = function ItemSkeleton$1() {
  return React.createElement(ContentLoader, {
    height: 80,
    width: 400,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: {
      height: 80
    }
  }, React.createElement("circle", {
    cx: "35",
    cy: "40",
    r: "25"
  }), React.createElement("circle", {
    cx: "95",
    cy: "40",
    r: "25"
  }), React.createElement("rect", {
    x: "145",
    y: "20",
    rx: "5",
    ry: "5",
    width: 350 * getRandom$1(0.6, 1),
    height: "18"
  }), React.createElement("rect", {
    x: "145",
    y: "55",
    rx: "5",
    ry: "5",
    width: 200 * getRandom$1(0.6, 1),
    height: "15"
  }));
};

var IntegrationsListSkeleton =
/*@__PURE__*/
function (superclass) {
  function IntegrationsListSkeleton() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationsListSkeleton.__proto__ = superclass;
  IntegrationsListSkeleton.prototype = Object.create(superclass && superclass.prototype);
  IntegrationsListSkeleton.prototype.constructor = IntegrationsListSkeleton;

  IntegrationsListSkeleton.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: 'list-group-item',
      "data-testid": 'integrations-list-skeleton-item-0'
    }, React.createElement("div", null, React.createElement(ItemSkeleton$1, null))), React.createElement("div", {
      className: 'list-group-item',
      "data-testid": 'integrations-list-skeleton-item-1'
    }, React.createElement("div", null, React.createElement(ItemSkeleton$1, null))), React.createElement("div", {
      className: 'list-group-item',
      "data-testid": 'integrations-list-skeleton-item-2'
    }, React.createElement("div", null, React.createElement(ItemSkeleton$1, null))));
  };

  return IntegrationsListSkeleton;
}(React.PureComponent);

var IntegrationsListView =
/*@__PURE__*/
function (superclass) {
  function IntegrationsListView() {
    superclass.apply(this, arguments);
  }

  if (superclass) IntegrationsListView.__proto__ = superclass;
  IntegrationsListView.prototype = Object.create(superclass && superclass.prototype);
  IntegrationsListView.prototype.constructor = IntegrationsListView;

  IntegrationsListView.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(SimplePageHeader, {
      i18nTitle: this.props.i18nTitle,
      i18nDescription: this.props.i18nDescription
    }), React.createElement(reactCore.PageSection, null, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, React.createElement(ButtonLink, {
      "data-testid": 'integrations-list-view-manage-cicd-button',
      href: this.props.linkToManageCiCd
    }, this.props.i18nManageCiCd), React.createElement(ButtonLink, {
      "data-testid": 'integrations-list-view-import-button',
      href: this.props.linkToIntegrationImport
    }, this.props.i18nImport), React.createElement(ButtonLink, {
      "data-testid": 'integrations-list-view-create-button',
      href: this.props.linkToIntegrationCreation,
      as: 'primary'
    }, this.props.i18nLinkCreateConnection))), this.props.children));
  };

  return IntegrationsListView;
}(React.Component);

var OperationsDropdown = function OperationsDropdown(ref) {
  var selectedOperation = ref.selectedOperation;
  var children = ref.children;
  var ref$1 = React.useState(false);
  var isOpen = ref$1[0];
  var setIsOpen = ref$1[1];

  var closeDropdown = function closeDropdown() {
    return setIsOpen(false);
  };

  var toggleDropdown = function toggleDropdown() {
    return setIsOpen(!isOpen);
  };

  return React.createElement(reactCore.Dropdown, {
    className: 'operations-dropdown',
    onSelect: closeDropdown,
    toggle: React.createElement(reactCore.DropdownToggle, {
      onToggle: toggleDropdown
    }, selectedOperation),
    isOpen: isOpen
  }, children);
};

var RecentUpdatesItem = function RecentUpdatesItem(ref) {
  var integrationName = ref.integrationName;
  var integrationCurrentState = ref.integrationCurrentState;
  var integrationDate = ref.integrationDate;
  var i18nError = ref.i18nError;
  var i18nPublished = ref.i18nPublished;
  var i18nUnpublished = ref.i18nUnpublished;
  return React.createElement(patternflyReact.Grid.Row, {
    xs: 12,
    className: 'recent-updates-item',
    "data-testid": "recent-updates-item-" + toValidHtmlId(integrationName) + "-row"
  }, React.createElement(patternflyReact.Grid.Col, {
    className: "recent-updates-item__title-container",
    xs: 5
  }, integrationName), React.createElement(patternflyReact.Grid.Col, {
    xs: 3
  }, React.createElement(IntegrationStatus, {
    currentState: integrationCurrentState,
    i18nError: i18nError,
    i18nPublished: i18nPublished,
    i18nUnpublished: i18nUnpublished
  })), React.createElement(patternflyReact.Grid.Col, {
    xs: 4
  }, integrationDate));
};

var RecentUpdatesSkeleton = function RecentUpdatesSkeleton(props) {
  return React.createElement(ContentLoader, Object.assign({
    height: 150,
    width: 350,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb"
  }, props), React.createElement("rect", {
    x: "20",
    y: "5",
    rx: "5",
    ry: "5",
    width: "100",
    height: "10"
  }), React.createElement("rect", {
    x: "150",
    y: "5",
    rx: "5",
    ry: "5",
    width: "30",
    height: "10"
  }), React.createElement("rect", {
    x: "250",
    y: "5",
    rx: "5",
    ry: "5",
    width: "40",
    height: "10"
  }), React.createElement("rect", {
    x: "20",
    y: "35",
    rx: "5",
    ry: "5",
    width: "80",
    height: "10"
  }), React.createElement("rect", {
    x: "150",
    y: "35",
    rx: "5",
    ry: "5",
    width: "30",
    height: "10"
  }), React.createElement("rect", {
    x: "250",
    y: "35",
    rx: "5",
    ry: "5",
    width: "40",
    height: "10"
  }), React.createElement("rect", {
    x: "20",
    y: "65",
    rx: "5",
    ry: "5",
    width: "95",
    height: "10"
  }), React.createElement("rect", {
    x: "150",
    y: "65",
    rx: "5",
    ry: "5",
    width: "30",
    height: "10"
  }), React.createElement("rect", {
    x: "250",
    y: "65",
    rx: "5",
    ry: "5",
    width: "40",
    height: "10"
  }), React.createElement("rect", {
    x: "20",
    y: "95",
    rx: "5",
    ry: "5",
    width: "125",
    height: "10"
  }), React.createElement("rect", {
    x: "150",
    y: "95",
    rx: "5",
    ry: "5",
    width: "30",
    height: "10"
  }), React.createElement("rect", {
    x: "250",
    y: "95",
    rx: "5",
    ry: "5",
    width: "40",
    height: "10"
  }), React.createElement("rect", {
    x: "20",
    y: "125",
    rx: "5",
    ry: "5",
    width: "65",
    height: "10"
  }), React.createElement("rect", {
    x: "150",
    y: "125",
    rx: "5",
    ry: "5",
    width: "30",
    height: "10"
  }), React.createElement("rect", {
    x: "250",
    y: "125",
    rx: "5",
    ry: "5",
    width: "40",
    height: "10"
  }));
};

var TopIntegrationsCard =
/*@__PURE__*/
function (superclass) {
  function TopIntegrationsCard() {
    superclass.apply(this, arguments);
  }

  if (superclass) TopIntegrationsCard.__proto__ = superclass;
  TopIntegrationsCard.prototype = Object.create(superclass && superclass.prototype);
  TopIntegrationsCard.prototype.constructor = TopIntegrationsCard;

  TopIntegrationsCard.prototype.render = function render() {
    return React.createElement(patternflyReact.Card, {
      accented: false,
      className: 'top-integrations'
    }, React.createElement(patternflyReact.Card.Heading, {
      className: 'top-integrations__heading'
    }, React.createElement(patternflyReact.Card.Title, null, this.props.i18nTitle), React.createElement("div", {
      className: 'top-integrations__heading-daterange'
    }, this.props.i18nLast30Days)), React.createElement(patternflyReact.Card.Body, null, this.props.children));
  };

  return TopIntegrationsCard;
}(React.Component);

var UptimeMetric =
/*@__PURE__*/
function (superclass) {
  function UptimeMetric() {
    superclass.apply(this, arguments);
  }

  if (superclass) UptimeMetric.__proto__ = superclass;
  UptimeMetric.prototype = Object.create(superclass && superclass.prototype);
  UptimeMetric.prototype.constructor = UptimeMetric;

  UptimeMetric.prototype.render = function render() {
    var startAsDate = new Date(this.props.start);
    var startAsHuman = startAsDate.toLocaleString();
    return React.createElement(patternflyReact.Card, {
      className: "metrics-uptime",
      accented: true,
      aggregated: true,
      matchHeight: true
    }, React.createElement(patternflyReact.Card.Title, {
      className: "metrics-uptime__header"
    }, React.createElement("div", null, this.props.i18nTitle), React.createElement("div", {
      className: "metrics-uptime__uptime"
    }, "since ", startAsHuman)), React.createElement(patternflyReact.Card.Body, null, React.createElement("span", null, this.props.durationDifference)));
  };

  return UptimeMetric;
}(React.PureComponent);

var ViewListItem =
/*@__PURE__*/
function (superclass) {
  function ViewListItem(props) {
    superclass.call(this, props);
    this.state = {
      showDeleteDialog: false
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.showDeleteDialog = this.showDeleteDialog.bind(this);
  }

  if (superclass) ViewListItem.__proto__ = superclass;
  ViewListItem.prototype = Object.create(superclass && superclass.prototype);
  ViewListItem.prototype.constructor = ViewListItem;

  ViewListItem.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(ConfirmationDialog, {
      buttonStyle: exports.ConfirmationButtonStyle.DANGER,
      i18nCancelButtonText: this.props.i18nCancelText,
      i18nConfirmButtonText: this.props.i18nDelete,
      i18nConfirmationMessage: this.props.i18nDeleteModalMessage,
      i18nTitle: this.props.i18nDeleteModalTitle,
      icon: exports.ConfirmationIconType.DANGER,
      showDialog: this.state.showDeleteDialog,
      onCancel: this.handleCancel,
      onConfirm: this.handleDelete
    }), React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "view-list-item-" + toValidHtmlId(this.props.viewName) + "-list-item",
      actions: React.createElement("div", {
        className: "form-group"
      }, React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getEditTooltip(),
        placement: "top"
      }, React.createElement(ButtonLink, {
        "data-testid": 'view-list-item-edit-button',
        href: this.props.viewEditPageLink,
        as: 'default'
      }, this.props.i18nEdit)), React.createElement(patternflyReact.DropdownKebab, {
        id: "view-" + this.props.viewName + "-action-menu",
        pullRight: true
      }, React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getDeleteTooltip(),
        placement: "left"
      }, React.createElement(patternflyReact.MenuItem, {
        onClick: this.showDeleteDialog
      }, this.props.i18nDelete)))),
      heading: this.props.viewName,
      description: this.props.viewDescription ? this.props.viewDescription : '',
      hideCloseIcon: true,
      leftContent: this.props.viewIcon ? React.createElement("div", {
        className: "blank-slate-pf-icon"
      }, React.createElement("img", {
        src: this.props.viewIcon,
        alt: this.props.viewName,
        width: 46
      })) : React.createElement(patternflyReact.ListViewIcon, {
        name: 'table'
      }),
      stacked: false
    }));
  };

  ViewListItem.prototype.getDeleteTooltip = function getDeleteTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "deleteTip"
    }, this.props.i18nDeleteTip ? this.props.i18nDeleteTip : this.props.i18nDelete);
  };

  ViewListItem.prototype.getEditTooltip = function getEditTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "editTip"
    }, this.props.i18nEditTip ? this.props.i18nEditTip : this.props.i18nEdit);
  };

  ViewListItem.prototype.handleCancel = function handleCancel() {
    this.setState({
      showDeleteDialog: false
    });
  };

  ViewListItem.prototype.showDeleteDialog = function showDeleteDialog() {
    this.setState({
      showDeleteDialog: true
    });
  };

  ViewListItem.prototype.handleDelete = function handleDelete() {
    this.setState({
      showDeleteDialog: false
    }); // TODO: disable components while delete is processing

    if (this.props.viewName) {
      this.props.onDelete(this.props.viewName);
    }
  };

  return ViewListItem;
}(React.Component);

var EmptyViewsState =
/*@__PURE__*/
function (superclass) {
  function EmptyViewsState() {
    superclass.apply(this, arguments);
  }

  if (superclass) EmptyViewsState.__proto__ = superclass;
  EmptyViewsState.prototype = Object.create(superclass && superclass.prototype);
  EmptyViewsState.prototype.constructor = EmptyViewsState;

  EmptyViewsState.prototype.render = function render() {
    return React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Icon, null), React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyStateTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyStateInfo), React.createElement(patternflyReact.EmptyState.Action, null, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getImportViewsTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'empty-views-state-import-views-button',
      href: this.props.linkImportViewsHRef,
      as: 'default',
      className: 'empty-views-import'
    }, this.props.i18nImportViews)), React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getCreateViewTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'empty-views-state-create-view-button',
      href: this.props.linkCreateViewHRef,
      as: 'primary'
    }, this.props.i18nCreateView))));
  };

  EmptyViewsState.prototype.getCreateViewTooltip = function getCreateViewTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "createTip"
    }, this.props.i18nCreateViewTip ? this.props.i18nCreateViewTip : this.props.i18nCreateView);
  };

  EmptyViewsState.prototype.getImportViewsTooltip = function getImportViewsTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "importViewsTip"
    }, this.props.i18nImportViewsTip ? this.props.i18nImportViewsTip : this.props.i18nImportViews);
  };

  return EmptyViewsState;
}(React.Component);

var ViewList =
/*@__PURE__*/
function (superclass) {
  function ViewList(props) {
    superclass.call(this, props);
  }

  if (superclass) ViewList.__proto__ = superclass;
  ViewList.prototype = Object.create(superclass && superclass.prototype);
  ViewList.prototype.constructor = ViewList;

  ViewList.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(reactCore.PageSection, {
      noPadding: true,
      variant: 'light'
    }, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getImportViewsTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'view-list-import-views-button',
      href: this.props.linkImportViewsHRef,
      as: 'default'
    }, this.props.i18nImportViews)), React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getCreateViewTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'view-list-create-view-button',
      href: this.props.linkCreateViewHRef,
      as: 'primary'
    }, this.props.i18nCreateView))))), React.createElement(reactCore.PageSection, {
      noPadding: true,
      variant: 'light'
    }, this.props.hasListData ? React.createElement(patternflyReact.ListView, null, this.props.children) : React.createElement(EmptyViewsState, {
      i18nEmptyStateTitle: this.props.i18nEmptyStateTitle,
      i18nEmptyStateInfo: this.props.i18nEmptyStateInfo,
      i18nCreateView: this.props.i18nCreateView,
      i18nCreateViewTip: this.props.i18nCreateViewTip,
      i18nImportViews: this.props.i18nImportViews,
      i18nImportViewsTip: this.props.i18nImportViewsTip,
      linkCreateViewHRef: this.props.linkCreateViewHRef,
      linkImportViewsHRef: this.props.linkImportViewsHRef
    })));
  };

  ViewList.prototype.getCreateViewTooltip = function getCreateViewTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "createTip"
    }, this.props.i18nCreateViewTip ? this.props.i18nCreateViewTip : this.props.i18nCreateView);
  };

  ViewList.prototype.getImportViewsTooltip = function getImportViewsTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "importViewsTip"
    }, this.props.i18nImportViewsTip ? this.props.i18nImportViewsTip : this.props.i18nImportViews);
  };

  return ViewList;
}(React.Component); // tslint:disable react-unused-props-and-state


var ViewListSkeleton = function ViewListSkeleton(ref) {
  var width = ref.width;
  var style = ref.style;
  return React.createElement(ContentLoader, {
    height: 356,
    width: width,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: style
  }, React.createElement("circle", {
    cx: "30",
    cy: "40",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "40",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "35",
    rx: "5",
    ry: "5",
    width: "200",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "35",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "110",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "110",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "105",
    rx: "5",
    ry: "5",
    width: "180",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "105",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "180",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "180",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "175",
    rx: "5",
    ry: "5",
    width: "195",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "175",
    rx: "5",
    ry: "5",
    width: "85",
    height: "15"
  }));
};

(function (ConnectionStatus) {
  ConnectionStatus["ACTIVE"] = "ACTIVE";
  ConnectionStatus["INACTIVE"] = "INACTIVE";
})(exports.ConnectionStatus || (exports.ConnectionStatus = {}));

var DvConnectionCard =
/*@__PURE__*/
function (superclass) {
  function DvConnectionCard(props) {
    var this$1 = this;
    superclass.call(this, props);

    this.toggleSelected = function (connName) {
      return function (event) {
        // User can only select active connections
        if (this$1.props.dvStatus === exports.ConnectionStatus.ACTIVE) {
          this$1.setState({
            isSelected: !this$1.state.isSelected
          });
          this$1.props.onSelectionChanged(connName, !this$1.state.isSelected);
        }
      };
    };

    this.state = {
      isSelected: props.selected
    };
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  if (superclass) DvConnectionCard.__proto__ = superclass;
  DvConnectionCard.prototype = Object.create(superclass && superclass.prototype);
  DvConnectionCard.prototype.constructor = DvConnectionCard;

  DvConnectionCard.prototype.render = function render() {
    return React.createElement("div", {
      className: 'dv-connection-card',
      onClick: this.toggleSelected(this.props.name)
    }, React.createElement(patternflyReact.Card, {
      "data-testid": "dv-connection-card-" + toValidHtmlId(this.props.name) + "-card",
      matchHeight: true,
      accented: this.state.isSelected
    }, React.createElement(patternflyReact.Card.Body, null, React.createElement("div", {
      className: "dv-connection-card__status"
    }, React.createElement(patternflyReact.Label, {
      type: this.props.dvStatus === exports.ConnectionStatus.ACTIVE ? 'success' : 'danger'
    }, this.props.dvStatus)), React.createElement("div", {
      className: 'dv-connection-card__content'
    }, React.createElement("div", {
      className: "dv-connection-card__icon"
    }, this.props.icon), React.createElement("div", {
      className: "dv-connection-card__title h2",
      "data-testid": 'dv-connection-card--title'
    }, this.props.name), React.createElement(reactCore.Text, {
      className: "dv-connection-card__description"
    }, this.props.description)))));
  };

  return DvConnectionCard;
}(React.PureComponent);

var DvConnectionsGrid =
/*@__PURE__*/
function (superclass) {
  function DvConnectionsGrid() {
    superclass.apply(this, arguments);
  }

  if (superclass) DvConnectionsGrid.__proto__ = superclass;
  DvConnectionsGrid.prototype = Object.create(superclass && superclass.prototype);
  DvConnectionsGrid.prototype.constructor = DvConnectionsGrid;

  DvConnectionsGrid.prototype.render = function render() {
    return React.createElement(patternflyReact.CardGrid, {
      fluid: true,
      matchHeight: true
    }, React.createElement(patternflyReact.CardGrid.Row, null, this.props.children));
  };

  return DvConnectionsGrid;
}(React.Component);

var DvConnectionsGridCell =
/*@__PURE__*/
function (superclass) {
  function DvConnectionsGridCell() {
    superclass.apply(this, arguments);
  }

  if (superclass) DvConnectionsGridCell.__proto__ = superclass;
  DvConnectionsGridCell.prototype = Object.create(superclass && superclass.prototype);
  DvConnectionsGridCell.prototype.constructor = DvConnectionsGridCell;

  DvConnectionsGridCell.prototype.render = function render() {
    return React.createElement(patternflyReact.CardGrid.Col, {
      xs: 6,
      md: 3
    }, this.props.children);
  };

  return DvConnectionsGridCell;
}(React.Component);

var DvConnectionSkeleton = function DvConnectionSkeleton(props) {
  return React.createElement(patternflyReact.Card, {
    matchHeight: true
  }, React.createElement(patternflyReact.Card.Body, null, React.createElement(patternflyReact.EmptyState, null, React.createElement(ContentLoader, Object.assign({
    height: 300,
    width: 200,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb"
  }, props), React.createElement("circle", {
    cx: "100",
    cy: "50",
    r: "40"
  }), React.createElement("rect", {
    x: "5",
    y: "125",
    rx: "5",
    ry: "5",
    width: "190",
    height: "30"
  }), React.createElement("rect", {
    x: "25",
    y: "180",
    rx: "5",
    ry: "5",
    width: "150",
    height: "15"
  }), React.createElement("rect", {
    x: "40",
    y: "205",
    rx: "5",
    ry: "5",
    width: "120",
    height: "15"
  })))));
};

var DvConnectionsListView =
/*@__PURE__*/
function (superclass) {
  function DvConnectionsListView() {
    superclass.apply(this, arguments);
  }

  if (superclass) DvConnectionsListView.__proto__ = superclass;
  DvConnectionsListView.prototype = Object.create(superclass && superclass.prototype);
  DvConnectionsListView.prototype.constructor = DvConnectionsListView;

  DvConnectionsListView.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, {
      noPadding: true
    }, this.props.resultsCount > 0 ? React.createElement(reactCore.PageSection, null, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, React.createElement(ButtonLink, {
      "data-testid": 'dv-connections-list-view-create-connection-button',
      href: this.props.linkToConnectionCreate,
      as: 'primary'
    }, this.props.i18nLinkCreateConnection))), React.createElement(Container, null, this.props.children)) : React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyStateTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyStateInfo)));
  };

  return DvConnectionsListView;
}(React.Component);

var SchemaNodeListItem =
/*@__PURE__*/
function (superclass) {
  function SchemaNodeListItem(props) {
    var this$1 = this;
    superclass.call(this, props);

    this.handleCheckboxToggle = function (connectionName, nodePath) {
      return function (event) {
        this$1.setState({
          itemSelected: !this$1.state.itemSelected
        });
        this$1.props.onSelectionChanged(connectionName, nodePath, !this$1.state.itemSelected);
      };
    };

    this.state = {
      itemSelected: props.selected
    };
    this.handleCheckboxToggle = this.handleCheckboxToggle.bind(this);
  }

  if (superclass) SchemaNodeListItem.__proto__ = superclass;
  SchemaNodeListItem.prototype = Object.create(superclass && superclass.prototype);
  SchemaNodeListItem.prototype.constructor = SchemaNodeListItem;

  SchemaNodeListItem.prototype.schemaDisplayPath = function schemaDisplayPath(schemaPath) {
    var result = '';
    schemaPath.split('/').map(function (segment) {
      return result += '/' + segment.split('=')[1];
    });
    return result;
  };

  SchemaNodeListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "schema-node-list-item-" + toValidHtmlId(this.props.name) + "-list-item",
      heading: this.props.name,
      className: 'schema-node-list-item',
      description: this.schemaDisplayPath(this.props.schemaPath),
      checkboxInput: React.createElement("input", {
        "data-testid": 'schema-node-list-item-selected-input',
        type: "checkbox",
        value: "",
        defaultChecked: this.props.selected,
        onChange: this.handleCheckboxToggle(this.props.connectionName, this.props.schemaPath)
      }),
      hideCloseIcon: true,
      stacked: false
    });
  };

  return SchemaNodeListItem;
}(React.Component);

var ViewEditContent =
/*@__PURE__*/
function (superclass) {
  function ViewEditContent(props) {
    var this$1 = this;
    superclass.call(this, props);

    this.handleDdlValidation = function () {
      return function (event) {
        var currentDdl = this$1.state.ddlValue;
        this$1.props.onValidate(currentDdl);
        this$1.setState({
          needsValidation: false
        });
      };
    };

    this.handleSave = function () {
      return function (event) {
        var currentDdl = this$1.state.ddlValue;
        this$1.props.onSave(currentDdl);
      };
    };

    this.state = {
      ddlChanged: false,
      ddlValue: this.props.viewDdl,
      initialDdlValue: this.props.viewDdl,
      needsValidation: false
    };
    this.handleDdlChange = this.handleDdlChange.bind(this);
    this.handleDdlValidation = this.handleDdlValidation.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  if (superclass) ViewEditContent.__proto__ = superclass;
  ViewEditContent.prototype = Object.create(superclass && superclass.prototype);
  ViewEditContent.prototype.constructor = ViewEditContent;

  ViewEditContent.prototype.handleDdlChange = function handleDdlChange(editor, data, value) {
    this.setState({
      ddlChanged: true,
      ddlValue: value,
      needsValidation: true
    });
  };

  ViewEditContent.prototype.render = function render() {
    var editorOptions = {
      autofocus: true,
      extraKeys: {
        'Ctrl-Space': 'autocomplete'
      },
      gutters: ['CodeMirror-lint-markers'],
      // TODO: dynamically generate the table - column hints
      // hintOptions: {
      //   tables: {
      //     countries: ['name', 'population', 'size'],
      //     users: ['name', 'score', 'birthDate'],
      //   },
      // },
      lineNumbers: true,
      lineWrapping: true,
      matchBrackets: true,
      mode: 'text/x-mysql',
      readOnly: false,
      showCursorWhenSelecting: true,
      styleActiveLine: true,
      tabSize: 2
    };
    return React.createElement(reactCore.PageSection, null, React.createElement(patternflyReact.Card, null, React.createElement(patternflyReact.Card.Body, null, this.props.validationResults.map(function (e, idx) {
      return React.createElement(patternflyReact.Alert, {
        key: idx,
        type: e.type
      }, e.message);
    }), React.createElement(TextEditor, {
      value: this.state.initialDdlValue,
      options: editorOptions,
      onChange: this.handleDdlChange
    }), React.createElement(patternflyReact.Button, {
      bsStyle: "default",
      disabled: this.props.isWorking,
      onClick: this.handleDdlValidation()
    }, this.props.isWorking ? React.createElement(Loader, {
      size: 'sm',
      inline: true
    }) : null, this.props.i18nValidateLabel)), React.createElement(patternflyReact.Card.Footer, null, React.createElement(patternflyReact.Button, {
      bsStyle: "default",
      className: "view-edit-content__editButton",
      disabled: this.props.isWorking,
      onClick: this.props.onCancel
    }, this.props.i18nCancelLabel), React.createElement(patternflyReact.Button, {
      bsStyle: "primary",
      className: "view-edit-content__editButton",
      disabled: this.props.isWorking || !this.props.isValid || !this.state.ddlChanged || this.state.needsValidation,
      onClick: this.handleSave()
    }, this.props.i18nSaveLabel))));
  };

  return ViewEditContent;
}(React.Component);

ViewEditContent.defaultProps = {
  validationResults: []
};
/**
 * Line 1: icon, name (name not currently editable)
 * Line 2: description label and value
 */

var ViewEditHeader =
/*@__PURE__*/
function (superclass) {
  function ViewEditHeader() {
    superclass.apply(this, arguments);
  }

  if (superclass) ViewEditHeader.__proto__ = superclass;
  ViewEditHeader.prototype = Object.create(superclass && superclass.prototype);
  ViewEditHeader.prototype.constructor = ViewEditHeader;

  ViewEditHeader.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, {
      variant: 'light'
    }, React.createElement(reactCore.Stack, {
      gutter: "md"
    }, React.createElement(reactCore.Split, {
      gutter: "md",
      className: 'view-edit-header__row'
    }, this.props.viewIcon ? React.createElement("div", null, React.createElement("img", {
      className: "view-edit-header__viewIcon",
      src: this.props.viewIcon,
      alt: this.props.viewName,
      width: 46
    })) : null, React.createElement(InlineTextEdit, {
      className: "view-edit-header__viewName",
      value: this.props.viewName,
      allowEditing: false,
      placeholder: this.props.i18nNamePlaceholder,
      isTextArea: false,
      onChange: this.props.onChangeName
    })), React.createElement(reactCore.TextContent, null, React.createElement(reactCore.TextList, {
      component: reactCore.TextListVariants.dl
    }, React.createElement(reactCore.TextListItem, {
      className: "view-edit-header__propertyLabel",
      component: reactCore.TextListItemVariants.dt
    }, this.props.i18nDescriptionLabel), React.createElement(reactCore.TextListItem, {
      component: reactCore.TextListItemVariants.dd
    }, React.createElement(InlineTextEdit, {
      value: this.props.viewDescription || '',
      allowEditing: this.props.allowEditing && !this.props.isWorking,
      i18nPlaceholder: this.props.i18nDescriptionPlaceholder,
      isTextArea: true,
      onChange: this.props.onChangeDescription
    }))))));
  };

  return ViewEditHeader;
}(React.Component);

var ViewHeader =
/*@__PURE__*/
function (superclass) {
  function ViewHeader() {
    superclass.apply(this, arguments);
  }

  if (superclass) ViewHeader.__proto__ = superclass;
  ViewHeader.prototype = Object.create(superclass && superclass.prototype);
  ViewHeader.prototype.constructor = ViewHeader;

  ViewHeader.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, {
      variant: 'light'
    }, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
      size: "2xl",
      headingLevel: reactCore.TitleLevel.h1
    }, this.props.i18nTitle), this.props.i18nDescription && React.createElement(reactCore.Text, null, this.props.i18nDescription)));
  };

  return ViewHeader;
}(React.Component);

var ViewInfoList =
/*@__PURE__*/
function (superclass) {
  function ViewInfoList() {
    superclass.apply(this, arguments);
  }

  if (superclass) ViewInfoList.__proto__ = superclass;
  ViewInfoList.prototype = Object.create(superclass && superclass.prototype);
  ViewInfoList.prototype.constructor = ViewInfoList;

  ViewInfoList.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", null)), this.props.children ? React.createElement(patternflyReact.ListView, null, this.props.children) : React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Icon, null), React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyStateTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyStateInfo)));
  };

  return ViewInfoList;
}(React.Component);

var ViewInfoListItem =
/*@__PURE__*/
function (superclass) {
  function ViewInfoListItem(props) {
    var this$1 = this;
    superclass.call(this, props);

    this.handleCheckboxToggle = function (viewName) {
      return function (event) {
        this$1.setState({
          itemSelected: !this$1.state.itemSelected
        });
        this$1.props.onSelectionChanged(viewName, !this$1.state.itemSelected);
      };
    };

    this.state = {
      itemSelected: props.selected
    };
    this.handleCheckboxToggle = this.handleCheckboxToggle.bind(this);
  }

  if (superclass) ViewInfoListItem.__proto__ = superclass;
  ViewInfoListItem.prototype = Object.create(superclass && superclass.prototype);
  ViewInfoListItem.prototype.constructor = ViewInfoListItem;

  ViewInfoListItem.prototype.temp = function temp() {
    var tDescription = this.props.description;
    var tConnectionName = this.props.connectionName;
    return tDescription + tConnectionName;
  };

  ViewInfoListItem.prototype.getNodePathStr = function getNodePathStr() {
    var path = '';

    for (var i = 0, list = this.props.nodePath; i < list.length; i += 1) {
      var segment = list[i];
      path += '/' + segment;
    }

    return path;
  };

  ViewInfoListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "view-info-list-item-" + toValidHtmlId(this.props.name) + "-list-item",
      className: 'view-info-list-item',
      heading: this.props.name,
      description: this.getNodePathStr(),
      checkboxInput: React.createElement("input", {
        "data-testid": 'view-info-list-item-selected-input',
        type: "checkbox",
        value: "",
        defaultChecked: this.props.selected,
        onChange: this.handleCheckboxToggle(this.props.name)
      }),
      additionalInfo: [React.createElement(patternflyReact.ListViewInfoItem, {
        key: 1
      }, this.props.isUpdateView === true ? React.createElement(patternflyReact.Label, {
        type: "warning"
      }, this.props.i18nUpdate) : '')],
      hideCloseIcon: true,
      stacked: false
    });
  };

  return ViewInfoListItem;
}(React.Component); // tslint:disable react-unused-props-and-state


var ViewInfoListSkeleton = function ViewInfoListSkeleton(ref) {
  var width = ref.width;
  var style = ref.style;
  return React.createElement(ContentLoader, {
    height: 356,
    width: width,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: style
  }, React.createElement("circle", {
    cx: "30",
    cy: "40",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "40",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "35",
    rx: "5",
    ry: "5",
    width: "200",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "35",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "110",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "110",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "105",
    rx: "5",
    ry: "5",
    width: "180",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "105",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "180",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "180",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "175",
    rx: "5",
    ry: "5",
    width: "195",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "175",
    rx: "5",
    ry: "5",
    width: "85",
    height: "15"
  }));
};
/**
 * A component to render a save form, to be used in the create view wizard.
 * This does *not* build the form itself, form's field should be passed
 * as the `children` value.
 * @see [i18nTitle]{@link IViewConfigurationFormProps#i18nTitle}
 * @see [i18nSubtitle]{@link IViewConfigurationFormProps#i18nSubtitle}
 */


var ViewConfigurationForm =
/*@__PURE__*/
function (superclass) {
  function ViewConfigurationForm() {
    superclass.apply(this, arguments);
  }

  if (superclass) ViewConfigurationForm.__proto__ = superclass;
  ViewConfigurationForm.prototype = Object.create(superclass && superclass.prototype);
  ViewConfigurationForm.prototype.constructor = ViewConfigurationForm;

  ViewConfigurationForm.prototype.render = function render() {
    return React.createElement(Container, null, React.createElement("form", {
      className: "form-horizontal required-pf",
      role: "form",
      onSubmit: this.props.handleSubmit
    }, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, this.props.i18nFormTitle && React.createElement("div", {
      className: "card-pf-title"
    }, this.props.i18nFormTitle), React.createElement("div", {
      className: "card-pf-body"
    }, this.props.validationResults.map(function (e, idx) {
      return React.createElement(patternflyReact.Alert, {
        key: idx,
        type: e.type
      }, e.message);
    }), React.createElement(Container, null, this.props.children))))));
  };

  return ViewConfigurationForm;
}(React.Component);

ViewConfigurationForm.defaultProps = {
  validationResults: []
};
/**
 * Provides the layout for the view create wizard. It uses the PatternFly Wizard
 * component under the hood.
 * The footer is pre-defined and follows the PF Wizard pattern, with
 * Cancel/Previous/Next buttons.
 *
 * @todo in the CSS we use hardcoded values for the heights of various
 * elements of the page to be able to size the element to take all the available
 * height and show the right scrollbars.
 * We should really find a smarter way to handle this.
 */

var ViewCreateLayout = function ViewCreateLayout(ref) {
  var header = ref.header;
  var content = ref.content;
  var onCancel = ref.onCancel;
  var onBack = ref.onBack;
  var onNext = ref.onNext;
  var cancelHref = ref.cancelHref;
  var backHref = ref.backHref;
  var nextHref = ref.nextHref;
  var isNextLoading = ref.isNextLoading;
  var isNextDisabled = ref.isNextDisabled;
  var isLastStep = ref.isLastStep;
  if (isLastStep === void 0) isLastStep = false;
  return React.createElement("div", {
    className: classnames('wizard-pf-body view-create-layout syn-scrollable', {
      'has-footer': true
    })
  }, header, React.createElement("div", {
    className: "wizard-pf-row view-create-layout__body syn-scrollable--body"
  }, React.createElement("div", {
    className: 'wizard-pf-main cards-pf view-create-layout__contentWrapper'
  }, React.createElement("div", {
    className: "view-create-layout__content"
  }, content))), React.createElement("div", {
    className: "wizard-pf-footer view-create-layout__footer"
  }, React.createElement(ButtonLink, {
    "data-testid": 'view-create-layout-back-button',
    onClick: onBack,
    href: backHref,
    className: 'wizard-pf-back'
  }, React.createElement("i", {
    className: "fa fa-angle-left"
  }), " Back"), React.createElement(ButtonLink, {
    "data-testid": 'view-create-layout-next-button',
    onClick: onNext,
    href: nextHref,
    as: 'primary',
    className: 'wizard-pf-next',
    disabled: isNextLoading || isNextDisabled
  }, isNextLoading ? React.createElement(Loader, {
    size: 'xs',
    inline: true
  }) : null, isLastStep ? 'Done' : React.createElement(React.Fragment, null, "Next ", React.createElement("i", {
    className: "fa fa-angle-right"
  }))), React.createElement(ButtonLink, {
    "data-testid": 'view-create-layout-cancel-button',
    onClick: onCancel,
    href: cancelHref,
    className: 'wizard-pf-cancel'
  }, "Cancel")));
};
/**
 * Provides the layout for the views import wizard. It uses the PatternFly Wizard
 * component under the hood.
 * The footer is pre-defined and follows the PF Wizard pattern, with
 * Cancel/Previous/Next buttons.
 *
 * @todo in the CSS we use hardcoded values for the heights of various
 * elements of the page to be able to size the element to take all the available
 * height and show the right scrollbars.
 * We should really find a smarter way to handle this.
 */


var ViewsImportLayout = function ViewsImportLayout(ref) {
  var header = ref.header;
  var content = ref.content;
  var onCancel = ref.onCancel;
  var onBack = ref.onBack;
  var onNext = ref.onNext;
  var onCreateViews = ref.onCreateViews;
  var cancelHref = ref.cancelHref;
  var backHref = ref.backHref;
  var nextHref = ref.nextHref;
  var isNextLoading = ref.isNextLoading;
  var isNextDisabled = ref.isNextDisabled;
  var isLastStep = ref.isLastStep;
  if (isLastStep === void 0) isLastStep = false;
  return React.createElement("div", {
    className: classnames('wizard-pf-body views-import-layout syn-scrollable', {
      'has-footer': true
    })
  }, header, React.createElement("div", {
    className: "wizard-pf-row views-import-layout__body syn-scrollable--body"
  }, React.createElement("div", {
    className: 'wizard-pf-main cards-pf views-import-layout__contentWrapper'
  }, React.createElement("div", {
    className: "views-import-layout__content"
  }, content))), React.createElement("div", {
    className: "wizard-pf-footer views-import-layout__footer"
  }, React.createElement(ButtonLink, {
    "data-testid": 'views-import-layout-back-button',
    onClick: onBack,
    href: backHref,
    className: 'wizard-pf-back'
  }, React.createElement("i", {
    className: "fa fa-angle-left"
  }), " Back"), React.createElement(ButtonLink, {
    "data-testid": 'views-import-layout-next-button',
    onClick: isLastStep ? onCreateViews : onNext,
    href: nextHref,
    as: 'primary',
    className: 'wizard-pf-next',
    disabled: isNextLoading || isNextDisabled
  }, isNextLoading ? React.createElement(Loader, {
    size: 'xs',
    inline: true
  }) : null, isLastStep ? 'Done' : React.createElement(React.Fragment, null, "Next ", React.createElement("i", {
    className: "fa fa-angle-right"
  }))), React.createElement(ButtonLink, {
    "data-testid": 'views-import-layout-cancel-button',
    onClick: onCancel,
    href: cancelHref,
    className: 'wizard-pf-cancel'
  }, "Cancel")));
};

var ConnectionSchemaList =
/*@__PURE__*/
function (superclass) {
  function ConnectionSchemaList(props) {
    superclass.call(this, props);
  }

  if (superclass) ConnectionSchemaList.__proto__ = superclass;
  ConnectionSchemaList.prototype = Object.create(superclass && superclass.prototype);
  ConnectionSchemaList.prototype.constructor = ConnectionSchemaList;

  ConnectionSchemaList.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, {
      noPadding: true
    }, this.props.hasListData ? React.createElement(patternflyReact.ListView, null, this.props.children) : React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyStateTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyStateInfo)));
  };

  return ConnectionSchemaList;
}(React.Component);

var ConnectionSchemaListItem =
/*@__PURE__*/
function (superclass) {
  function ConnectionSchemaListItem() {
    superclass.apply(this, arguments);
  }

  if (superclass) ConnectionSchemaListItem.__proto__ = superclass;
  ConnectionSchemaListItem.prototype = Object.create(superclass && superclass.prototype);
  ConnectionSchemaListItem.prototype.constructor = ConnectionSchemaListItem;

  ConnectionSchemaListItem.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "connection-schema-list-item-" + toValidHtmlId(this.props.connectionName) + "-list-item",
      heading: this.props.connectionName,
      description: this.props.connectionDescription ? this.props.connectionDescription : '',
      hideCloseIcon: true,
      leftContent: this.props.icon ? React.createElement("div", {
        className: "blank-slate-pf-icon"
      }, React.createElement("img", {
        src: this.props.icon,
        alt: this.props.connectionName,
        width: 46
      })) : React.createElement(patternflyReact.ListViewIcon, {
        name: 'database'
      }),
      stacked: false
    }, this.props.children ? React.createElement(patternflyReact.ListView, null, this.props.children) : null));
  };

  return ConnectionSchemaListItem;
}(React.Component); // tslint:disable react-unused-props-and-state


var ConnectionSchemaListSkeleton = function ConnectionSchemaListSkeleton(ref) {
  var width = ref.width;
  var style = ref.style;
  return React.createElement(ContentLoader, {
    height: 356,
    width: width,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: style
  }, React.createElement("circle", {
    cx: "30",
    cy: "40",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "40",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "35",
    rx: "5",
    ry: "5",
    width: "200",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "35",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "110",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "110",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "105",
    rx: "5",
    ry: "5",
    width: "180",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "105",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "180",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "180",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "175",
    rx: "5",
    ry: "5",
    width: "195",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "175",
    rx: "5",
    ry: "5",
    width: "85",
    height: "15"
  }));
};

var defaultCellFormat = function defaultCellFormat(value) {
  return React.createElement(patternflyReact.Table.Heading, null, value);
};

var defaultHeaderFormat = function defaultHeaderFormat(value) {
  return React.createElement(patternflyReact.Table.Cell, null, value);
};
/**
 * The SQL client content.  This component includes:
 * - SqlClientForm - for selection of the view and query params
 * - GenericTable - for display of the query results
 * - EmptyStates - displayed when no views available or no results available.
 */


var SqlClientContent =
/*@__PURE__*/
function (superclass) {
  function SqlClientContent() {
    superclass.apply(this, arguments);
  }

  if (superclass) SqlClientContent.__proto__ = superclass;
  SqlClientContent.prototype = Object.create(superclass && superclass.prototype);
  SqlClientContent.prototype.constructor = SqlClientContent;

  SqlClientContent.prototype.render = function render() {
    return React.createElement(reactCore.PageSection, null, this.props.viewNames.length > 0 ? React.createElement(patternflyReact.Grid.Row, null, React.createElement(patternflyReact.Grid.Col, {
      md: 4
    }, React.createElement(Container, null, this.props.formContent)), React.createElement(patternflyReact.Grid.Col, {
      md: 8
    }, React.createElement(React.Fragment, null, this.props.queryResultCols.length > 0 ? React.createElement(React.Fragment, null, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Text, null, this.props.i18nResultsTitle)), React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Text, null, React.createElement("small", null, React.createElement("i", null, this.props.i18nResultsRowCountMsg, this.props.queryResultRows.length)))), React.createElement(GenericTable, Object.assign({
      columns: this.props.queryResultCols.map(function (col) {
        return {
          cell: {
            formatters: [defaultCellFormat]
          },
          header: {
            formatters: [defaultHeaderFormat],
            label: col.label
          },
          property: col.id
        };
      }),
      rows: this.props.queryResultRows,
      rowKey: this.props.queryResultCols.length > 0 ? this.props.queryResultCols[0].id : ''
    }, this.props))) : React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyResultsTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyResultsMsg))))) : React.createElement(EmptyViewsState, {
      i18nEmptyStateTitle: this.props.i18nEmptyStateTitle,
      i18nEmptyStateInfo: this.props.i18nEmptyStateInfo,
      i18nCreateView: this.props.i18nCreateView,
      i18nCreateViewTip: this.props.i18nCreateViewTip,
      i18nImportViews: this.props.i18nImportViews,
      i18nImportViewsTip: this.props.i18nImportViewsTip,
      linkCreateViewHRef: this.props.linkCreateViewHRef,
      linkImportViewsHRef: this.props.linkImportViewsHRef
    }));
  };

  return SqlClientContent;
}(React.Component);
/**
 * A component to render the SqlClient entry form, to be used on the Virtualization SQL client page.
 * This does *not* build the form itself, form fields should be passed as the `children` value.
 */


var SqlClientForm =
/*@__PURE__*/
function (superclass) {
  function SqlClientForm() {
    superclass.apply(this, arguments);
  }

  if (superclass) SqlClientForm.__proto__ = superclass;
  SqlClientForm.prototype = Object.create(superclass && superclass.prototype);
  SqlClientForm.prototype.constructor = SqlClientForm;

  SqlClientForm.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(Container, null, React.createElement("form", {
      className: "form-horizontal required-pf",
      role: "form",
      onSubmit: this.props.handleSubmit
    }, React.createElement("div", {
      className: "row row-cards-pf"
    }, React.createElement("div", {
      className: "card-pf"
    }, React.createElement("div", {
      className: "card-pf-body"
    }, React.createElement(Container, null, this.props.children))))), React.createElement("button", {
      "data-testid": 'sql-client-form-submit-button',
      type: "button",
      className: "btn btn-primary",
      onClick: this.props.handleSubmit
    }, "Submit")));
  };

  return SqlClientForm;
}(React.Component);

var NOTFOUND = 'NOTFOUND';
var SUBMITTED = 'SUBMITTED';
var CONFIGURING = 'CONFIGURING';
var BUILDING = 'BUILDING';
var DEPLOYING = 'DEPLOYING';
var RUNNING = 'RUNNING';
var FAILED = 'FAILED';
var CANCELLED = 'CANCELLED';
var DELETE_SUBMITTED = 'DELETE_SUBMITTED';
var DELETE_REQUEUE = 'DELETE_REQUEUE';
var DELETE_DONE = 'DELETE_DONE'; // Detailed state log link types

var VirtualizationPublishStatus =
/*@__PURE__*/
function (superclass) {
  function VirtualizationPublishStatus() {
    superclass.apply(this, arguments);
  }

  if (superclass) VirtualizationPublishStatus.__proto__ = superclass;
  VirtualizationPublishStatus.prototype = Object.create(superclass && superclass.prototype);
  VirtualizationPublishStatus.prototype.constructor = VirtualizationPublishStatus;

  VirtualizationPublishStatus.prototype.render = function render() {
    var labelType = this.props.currentState === FAILED ? 'danger' : this.props.currentState === RUNNING ? 'primary' : 'default';
    var label = '';
    var inProgressMsg = '';

    switch (this.props.currentState) {
      case RUNNING:
        label = this.props.i18nPublished;
        break;

      case FAILED:
        label = this.props.i18nError;
        break;

      case NOTFOUND:
        label = this.props.i18nUnpublished;
        break;

      case SUBMITTED:
        inProgressMsg = this.props.i18nPublishInProgress;
        break;

      case CANCELLED:
      case DELETE_SUBMITTED:
      case DELETE_REQUEUE:
      case DELETE_DONE:
        inProgressMsg = this.props.i18nUnpublishInProgress;
        break;

      case CONFIGURING:
      case BUILDING:
      case DEPLOYING:
        label = DEPLOYING;
        break;
    }

    return React.createElement(React.Fragment, null, inProgressMsg.length > 0 ? React.createElement(React.Fragment, null, React.createElement(patternflyReact.Spinner, {
      loading: true,
      inline: true
    }), inProgressMsg, "\xA0\xA0") : React.createElement(patternflyReact.Label, {
      className: 'virtualization-publish-status-label',
      type: labelType
    }, label));
  };

  return VirtualizationPublishStatus;
}(React.Component);

var VirtualizationListItem =
/*@__PURE__*/
function (superclass) {
  function VirtualizationListItem(props) {
    superclass.call(this, props);
    this.state = {
      showConfirmationDialog: false
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    /* TD-636: Commented out for TP
    this.handleExport = this.handleExport.bind(this); */

    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.showConfirmationDialog = this.showConfirmationDialog.bind(this);
  }

  if (superclass) VirtualizationListItem.__proto__ = superclass;
  VirtualizationListItem.prototype = Object.create(superclass && superclass.prototype);
  VirtualizationListItem.prototype.constructor = VirtualizationListItem;

  VirtualizationListItem.prototype.getEditTooltip = function getEditTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "detailsTip"
    }, this.props.i18nEditTip ? this.props.i18nEditTip : this.props.i18nEdit);
  };

  VirtualizationListItem.prototype.handleCancel = function handleCancel() {
    this.setState({
      showConfirmationDialog: false
    });
  };

  VirtualizationListItem.prototype.handleDelete = function handleDelete() {
    this.setState({
      showConfirmationDialog: false
    }); // TODO: disable components while delete is processing

    if (this.props.virtualizationName) {
      this.props.onDelete(this.props.virtualizationName);
    }
  };
  /* TD-636: Commented out for TP
  public handleExport() {
    if (this.props.virtualizationName) {
      this.props.onExport(this.props.virtualizationName);
    }
  } */


  VirtualizationListItem.prototype.handlePublish = function handlePublish() {
    if (this.props.virtualizationName) {
      this.props.onPublish(this.props.virtualizationName, this.props.virtualizationViewNames.length > 0);
    }
  };

  VirtualizationListItem.prototype.handleUnpublish = function handleUnpublish() {
    this.setState({
      showConfirmationDialog: false
    });

    if (this.props.serviceVdbName) {
      this.props.onUnpublish(this.props.serviceVdbName);
    }
  };

  VirtualizationListItem.prototype.showConfirmationDialog = function showConfirmationDialog() {
    this.setState({
      showConfirmationDialog: true
    });
  };

  VirtualizationListItem.prototype.handleAcceptConfirmation = function handleAcceptConfirmation() {
    var isPublished = this.props.currentPublishedState === RUNNING ? true : false;

    if (isPublished) {
      this.handleUnpublish();
    } else {
      this.handleDelete();
    }
  };

  VirtualizationListItem.prototype.render = function render() {
    // Determine published state
    var isPublished = this.props.currentPublishedState === RUNNING ? true : false;
    var publishInProgress = this.props.currentPublishedState === BUILDING || this.props.currentPublishedState === CONFIGURING || this.props.currentPublishedState === DEPLOYING ? true : false;
    return React.createElement(React.Fragment, null, React.createElement(ConfirmationDialog, {
      buttonStyle: isPublished ? exports.ConfirmationButtonStyle.WARNING : exports.ConfirmationButtonStyle.DANGER,
      i18nCancelButtonText: this.props.i18nCancelText,
      i18nConfirmButtonText: isPublished ? this.props.i18nUnpublish : this.props.i18nDelete,
      i18nConfirmationMessage: isPublished ? this.props.i18nUnpublishModalMessage : this.props.i18nDeleteModalMessage,
      i18nTitle: isPublished ? this.props.i18nUnpublishModalTitle : this.props.i18nDeleteModalTitle,
      icon: isPublished ? exports.ConfirmationIconType.WARNING : exports.ConfirmationIconType.DANGER,
      showDialog: this.state.showConfirmationDialog,
      onCancel: this.handleCancel,
      onConfirm: isPublished ? this.handleUnpublish : this.handleDelete
    }), React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "virtualization-list-item-" + toValidHtmlId(this.props.virtualizationName) + "-list-item",
      actions: React.createElement("div", {
        className: "form-group"
      }, publishInProgress ? React.createElement("div", {
        "data-testid": 'virtualization-list-item-progress',
        className: 'virtualization-list-item-progress'
      }, React.createElement(ProgressWithLink, {
        logUrl: this.props.publishingLogUrl,
        value: this.props.publishingStepText ? this.props.publishingStepText : '',
        currentStep: this.props.publishingCurrentStep ? this.props.publishingCurrentStep : 0,
        totalSteps: this.props.publishingTotalSteps ? this.props.publishingTotalSteps : 4,
        i18nLogUrlText: this.props.i18nPublishLogUrlText
      })) : React.createElement(VirtualizationPublishStatus, {
        currentState: this.props.currentPublishedState,
        i18nPublished: this.props.i18nPublished,
        i18nUnpublished: this.props.i18nDraft,
        i18nPublishInProgress: this.props.i18nPublishInProgress,
        i18nUnpublishInProgress: this.props.i18nUnpublishInProgress,
        i18nError: this.props.i18nError
      }), React.createElement(patternflyReact.OverlayTrigger, {
        overlay: this.getEditTooltip(),
        placement: "top"
      }, React.createElement(ButtonLink, {
        "data-testid": 'virtualization-list-item-edit-button',
        href: this.props.detailsPageLink,
        as: 'primary'
      }, this.props.i18nEdit)), React.createElement(patternflyReact.DropdownKebab, {
        id: "virtualization-" + this.props.virtualizationName + "-action-menu",
        pullRight: true
      }, React.createElement(patternflyReact.MenuItem, {
        onClick: this.showConfirmationDialog
      }, this.props.i18nDelete), React.createElement(patternflyReact.MenuItem, {
        onClick: isPublished || publishInProgress ? this.handleUnpublish : this.handlePublish
      }, isPublished || publishInProgress ? this.props.i18nUnpublish : this.props.i18nPublish))),
      heading: this.props.virtualizationName,
      description: this.props.virtualizationDescription ? this.props.virtualizationDescription : '',
      additionalInfo: [React.createElement(patternflyReact.ListViewInfoItem, {
        key: 1
      }, this.props.odataUrl && React.createElement("span", null, React.createElement("a", {
        "data-testid": 'virtualization-list-item-odataUrl',
        target: "_blank",
        href: this.props.odataUrl
      }, this.props.odataUrl, React.createElement(patternflyReact.Icon, {
        className: 'virtualization-list-item-odata-link-icon',
        name: 'external-link'
      }))))],
      hideCloseIcon: true,
      leftContent: this.props.icon ? React.createElement("div", {
        className: "blank-slate-pf-icon"
      }, React.createElement("img", {
        src: this.props.icon,
        alt: this.props.virtualizationName,
        width: 46
      })) : React.createElement(patternflyReact.ListViewIcon, {
        name: 'cube'
      }),
      stacked: true
    }, this.props.children ? React.createElement(patternflyReact.ListView, null, this.props.children) : null));
  };

  return VirtualizationListItem;
}(React.Component);

var VirtualizationList =
/*@__PURE__*/
function (superclass) {
  function VirtualizationList(props) {
    superclass.call(this, props);
    /* TD-636: Commented out for TP {this.handleImport = this.handleImport.bind(this);} */
  }

  if (superclass) VirtualizationList.__proto__ = superclass;
  VirtualizationList.prototype = Object.create(superclass && superclass.prototype);
  VirtualizationList.prototype.constructor = VirtualizationList;

  VirtualizationList.prototype.getCreateVirtualizationTooltip = function getCreateVirtualizationTooltip() {
    return React.createElement(patternflyReact.Tooltip, {
      id: "createTip"
    }, this.props.i18nLinkCreateVirtualizationTip ? this.props.i18nLinkCreateVirtualizationTip : this.props.i18nLinkCreateVirtualization);
  };
  /* TD-636: Commented out for TP
    public getImportVirtualizationTooltip() {
    return (
      <Tooltip id="importTip">
        {this.props.i18nImportTip
          ? this.props.i18nImportTip
          : this.props.i18nImport}
      </Tooltip>
    );
  }
     public handleImport() {
    this.props.onImport('');
  } */


  VirtualizationList.prototype.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(reactCore.PageSection, {
      noPadding: true,
      variant: 'light'
    }, React.createElement(ListViewToolbar, Object.assign({}, this.props), React.createElement("div", {
      className: "form-group"
    }, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getCreateVirtualizationTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'virtualization-list-create-virtualization-button',
      href: this.props.linkCreateHRef,
      as: 'primary'
    }, this.props.i18nLinkCreateVirtualization))))), React.createElement(reactCore.PageSection, {
      noPadding: true,
      variant: 'light'
    }, this.props.hasListData ? React.createElement(patternflyReact.ListView, null, this.props.children) : React.createElement(patternflyReact.EmptyState, null, React.createElement(patternflyReact.EmptyState.Icon, null), React.createElement(patternflyReact.EmptyState.Title, null, this.props.i18nEmptyStateTitle), React.createElement(patternflyReact.EmptyState.Info, null, this.props.i18nEmptyStateInfo), React.createElement(patternflyReact.EmptyState.Action, null, React.createElement(patternflyReact.OverlayTrigger, {
      overlay: this.getCreateVirtualizationTooltip(),
      placement: "top"
    }, React.createElement(ButtonLink, {
      "data-testid": 'virtualization-list-empty-state-create-button',
      href: this.props.linkCreateHRef,
      as: 'primary'
    }, this.props.i18nLinkCreateVirtualization))))));
  };

  return VirtualizationList;
}(React.Component); // tslint:disable react-unused-props-and-state


var VirtualizationListSkeleton = function VirtualizationListSkeleton(ref) {
  var width = ref.width;
  var style = ref.style;
  return React.createElement(ContentLoader, {
    height: 356,
    width: width,
    speed: 2,
    primaryColor: "#f3f3f3",
    secondaryColor: "#ecebeb",
    style: style
  }, React.createElement("circle", {
    cx: "30",
    cy: "40",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "40",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "35",
    rx: "5",
    ry: "5",
    width: "200",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "35",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "110",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "110",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "105",
    rx: "5",
    ry: "5",
    width: "180",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "105",
    rx: "5",
    ry: "5",
    width: "80",
    height: "15"
  }), React.createElement("circle", {
    cx: "30",
    cy: "180",
    r: "16"
  }), React.createElement("circle", {
    cx: "70",
    cy: "180",
    r: "16"
  }), React.createElement("rect", {
    x: "105",
    y: "175",
    rx: "5",
    ry: "5",
    width: "195",
    height: "15"
  }), React.createElement("rect", {
    x: width - 100,
    y: "175",
    rx: "5",
    ry: "5",
    width: "85",
    height: "15"
  }));
};

var OAuthAppExpanderBody =
/*@__PURE__*/
function (superclass) {
  function OAuthAppExpanderBody(props) {
    superclass.call(this, props);
  }

  if (superclass) OAuthAppExpanderBody.__proto__ = superclass;
  OAuthAppExpanderBody.prototype = Object.create(superclass && superclass.prototype);
  OAuthAppExpanderBody.prototype.constructor = OAuthAppExpanderBody;

  OAuthAppExpanderBody.prototype.render = function render() {
    return React.createElement(React.Fragment, null, this.props.showSuccess && React.createElement(patternflyReact.Row, null, React.createElement(patternflyReact.Col, {
      xs: 11
    }, React.createElement(patternflyReact.Alert, {
      type: 'success'
    }, React.createElement("strong", null, this.props.i18nAlertTitle), "\xA0", this.props.i18nAlertDetail))), React.createElement(patternflyReact.Row, null, React.createElement(patternflyReact.Col, {
      xs: 12,
      md: 8
    }, this.props.children)), React.createElement(patternflyReact.Row, null, React.createElement(patternflyReact.Col, {
      xs: 12,
      md: 8
    }, React.createElement(React.Fragment, null, React.createElement(patternflyReact.Button, {
      "data-testid": 'o-auth-app-expander-body-save-button',
      bsStyle: "primary",
      onClick: this.props.onSave,
      disabled: this.props.disableSave
    }, this.props.i18nSaveButtonText), ' ', React.createElement(patternflyReact.Button, {
      "data-testid": 'o-auth-app-expander-body-remove-button',
      onClick: this.props.onRemove,
      disabled: this.props.disableRemove
    }, this.props.i18nRemoveButtonText)))));
  };

  return OAuthAppExpanderBody;
}(React.Component);

var OAuthAppHeader = function OAuthAppHeader(ref) {
  var i18nPageTitle = ref.i18nPageTitle;
  var i18nDescription = ref.i18nDescription;
  var i18nCallbackDescription = ref.i18nCallbackDescription;
  var callbackURI = ref.callbackURI;
  return React.createElement(reactCore.PageSection, {
    variant: 'light'
  }, React.createElement(reactCore.TextContent, null, React.createElement(reactCore.Title, {
    size: '2xl',
    headingLevel: reactCore.TitleLevel.h1
  }, i18nPageTitle), React.createElement(reactCore.Text, {
    dangerouslySetInnerHTML: {
      __html: i18nDescription
    }
  }), React.createElement("div", null, React.createElement("span", {
    className: "pf-u-mr-md"
  }, i18nCallbackDescription, ":"), React.createElement(CopyToClipboard, null, callbackURI))));
};

var OAuthAppList = function OAuthAppList(ref) {
  var children = ref.children;
  return React.createElement(patternflyReact.ListView, null, children);
};

var OAuthAppListItem =
/*@__PURE__*/
function (superclass) {
  function OAuthAppListItem(props) {
    superclass.call(this, props);
  }

  if (superclass) OAuthAppListItem.__proto__ = superclass;
  OAuthAppListItem.prototype = Object.create(superclass && superclass.prototype);
  OAuthAppListItem.prototype.constructor = OAuthAppListItem;

  OAuthAppListItem.prototype.render = function render() {
    return React.createElement(patternflyReact.ListViewItem, {
      "data-testid": "o-auth-app-list-item-" + toValidHtmlId(this.props.name) + "-list-item",
      key: this.props.id,
      hideCloseIcon: true,
      initExpanded: this.props.expanded,
      heading: this.props.name,
      leftContent: this.props.icon,
      description: '',
      additionalInfo: [!this.props.configured && React.createElement("i", {
        key: 0
      }, this.props.i18nNotConfiguredText)]
    }, this.props.children);
  };

  return OAuthAppListItem;
}(React.Component);

function objectWithoutProperties$b(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var OAuthAppListItemView = function OAuthAppListItemView(ref) {
  var children = ref.children;
  var rest$1 = objectWithoutProperties$b(ref, ["children"]);
  var rest = rest$1;
  return React.createElement(reactCore.PageSection, null, React.createElement(ListViewToolbar, Object.assign({}, rest)), children);
};

var DownloadDiagnostics = function DownloadDiagnostics(ref) {
  var children = ref.children;
  return React.createElement(React.Fragment, null, React.createElement(reactCore.CardBody, null, React.createElement("div", {
    className: "pf-c-content"
  }, React.createElement("h2", {
    className: "pf-c-title pf-m-lg"
  }, "Download Troubleshooting Diagnostics \xA0", React.createElement(reactCore.Popover, {
    position: "right",
    bodyContent: React.createElement("p", null, "System level and application level diagnostics will be captured since both are required to troubleshoot any issues. Usernames and passwords are not present in the downloaded zip file."),
    headerContent: React.createElement("span", {
      className: "pf-c-title pf-m-lg"
    }, "Download Troubleshooting Diagnostics")
  }, React.createElement(reactIcons.HelpIcon, null))), children)));
};

exports.BreadcrumbItem = reactCore.BreadcrumbItem;
exports.PageSection = reactCore.PageSection;
exports.ConnectionCard = ConnectionCard;
exports.ConnectionCreatorLayout = ConnectionCreatorLayout;
exports.ConnectionDetailsForm = ConnectionDetailsForm;
exports.ConnectionDetailsHeader = ConnectionDetailsHeader;
exports.ConnectionDetailsOauthCard = ConnectionDetailsOauthCard;
exports.ConnectionsGrid = ConnectionsGrid;
exports.ConnectionsGridCell = ConnectionsGridCell;
exports.ConnectionSkeleton = ConnectionSkeleton;
exports.ConnectionsListView = ConnectionsListView;
exports.ConnectorAuthorization = ConnectorAuthorization;
exports.ConnectorConfigurationForm = ConnectorConfigurationForm;
exports.ApiConnectorCreatorLayout = ApiConnectorCreatorLayout;
exports.ApiConnectorDetailCard = ApiConnectorDetailCard;
exports.ApiConnectorDetailsForm = ApiConnectorDetailsForm;
exports.ApiConnectorListItem = ApiConnectorListItem;
exports.ApiConnectorListSkeleton = ApiConnectorListSkeleton;
exports.ApiConnectorListView = ApiConnectorListView;
exports.ApiConnectorReview = ApiConnectorReview;
exports.isAuthTypeValid = isAuthTypeValid;
exports.ApiClientConnectorCreateSecurity = ApiClientConnectorCreateSecurity;
exports.ApiClientConnectorCreateUpload = ApiClientConnectorCreateUpload;
exports.ExtensionDetail = ExtensionDetail;
exports.ExtensionImportCard = ExtensionImportCard;
exports.ExtensionImportReview = ExtensionImportReview;
exports.ExtensionIntegrationsTable = ExtensionIntegrationsTable;
exports.ExtensionListItem = ExtensionListItem;
exports.ExtensionListSkeleton = ExtensionListSkeleton;
exports.ExtensionListView = ExtensionListView;
exports.ExtensionOverview = ExtensionOverview;
exports.ExtensionSupports = ExtensionSupports;
exports.ConnectionsMetric = ConnectionsMetric;
exports.Dashboard = Dashboard;
exports.IntegrationBoard = IntegrationBoard;
exports.RecentUpdatesCard = RecentUpdatesCard;
exports.RecentUpdatesItem = RecentUpdatesItem;
exports.RecentUpdatesSkeleton = RecentUpdatesSkeleton;
exports.TopIntegrationsCard = TopIntegrationsCard;
exports.UptimeMetric = UptimeMetric;
exports.ViewListItem = ViewListItem;
exports.ViewList = ViewList;
exports.ViewListSkeleton = ViewListSkeleton;
exports.DvConnectionCard = DvConnectionCard;
exports.DvConnectionsGrid = DvConnectionsGrid;
exports.DvConnectionsGridCell = DvConnectionsGridCell;
exports.DvConnectionSkeleton = DvConnectionSkeleton;
exports.DvConnectionsListView = DvConnectionsListView;
exports.EmptyViewsState = EmptyViewsState;
exports.SchemaNodeListItem = SchemaNodeListItem;
exports.ViewEditContent = ViewEditContent;
exports.ViewEditHeader = ViewEditHeader;
exports.ViewHeader = ViewHeader;
exports.ViewInfoList = ViewInfoList;
exports.ViewInfoListItem = ViewInfoListItem;
exports.ViewInfoListSkeleton = ViewInfoListSkeleton;
exports.ViewConfigurationForm = ViewConfigurationForm;
exports.ViewCreateLayout = ViewCreateLayout;
exports.ViewsImportLayout = ViewsImportLayout;
exports.ConnectionSchemaList = ConnectionSchemaList;
exports.ConnectionSchemaListItem = ConnectionSchemaListItem;
exports.ConnectionSchemaListSkeleton = ConnectionSchemaListSkeleton;
exports.SqlClientContent = SqlClientContent;
exports.SqlClientForm = SqlClientForm;
exports.VirtualizationListItem = VirtualizationListItem;
exports.VirtualizationList = VirtualizationList;
exports.VirtualizationListSkeleton = VirtualizationListSkeleton;
exports.VirtualizationPublishStatus = VirtualizationPublishStatus;
exports.IntegrationDetailActivity = IntegrationDetailActivity;
exports.IntegrationDetailActivityItem = IntegrationDetailActivityItem;
exports.IntegrationDetailActivityItemSteps = IntegrationDetailActivityItemSteps;
exports.CiCdEditDialog = CiCdEditDialog;
exports.CiCdList = CiCdList;
exports.CiCdListEmptyState = CiCdListEmptyState;
exports.CiCdListItem = CiCdListItem;
exports.CiCdManagePageUI = CiCdManagePageUI;
exports.CiCdListSkeleton = CiCdListSkeleton;
exports.CiCdListView = CiCdListView;
exports.TagIntegrationDialog = TagIntegrationDialog;
exports.TagIntegrationListItem = TagIntegrationListItem;
exports.TagIntegrationDialogEmptyState = TagIntegrationDialogEmptyState;
exports.TagIntegrationDialogBody = TagIntegrationDialogBody;
exports.IntegrationActions = IntegrationActions;
exports.IntegrationActionSelectorCard = IntegrationActionSelectorCard;
exports.IntegrationBulletinBoardAlert = IntegrationBulletinBoardAlert;
exports.IntegrationDetailBreadcrumb = IntegrationDetailBreadcrumb;
exports.IntegrationDetailDescription = IntegrationDetailDescription;
exports.IntegrationDetailEditableName = IntegrationDetailEditableName;
exports.IntegrationDetailHistoryListView = IntegrationDetailHistoryListView;
exports.IntegrationDetailHistoryListViewItem = IntegrationDetailHistoryListViewItem;
exports.IntegrationDetailHistoryListViewItemActions = IntegrationDetailHistoryListViewItemActions;
exports.IntegrationDetailInfo = IntegrationDetailInfo;
exports.IntegrationExposedURL = IntegrationExposedURL;
exports.ApiProviderReviewOperations = ApiProviderReviewOperations;
exports.ApiProviderReviewOperationsItem = ApiProviderReviewOperationsItem;
exports.ApiProviderSetInfo = ApiProviderSetInfo;
exports.ChoiceCardHeader = ChoiceCardHeader;
exports.ChoiceConfigurationView = ChoiceConfigurationView;
exports.EditorPageCard = EditorPageCard;
exports.PageSectionLoader = PageSectionLoader;
exports.TemplateStepTypeSelector = TemplateStepTypeSelector;
exports.TemplateStepLinters = TemplateStepLinters;
exports.TemplateStepTemplateEditor = TemplateStepTemplateEditor;
exports.DescribeDataShapeForm = DescribeDataShapeForm;
exports.IntegrationEditorActionsListItem = IntegrationEditorActionsListItem;
exports.IntegrationEditorChooseAction = IntegrationEditorChooseAction;
exports.IntegrationEditorConnectionsListItem = IntegrationEditorConnectionsListItem;
exports.IntegrationEditorForm = IntegrationEditorForm;
exports.IntegrationEditorLayout = IntegrationEditorLayout;
exports.IntegrationEditorNothingToConfigure = IntegrationEditorNothingToConfigure;
exports.IntegrationEditorStepsAdderHeader = IntegrationEditorStepsAdderHeader;
exports.IntegrationEditorStepsList = IntegrationEditorStepsList;
exports.IntegrationEditorStepsListItem = IntegrationEditorStepsListItem;
exports.IntegrationEditorWizard = IntegrationEditorWizard;
exports.ImportPageUI = ImportPageUI;
exports.IntegrationDetailMetrics = IntegrationDetailMetrics;
exports.ConditionsBackButtonItem = ConditionsBackButtonItem;
exports.ConditionsDropdown = ConditionsDropdown;
exports.ConditionsDropdownBody = ConditionsDropdownBody;
exports.ConditionsDropdownHeader = ConditionsDropdownHeader;
exports.ConditionsDropdownItem = ConditionsDropdownItem;
exports.IntegrationFlowAddStep = IntegrationFlowAddStep;
exports.IntegrationFlowStep = IntegrationFlowStep;
exports.IntegrationFlowStepDetails = IntegrationFlowStepDetails;
exports.IntegrationFlowStepGeneric = IntegrationFlowStepGeneric;
exports.IntegrationFlowStepWithOverview = IntegrationFlowStepWithOverview;
exports.IntegrationIcon = IntegrationIcon;
exports.IntegrationSaveForm = IntegrationSaveForm;
exports.IntegrationStatus = IntegrationStatus;
exports.IntegrationStatusDetail = IntegrationStatusDetail;
exports.IntegrationStepsHorizontalItem = IntegrationStepsHorizontalItem;
exports.IntegrationStepsHorizontalView = IntegrationStepsHorizontalView;
exports.IntegrationVerticalFlow = IntegrationVerticalFlow;
exports.IntegrationsList = IntegrationsList;
exports.IntegrationsListItem = IntegrationsListItem;
exports.IntegrationsListItemBasic = IntegrationsListItemBasic;
exports.IntegrationsListItemUnreadable = IntegrationsListItemUnreadable;
exports.IntegrationsListSkeleton = IntegrationsListSkeleton;
exports.IntegrationsListView = IntegrationsListView;
exports.OperationsDropdown = OperationsDropdown;
exports.AppBreadcrumb = AppBreadcrumb;
exports.AppLayout = AppLayout;
exports.AppTopMenu = AppTopMenu;
exports.ButtonLink = ButtonLink;
exports.Breadcrumb = Breadcrumb;
exports.Container = Container;
exports.Loader = Loader;
exports.PageLoader = PageLoader;
exports.PfNavLink = PfNavLink;
exports.PfVerticalNavItem = PfVerticalNavItem;
exports.TabBar = TabBar;
exports.TabBarItem = TabBarItem;
exports.WizardStep = WizardStep;
exports.WizardSteps = WizardSteps;
exports.OAuthAppExpanderBody = OAuthAppExpanderBody;
exports.OAuthAppHeader = OAuthAppHeader;
exports.OAuthAppList = OAuthAppList;
exports.OAuthAppListItem = OAuthAppListItem;
exports.OAuthAppListItemView = OAuthAppListItemView;
exports.AboutModal = AboutModal;
exports.AboutModalContent = AboutModalContent;
exports.AggregatedMetricCard = AggregatedMetricCard;
exports.ConfirmationDialog = ConfirmationDialog;
exports.CopyToClipboard = CopyToClipboard;
exports.Dialog = Dialog;
exports.DndFileChooser = DndFileChooser;
exports.DefaultHeaderFormat = DefaultHeaderFormat;
exports.DefaultCellFormat = DefaultCellFormat;
exports.GenericTable = GenericTable;
exports.HelpDropdown = HelpDropdown;
exports.HttpMethodColors = HttpMethodColors;
exports.InlineTextEdit = InlineTextEdit;
exports.ListViewToolbar = ListViewToolbar;
exports.LogViewer = LogViewer;
exports.Notifications = Notifications;
exports.OpenApiReviewActions = OpenApiReviewActions;
exports.OpenApiSelectMethod = OpenApiSelectMethod;
exports.PfDropdownItem = PfDropdownItem;
exports.ProgressWithLink = ProgressWithLink;
exports.SimplePageHeader = SimplePageHeader;
exports.AbstractLanguageLint = AbstractLanguageLint;
exports.TemplateSymbol = TemplateSymbol;
exports.MustacheModeLint = MustacheModeLint;
exports.VelocityLint = VelocityLint;
exports.FreemarkerModeLint = FreemarkerModeLint;
exports.TextEditor = TextEditor;
exports.UnrecoverableError = UnrecoverableError;
exports.WithDropzone = WithDropzone;
exports.IframeWrapper = IframeWrapper;
exports.DownloadDiagnostics = DownloadDiagnostics;
exports.toValidHtmlId = toValidHtmlId;